/* tslint:disable */
/* eslint-disable */
/**
 * omise-craft-core API
 * # Description This is omise-craft-core API. 
 *
 * The version of the OpenAPI document: ${version}
 * Contact: tomohiko.ozawa@sre-group.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdminInteriorDesignOrderSendRequest
 */
export interface AdminInteriorDesignOrderSendRequest {
    /**
     * 送付先の内装会社IDの配列
     * @type {Array<string>}
     * @memberof AdminInteriorDesignOrderSendRequest
     */
    'company_ids': Array<string>;
    /**
     * タイトル
     * @type {string}
     * @memberof AdminInteriorDesignOrderSendRequest
     */
    'title'?: string;
    /**
     * 期限
     * @type {string}
     * @memberof AdminInteriorDesignOrderSendRequest
     */
    'deadlineAt': string;
}
/**
 * 
 * @export
 * @interface AdminInteriorDesignOrderSendResponse
 */
export interface AdminInteriorDesignOrderSendResponse {
    /**
     * 登録（送付対象として記録）された内装会社のID一覧
     * @type {Array<string>}
     * @memberof AdminInteriorDesignOrderSendResponse
     */
    'company_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface AdminInteriorDesignOrderSendingListResponse
 */
export interface AdminInteriorDesignOrderSendingListResponse {
    /**
     * 
     * @type {Array<InteriorDesignCompanyInteriorDesignOrder>}
     * @memberof AdminInteriorDesignOrderSendingListResponse
     */
    'results': Array<InteriorDesignCompanyInteriorDesignOrder>;
    /**
     * フィルタされたの内装会社IDの配列
     * @type {Array<number>}
     * @memberof AdminInteriorDesignOrderSendingListResponse
     */
    'filteredCompanyIds'?: Array<number>;
    /**
     * 選択肢から非活性にする内装会社IDの配列
     * @type {Array<number>}
     * @memberof AdminInteriorDesignOrderSendingListResponse
     */
    'disableCompanyIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface AuthLogin200Response
 */
export interface AuthLogin200Response {
    /**
     * 
     * @type {DefaultResponseBody}
     * @memberof AuthLogin200Response
     */
    'body': DefaultResponseBody;
}
/**
 * 
 * @export
 * @interface AuthLoginForAdmin200Response
 */
export interface AuthLoginForAdmin200Response {
    /**
     * 
     * @type {DefaultResponseBody}
     * @memberof AuthLoginForAdmin200Response
     */
    'body': DefaultResponseBody;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginForAdmin200Response
     */
    'dummy'?: string;
}
/**
 * 簡易損益シミュレーションの設問の全入力項目
 * @export
 * @interface BalanceInput
 */
export interface BalanceInput {
    /**
     * 
     * @type {BalanceInputIndustry}
     * @memberof BalanceInput
     */
    'industry'?: BalanceInputIndustry;
    /**
     * 
     * @type {BalanceInputArea}
     * @memberof BalanceInput
     */
    'area'?: BalanceInputArea;
    /**
     * 
     * @type {BalanceInputBusinessHoursDetails}
     * @memberof BalanceInput
     */
    'business_hours_details'?: BalanceInputBusinessHoursDetails;
    /**
     * 
     * @type {BalanceInputChargePerCustomer}
     * @memberof BalanceInput
     */
    'charge_per_customer'?: BalanceInputChargePerCustomer;
    /**
     * 
     * @type {BalanceInputLaborCost}
     * @memberof BalanceInput
     */
    'labor_cost'?: BalanceInputLaborCost;
    /**
     * 
     * @type {BalanceInputFoodCost}
     * @memberof BalanceInput
     */
    'food_cost'?: BalanceInputFoodCost;
    /**
     * 
     * @type {BalanceInputRent}
     * @memberof BalanceInput
     */
    'rent'?: BalanceInputRent;
    /**
     * 
     * @type {BalanceInputOtherCost}
     * @memberof BalanceInput
     */
    'other_cost'?: BalanceInputOtherCost;
    /**
     * 
     * @type {BalanceInputInitialCost}
     * @memberof BalanceInput
     */
    'initial_cost'?: BalanceInputInitialCost;
}
/**
 * 出店エリア
 * @export
 * @interface BalanceInputArea
 */
export interface BalanceInputArea {
    /**
     * 都道府県
     * @type {number}
     * @memberof BalanceInputArea
     */
    'prefecture_id'?: number;
    /**
     * エリア
     * @type {number}
     * @memberof BalanceInputArea
     */
    'area_id'?: number;
    /**
     * 坪数
     * @type {number}
     * @memberof BalanceInputArea
     */
    'surface_area'?: number;
    /**
     * 席数
     * @type {number}
     * @memberof BalanceInputArea
     */
    'number_of_seats'?: number;
}
/**
 * 営業時間の内容
 * @export
 * @interface BalanceInputBusinessHoursDetails
 */
export interface BalanceInputBusinessHoursDetails {
    /**
     * 週何日
     * @type {number}
     * @memberof BalanceInputBusinessHoursDetails
     */
    'day_a_week'?: number;
    /**
     * 昼の営業時間
     * @type {number}
     * @memberof BalanceInputBusinessHoursDetails
     */
    'daytime_business_hours'?: number;
    /**
     * 夜の営業時間
     * @type {number}
     * @memberof BalanceInputBusinessHoursDetails
     */
    'night_business_hours'?: number;
}
/**
 * 客単価と回転率
 * @export
 * @interface BalanceInputChargePerCustomer
 */
export interface BalanceInputChargePerCustomer {
    /**
     * 昼の客単価
     * @type {number}
     * @memberof BalanceInputChargePerCustomer
     */
    'daytime_charge'?: number;
    /**
     * 昼の客数
     * @type {number}
     * @memberof BalanceInputChargePerCustomer
     */
    'daytime_customer'?: number;
    /**
     * 昼の回転率
     * @type {number}
     * @memberof BalanceInputChargePerCustomer
     */
    'daytime_turnover_rate'?: number;
    /**
     * 夜の客単価
     * @type {number}
     * @memberof BalanceInputChargePerCustomer
     */
    'night_charge'?: number;
    /**
     * 夜の客数
     * @type {number}
     * @memberof BalanceInputChargePerCustomer
     */
    'night_customer'?: number;
    /**
     * 夜の回転率
     * @type {number}
     * @memberof BalanceInputChargePerCustomer
     */
    'night_turnover_rate'?: number;
}
/**
 * 食料原価
 * @export
 * @interface BalanceInputFoodCost
 */
export interface BalanceInputFoodCost {
    /**
     * 食料原価率
     * @type {number}
     * @memberof BalanceInputFoodCost
     */
    'cost_rate'?: number;
}
/**
 * 業種選択
 * @export
 * @interface BalanceInputIndustry
 */
export interface BalanceInputIndustry {
    /**
     * 業態
     * @type {number}
     * @memberof BalanceInputIndustry
     */
    'category'?: number;
}
/**
 * 初期費用
 * @export
 * @interface BalanceInputInitialCost
 */
export interface BalanceInputInitialCost {
    /**
     * 物件取得費
     * @type {number}
     * @memberof BalanceInputInitialCost
     */
    'property_acquisition_cost'?: number;
    /**
     * 内装費
     * @type {number}
     * @memberof BalanceInputInitialCost
     */
    'interior_rate'?: number;
    /**
     * 厨房費
     * @type {number}
     * @memberof BalanceInputInitialCost
     */
    'kitchen_cost'?: number;
}
/**
 * 人件費
 * @export
 * @interface BalanceInputLaborCost
 */
export interface BalanceInputLaborCost {
    /**
     * 総労働時間
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'total_working_hours'?: number;
    /**
     * 社員数
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'count_employee'?: number;
    /**
     * 社員労働時間
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'employee_working_hours'?: number;
    /**
     * 社員給料
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'employee_salary'?: number;
    /**
     * アルバイト人数
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'count_part_time'?: number;
    /**
     * アルバイト時給
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'part_time_hourly_pay'?: number;
    /**
     * アルバイト労働時間
     * @type {number}
     * @memberof BalanceInputLaborCost
     */
    'part_time_working_hours'?: number;
}
/**
 * その他費用
 * @export
 * @interface BalanceInputOtherCost
 */
export interface BalanceInputOtherCost {
    /**
     * 水道光熱費
     * @type {number}
     * @memberof BalanceInputOtherCost
     */
    'water_and_utility_cost'?: number;
    /**
     * その他
     * @type {number}
     * @memberof BalanceInputOtherCost
     */
    'other'?: number;
}
/**
 * 家賃
 * @export
 * @interface BalanceInputRent
 */
export interface BalanceInputRent {
    /**
     * 月額
     * @type {number}
     * @memberof BalanceInputRent
     */
    'monthly_rent'?: number;
    /**
     * 月坪家賃
     * @type {number}
     * @memberof BalanceInputRent
     */
    'monthly_thubo_rent'?: number;
}
/**
 * 
 * @export
 * @interface ChooseDesignMatching200Response
 */
export interface ChooseDesignMatching200Response {
    /**
     * 会員ID
     * @type {number}
     * @memberof ChooseDesignMatching200Response
     */
    'order_id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof ChooseDesignMatching200Response
     */
    'interior_design_company_id'?: number;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus & object}
     * @memberof ChooseDesignMatching200Response
     */
    'status'?: InteriorDesignCompanyInteriorDesignOrderStatus & object;
}
/**
 * 
 * @export
 * @interface ChooseDesignMatchingRequest
 */
export interface ChooseDesignMatchingRequest {
    /**
     * 会員ID
     * @type {number}
     * @memberof ChooseDesignMatchingRequest
     */
    'order_id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof ChooseDesignMatchingRequest
     */
    'interior_design_company_id': number;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus & object}
     * @memberof ChooseDesignMatchingRequest
     */
    'status': InteriorDesignCompanyInteriorDesignOrderStatus & object;
}
/**
 * 設問の全入力項目
 * @export
 * @interface ConceptInput
 */
export interface ConceptInput {
    /**
     * 
     * @type {ConceptInputWhat}
     * @memberof ConceptInput
     */
    'what'?: ConceptInputWhat;
    /**
     * 
     * @type {ConceptInputWho}
     * @memberof ConceptInput
     */
    'who'?: ConceptInputWho;
    /**
     * 
     * @type {ConceptInputWhere}
     * @memberof ConceptInput
     */
    'where'?: ConceptInputWhere;
    /**
     * 
     * @type {ConceptInputWhen}
     * @memberof ConceptInput
     */
    'when'?: ConceptInputWhen;
    /**
     * 
     * @type {ConceptInputHowMuch}
     * @memberof ConceptInput
     */
    'how_much'?: ConceptInputHowMuch;
    /**
     * 
     * @type {ConceptInputHow}
     * @memberof ConceptInput
     */
    'how'?: ConceptInputHow;
    /**
     * 
     * @type {ConceptInputWhom}
     * @memberof ConceptInput
     */
    'whom'?: ConceptInputWhom;
    /**
     * 
     * @type {ConceptInputWhy}
     * @memberof ConceptInput
     */
    'why'?: ConceptInputWhy;
    /**
     * 店舗コンセプト
     * @type {string}
     * @memberof ConceptInput
     */
    'concept'?: string;
    /**
     * 開業当初売り上げ目標
     * @type {number}
     * @memberof ConceptInput
     */
    'sales_target'?: number;
}
/**
 * How (どのように) 入力・選択項目
 * @export
 * @interface ConceptInputHow
 */
export interface ConceptInputHow {
    /**
     * How (どのように) 提供方法リスト
     * @type {Array<number>}
     * @memberof ConceptInputHow
     */
    'providing_methods'?: Array<number>;
    /**
     * How (どのように) 提供方法その他
     * @type {string}
     * @memberof ConceptInputHow
     */
    'providing_method_other'?: string;
    /**
     * How (どのように) 空間イメージ
     * @type {number}
     * @memberof ConceptInputHow
     */
    'spatial_image'?: number;
    /**
     * How (どのように) 空間イメージその他
     * @type {string}
     * @memberof ConceptInputHow
     */
    'spatial_image_other'?: string;
    /**
     * How (どのように) こだわり
     * @type {string}
     * @memberof ConceptInputHow
     */
    'commitment'?: string;
}
/**
 * How Much (いくらで) 入力・選択項目
 * @export
 * @interface ConceptInputHowMuch
 */
export interface ConceptInputHowMuch {
    /**
     * How Much (いくらで) 客単価朝
     * @type {number}
     * @memberof ConceptInputHowMuch
     */
    'at_morning'?: number;
    /**
     * How Much (いくらで) 客単価昼
     * @type {number}
     * @memberof ConceptInputHowMuch
     */
    'at_noon'?: number;
    /**
     * How Much (いくらで) 客単価夜
     * @type {number}
     * @memberof ConceptInputHowMuch
     */
    'at_night'?: number;
    /**
     * How Much (いくらで) 客単価深夜
     * @type {number}
     * @memberof ConceptInputHowMuch
     */
    'at_midnight'?: number;
    /**
     * How Much (いくらで) 価格特徴
     * @type {string}
     * @memberof ConceptInputHowMuch
     */
    'price_feature'?: string;
}
/**
 * What (何を) 入力・選択項目
 * @export
 * @interface ConceptInputWhat
 */
export interface ConceptInputWhat {
    /**
     * What (何を) 業種
     * @type {number}
     * @memberof ConceptInputWhat
     */
    'industry'?: number;
    /**
     * What (何を) メインメニューその他
     * @type {string}
     * @memberof ConceptInputWhat
     */
    'main_menu'?: string;
    /**
     * What (何を) メインメニュー特徴
     * @type {string}
     * @memberof ConceptInputWhat
     */
    'main_menu_feature'?: string;
}
/**
 * When (いつ) 入力・選択項目
 * @export
 * @interface ConceptInputWhen
 */
export interface ConceptInputWhen {
    /**
     * When (いつ) 平日昼営業開始時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_weekday_day_start_time'?: number;
    /**
     * When (いつ) 平日昼営業終了時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_weekday_day_end_time'?: number;
    /**
     * When (いつ) 平日夜営業開始時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_weekday_night_start_time'?: number;
    /**
     * When (いつ) 平日夜営業終了時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_weekday_night_end_time'?: number;
    /**
     * When (いつ) 休日昼営業開始時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_holiday_day_start_time'?: number;
    /**
     * When (いつ) 休日昼営業終了時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_holiday_day_end_time'?: number;
    /**
     * When (いつ) 休日夜営業開始時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_holiday_night_start_time'?: number;
    /**
     * When (いつ) 休日夜営業終了時間
     * @type {number}
     * @memberof ConceptInputWhen
     */
    'business_holiday_night_end_time'?: number;
    /**
     * When (いつ) business_times
     * @type {Array<number>}
     * @memberof ConceptInputWhen
     */
    'business_times'?: Array<number>;
    /**
     * When (いつ) 定休日リスト
     * @type {Array<number>}
     * @memberof ConceptInputWhen
     */
    'regular_holidays'?: Array<number>;
}
/**
 * Where (どこで) 入力・選択項目
 * @export
 * @interface ConceptInputWhere
 */
export interface ConceptInputWhere {
    /**
     * Where (どこで) エリア特徴リスト
     * @type {Array<number>}
     * @memberof ConceptInputWhere
     */
    'area_features'?: Array<number>;
    /**
     * Where (どこで) エリア特徴その他
     * @type {string}
     * @memberof ConceptInputWhere
     */
    'area_feature_other'?: string;
    /**
     * Where (どこで) 坪数リスト
     * @type {Array<number>}
     * @memberof ConceptInputWhere
     */
    'tsubos'?: Array<number>;
    /**
     * Where (どこで) 席数リスト
     * @type {Array<number>}
     * @memberof ConceptInputWhere
     */
    'seats'?: Array<number>;
}
/**
 * Who (誰に) 入力・選択項目
 * @export
 * @interface ConceptInputWho
 */
export interface ConceptInputWho {
    /**
     * 
     * @type {WhoInputDetail}
     * @memberof ConceptInputWho
     */
    'day_time'?: WhoInputDetail;
    /**
     * 
     * @type {WhoInputDetail}
     * @memberof ConceptInputWho
     */
    'night_time'?: WhoInputDetail;
}
/**
 * Whom (誰が) 入力・選択項目
 * @export
 * @interface ConceptInputWhom
 */
export interface ConceptInputWhom {
    /**
     * あなたが持っているスキル
     * @type {string}
     * @memberof ConceptInputWhom
     */
    'have_skill'?: string;
    /**
     * あなたが持っていない店舗運営に必要なスキル
     * @type {string}
     * @memberof ConceptInputWhom
     */
    'not_have_skill'?: string;
    /**
     * あなたのお店に求める従業員像
     * @type {string}
     * @memberof ConceptInputWhom
     */
    'ideal_employee'?: string;
}
/**
 * Why (なぜ) 入力・選択項目
 * @export
 * @interface ConceptInputWhy
 */
export interface ConceptInputWhy {
    /**
     * Why (なぜ) 創業目的・動機
     * @type {string}
     * @memberof ConceptInputWhy
     */
    'purpose'?: string;
}
/**
 * 
 * @export
 * @interface ConstructionCaseImages
 */
export interface ConstructionCaseImages {
    /**
     * ID
     * @type {number}
     * @memberof ConstructionCaseImages
     */
    'id'?: number;
    /**
     * 事例ID
     * @type {number}
     * @memberof ConstructionCaseImages
     */
    'construction_case_id'?: number;
    /**
     * 事例画像URL
     * @type {string}
     * @memberof ConstructionCaseImages
     */
    'image_url'?: string;
}
/**
 * 
 * @export
 * @interface ConstructionCasesRequestBodyInner
 */
export interface ConstructionCasesRequestBodyInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'id'?: number;
    /**
     * 内装会社ID
     * @type {number}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'interior_design_company_id': number;
    /**
     * 業態（例カフェ、居酒屋など）
     * @type {string}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'category'?: string;
    /**
     * 面積（坪）decimal(10,2)
     * @type {number}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'area_tsubo'?: number;
    /**
     * 完工年
     * @type {string}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'completion_year'?: string;
    /**
     * 席数
     * @type {number}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'seat_count'?: number;
    /**
     * こだわりポイント
     * @type {string}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'focus_points'?: string;
    /**
     * 工事費用
     * @type {number}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'construction_cost'?: number;
    /**
     * 
     * @type {Array<UploadConstructionCaseImage>}
     * @memberof ConstructionCasesRequestBodyInner
     */
    'images'?: Array<UploadConstructionCaseImage>;
}
/**
 * 
 * @export
 * @interface Contact200Response
 */
export interface Contact200Response {
    /**
     * 
     * @type {Contact200ResponseBody}
     * @memberof Contact200Response
     */
    'body': Contact200ResponseBody;
}
/**
 * 
 * @export
 * @interface Contact200ResponseBody
 */
export interface Contact200ResponseBody {
    /**
     * 問合せ種別
     * @type {number}
     * @memberof Contact200ResponseBody
     */
    'type': number;
    /**
     * 会員ID
     * @type {number}
     * @memberof Contact200ResponseBody
     */
    'member_id'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'company_name'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'name': string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'post_number'?: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'prefecture'?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'city'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'street_address'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'building'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'email'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'phone_number'?: string;
    /**
     * 問合せ内容
     * @type {string}
     * @memberof Contact200ResponseBody
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof Contact200ResponseBody
     */
    'dummy_for_contact_response'?: number;
}
/**
 * 
 * @export
 * @interface ContactRequest
 */
export interface ContactRequest {
    /**
     * 問合せ種別
     * @type {number}
     * @memberof ContactRequest
     */
    'type': number;
    /**
     * 会員ID
     * @type {number}
     * @memberof ContactRequest
     */
    'member_id'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof ContactRequest
     */
    'company_name'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof ContactRequest
     */
    'name': string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof ContactRequest
     */
    'post_number'?: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof ContactRequest
     */
    'prefecture'?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof ContactRequest
     */
    'city'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof ContactRequest
     */
    'street_address'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof ContactRequest
     */
    'building'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof ContactRequest
     */
    'email'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof ContactRequest
     */
    'phone_number'?: string;
    /**
     * 問合せ内容
     * @type {string}
     * @memberof ContactRequest
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateFavoriteProperty200Response
 */
export interface CreateFavoriteProperty200Response {
    /**
     * 
     * @type {CreateFavoriteProperty200ResponseBody}
     * @memberof CreateFavoriteProperty200Response
     */
    'body': CreateFavoriteProperty200ResponseBody;
}
/**
 * 
 * @export
 * @interface CreateFavoriteProperty200ResponseBody
 */
export interface CreateFavoriteProperty200ResponseBody {
    /**
     * お気に入り物件ID
     * @type {number}
     * @memberof CreateFavoriteProperty200ResponseBody
     */
    'id': number;
    /**
     * 物件ID
     * @type {number}
     * @memberof CreateFavoriteProperty200ResponseBody
     */
    'property_id': number;
    /**
     * 問合せフラグ
     * @type {boolean}
     * @memberof CreateFavoriteProperty200ResponseBody
     */
    'inquiry_flg': boolean;
}
/**
 * 
 * @export
 * @interface CreateFavoritePropertyRequest
 */
export interface CreateFavoritePropertyRequest {
    /**
     * 物件ID
     * @type {number}
     * @memberof CreateFavoritePropertyRequest
     */
    'property_id': number;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateDesignPattern200Response
 */
export interface CreateOrUpdateDesignPattern200Response {
    /**
     * 
     * @type {CreateOrUpdateDesignPattern200ResponseBody}
     * @memberof CreateOrUpdateDesignPattern200Response
     */
    'body': CreateOrUpdateDesignPattern200ResponseBody;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateDesignPattern200ResponseBody
 */
export interface CreateOrUpdateDesignPattern200ResponseBody {
    /**
     * 内装会社マッチングID
     * @type {number}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'id': number;
    /**
     * 種別
     * @type {string}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'class': string;
    /**
     * 名前
     * @type {string}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'name': string;
    /**
     * 説明
     * @type {string}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'description'?: string;
    /**
     * 公開・非公開
     * @type {boolean}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'open_flg': boolean;
    /**
     * 
     * @type {GetDesignPatternForAdmin200ResponseBodyThumbnail}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'thumbnail'?: GetDesignPatternForAdmin200ResponseBodyThumbnail;
    /**
     * 
     * @type {Array<GetDesignPatternForAdmin200ResponseBodyOtherImagesInner>}
     * @memberof CreateOrUpdateDesignPattern200ResponseBody
     */
    'other_images'?: Array<GetDesignPatternForAdmin200ResponseBodyOtherImagesInner>;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateDesignPatternRequest
 */
export interface CreateOrUpdateDesignPatternRequest {
    /**
     * 内装会社マッチングID
     * @type {number}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    'id': number;
    /**
     * 種別
     * @type {string}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    'class': string;
    /**
     * 名前
     * @type {string}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    'name': string;
    /**
     * 説明
     * @type {string}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    'description'?: string;
    /**
     * 公開・非公開
     * @type {boolean}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    'open_flg': boolean;
    /**
     * URL
     * @type {string}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    's3_thumbnail_path'?: string;
    /**
     * 
     * @type {Array<DesignPatternImageFiles>}
     * @memberof CreateOrUpdateDesignPatternRequest
     */
    'files'?: Array<DesignPatternImageFiles>;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateTodo200Response
 */
export interface CreateOrUpdateTodo200Response {
    /**
     * 
     * @type {CreateOrUpdateTodo200ResponseBody}
     * @memberof CreateOrUpdateTodo200Response
     */
    'body': CreateOrUpdateTodo200ResponseBody;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateTodo200ResponseBody
 */
export interface CreateOrUpdateTodo200ResponseBody {
    /**
     * チェック
     * @type {boolean}
     * @memberof CreateOrUpdateTodo200ResponseBody
     */
    'check_flg': boolean;
    /**
     * メモ
     * @type {string}
     * @memberof CreateOrUpdateTodo200ResponseBody
     */
    'memo'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateTodo200ResponseBody
     */
    'dummy_for_todo_create_or_update_response'?: number;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateTodoRequest
 */
export interface CreateOrUpdateTodoRequest {
    /**
     * チェック
     * @type {boolean}
     * @memberof CreateOrUpdateTodoRequest
     */
    'check_flg': boolean;
    /**
     * メモ
     * @type {string}
     * @memberof CreateOrUpdateTodoRequest
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface CreatePasswordReset200Response
 */
export interface CreatePasswordReset200Response {
    /**
     * 
     * @type {object}
     * @memberof CreatePasswordReset200Response
     */
    'body': object;
}
/**
 * 
 * @export
 * @interface CreatePasswordResetRequest
 */
export interface CreatePasswordResetRequest {
    /**
     * メールアドレス
     * @type {string}
     * @memberof CreatePasswordResetRequest
     */
    'email': string;
    /**
     * 管理者かどうか
     * @type {boolean}
     * @memberof CreatePasswordResetRequest
     */
    'isAdmin'?: boolean;
}
/**
 * 成功レスポンス
 * @export
 * @interface CreateRegistrationTemp200Response
 */
export interface CreateRegistrationTemp200Response {
    /**
     * 
     * @type {object}
     * @memberof CreateRegistrationTemp200Response
     */
    'body': object;
}
/**
 * 
 * @export
 * @interface CreateUser200Response
 */
export interface CreateUser200Response {
    /**
     * ユーザID
     * @type {number}
     * @memberof CreateUser200Response
     */
    'id': number;
    /**
     * Cognito ID
     * @type {string}
     * @memberof CreateUser200Response
     */
    'congito_id'?: string;
    /**
     * ニックネーム
     * @type {string}
     * @memberof CreateUser200Response
     */
    'nick_name': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof CreateUser200Response
     */
    'email': string;
    /**
     * 生年月日
     * @type {string}
     * @memberof CreateUser200Response
     */
    'birthday': string;
    /**
     * 性別
     * @type {number}
     * @memberof CreateUser200Response
     */
    'gender': number;
    /**
     * 飲食店経験有無
     * @type {number}
     * @memberof CreateUser200Response
     */
    'diner_experience'?: number;
    /**
     * 開業資金額
     * @type {number}
     * @memberof CreateUser200Response
     */
    'openingFunds'?: number;
    /**
     * 開業状況
     * @type {string}
     * @memberof CreateUser200Response
     */
    'openingStatus'?: string;
    /**
     * 自己資金額
     * @type {number}
     * @memberof CreateUser200Response
     */
    'ownFunds'?: number;
    /**
     * 開業予定業種
     * @type {number}
     * @memberof CreateUser200Response
     */
    'openingIndustryType'?: number;
    /**
     * 既存店数
     * @type {number}
     * @memberof CreateUser200Response
     */
    'existingStoreCount'?: number;
    /**
     * 開業予定エリア（都道府県）
     * @type {number}
     * @memberof CreateUser200Response
     */
    'openingPrefecture'?: number;
    /**
     * QualifiedRank
     * @type {number}
     * @memberof CreateUser200Response
     */
    'qualifiedRank'?: number;
    /**
     * 開業予定者フラグ
     * @type {boolean}
     * @memberof CreateUser200Response
     */
    'willOpenFlg'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 認証コード
     * @type {string}
     * @memberof CreateUserRequest
     */
    'checksum': string;
    /**
     * メール配信フラグ
     * @type {boolean}
     * @memberof CreateUserRequest
     */
    'mailCheck'?: boolean;
    /**
     * ニックネーム
     * @type {string}
     * @memberof CreateUserRequest
     */
    'nick_name': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof CreateUserRequest
     */
    'email': string;
    /**
     * パスワード
     * @type {string}
     * @memberof CreateUserRequest
     */
    'password': string;
    /**
     * 生年月日
     * @type {string}
     * @memberof CreateUserRequest
     */
    'birthday': string;
    /**
     * 性別
     * @type {number}
     * @memberof CreateUserRequest
     */
    'gender': number;
    /**
     * 飲食店経験有無
     * @type {number}
     * @memberof CreateUserRequest
     */
    'diner_experience'?: number;
    /**
     * 飲食店経験有種別リスト
     * @type {Array<number>}
     * @memberof CreateUserRequest
     */
    'diner_exp_type'?: Array<number>;
    /**
     * 出店予定時期
     * @type {number}
     * @memberof CreateUserRequest
     */
    'opn_sched_time'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof CreateUserRequest
     */
    'companyName'?: string;
    /**
     * 開業資金額
     * @type {number}
     * @memberof CreateUserRequest
     */
    'openingFunds'?: number;
    /**
     * 開業状況
     * @type {string}
     * @memberof CreateUserRequest
     */
    'openingStatus'?: string;
    /**
     * 自己資金額
     * @type {number}
     * @memberof CreateUserRequest
     */
    'ownFunds'?: number;
    /**
     * 開業予定業種
     * @type {number}
     * @memberof CreateUserRequest
     */
    'openingIndustryType'?: number;
    /**
     * 既存店数
     * @type {number}
     * @memberof CreateUserRequest
     */
    'existingStoreCount'?: number;
    /**
     * 開業予定エリア（都道府県）
     * @type {number}
     * @memberof CreateUserRequest
     */
    'openingPrefecture'?: number;
    /**
     * 電話番号
     * @type {string}
     * @memberof CreateUserRequest
     */
    'phoneNumber'?: string;
    /**
     * 開業予定者フラグ
     * @type {boolean}
     * @memberof CreateUserRequest
     */
    'willOpenFlg'?: boolean;
    /**
     * 事業形態
     * @type {number}
     * @memberof CreateUserRequest
     */
    'businessType'?: number;
    /**
     * 店舗数
     * @type {number}
     * @memberof CreateUserRequest
     */
    'storeCount'?: number;
    /**
     * 利用中システム
     * @type {string}
     * @memberof CreateUserRequest
     */
    'usedSystem'?: string;
    /**
     * 悩み事
     * @type {string}
     * @memberof CreateUserRequest
     */
    'concern'?: string;
    /**
     * 将来の展望
     * @type {string}
     * @memberof CreateUserRequest
     */
    'futureVision'?: string;
    /**
     * 苗字
     * @type {string}
     * @memberof CreateUserRequest
     */
    'familyName'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof CreateUserRequest
     */
    'firstName'?: string;
    /**
     * 苗字カナ
     * @type {string}
     * @memberof CreateUserRequest
     */
    'familyNameKana'?: string;
    /**
     * 名前カナ
     * @type {string}
     * @memberof CreateUserRequest
     */
    'firstNameKana'?: string;
}
/**
 * デフォルトレスポンスボディ
 * @export
 * @interface DefaultResponseBody
 */
export interface DefaultResponseBody {
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseBody
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DeleteDesignPattern200Response
 */
export interface DeleteDesignPattern200Response {
    /**
     * 
     * @type {DeleteDesignPattern200ResponseBody}
     * @memberof DeleteDesignPattern200Response
     */
    'body': DeleteDesignPattern200ResponseBody;
}
/**
 * 
 * @export
 * @interface DeleteDesignPattern200ResponseBody
 */
export interface DeleteDesignPattern200ResponseBody {
    /**
     * 内装会社マッチングID
     * @type {number}
     * @memberof DeleteDesignPattern200ResponseBody
     */
    'id': number;
}
/**
 * 成功レスポンス
 * @export
 * @interface DeleteFavoriteProperty200Response
 */
export interface DeleteFavoriteProperty200Response {
    /**
     * 
     * @type {DeleteFavoriteProperty200ResponseBody}
     * @memberof DeleteFavoriteProperty200Response
     */
    'body': DeleteFavoriteProperty200ResponseBody;
}
/**
 * 
 * @export
 * @interface DeleteFavoriteProperty200ResponseBody
 */
export interface DeleteFavoriteProperty200ResponseBody {
    /**
     * お気に入り物件ID
     * @type {number}
     * @memberof DeleteFavoriteProperty200ResponseBody
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface DeleteUserRequest
 */
export interface DeleteUserRequest {
    /**
     * 退会理由
     * @type {number}
     * @memberof DeleteUserRequest
     */
    'reason'?: number;
    /**
     * 退会理由(任意入力)
     * @type {string}
     * @memberof DeleteUserRequest
     */
    'free_input'?: string;
    /**
     * 満足度
     * @type {number}
     * @memberof DeleteUserRequest
     */
    'satisfaction_level'?: number;
    /**
     * 満足度の理由
     * @type {string}
     * @memberof DeleteUserRequest
     */
    'satisssfaction_reason'?: string;
}
/**
 * 内装会社マッチング画像
 * @export
 * @interface DesignPatternImageFiles
 */
export interface DesignPatternImageFiles {
    /**
     * S3キー
     * @type {string}
     * @memberof DesignPatternImageFiles
     */
    'S3Key'?: string;
    /**
     * URL
     * @type {string}
     * @memberof DesignPatternImageFiles
     */
    'Url'?: string;
    /**
     * 種類 * `0`: サムネイル * `1`: その他
     * @type {number}
     * @memberof DesignPatternImageFiles
     */
    'Type'?: DesignPatternImageFilesTypeEnum;
    /**
     * ファイル名
     * @type {string}
     * @memberof DesignPatternImageFiles
     */
    'Filename'?: string;
    /**
     * base64ファイルデータ
     * @type {string}
     * @memberof DesignPatternImageFiles
     */
    'Payload'?: string;
    /**
     * 順序
     * @type {number}
     * @memberof DesignPatternImageFiles
     */
    'Order'?: number;
    /**
     * コメント
     * @type {string}
     * @memberof DesignPatternImageFiles
     */
    'Comment'?: string;
}

export const DesignPatternImageFilesTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type DesignPatternImageFilesTypeEnum = typeof DesignPatternImageFilesTypeEnum[keyof typeof DesignPatternImageFilesTypeEnum];

/**
 * 
 * @export
 * @interface DesignPatternInquiry
 */
export interface DesignPatternInquiry {
    /**
     * 苗字
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'family_name'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'first_name'?: string;
    /**
     * フリガナ苗字
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'family_name_kana'?: string;
    /**
     * フリガナ名前
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'first_name_kana'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'phone_number'?: string;
    /**
     * 業態(m_option)
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'category'?: number;
    /**
     * 開業予定日
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'open_day'?: string;
    /**
     * 開業予定地域
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'open_area'?: string;
    /**
     * 予算
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'budget'?: number;
    /**
     * 物件契約状況
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'property_contract_status'?: number;
    /**
     * 物件の状態
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'property_condition'?: number;
    /**
     * 業種詳細
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'business_detail'?: string;
    /**
     * 物件広さ
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'property_surface'?: string;
    /**
     * 物件備考
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'property_remark'?: string;
    /**
     * 厨房機器
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'equipment'?: number;
    /**
     * 融資の予定
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'financing'?: number;
    /**
     * 内装イメージ
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'interior_image'?: string;
    /**
     * 法人or個人
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'contract_type'?: number;
    /**
     * 出店経験
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'experience'?: number;
    /**
     * 経歴
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'career'?: string;
    /**
     * ご要望
     * @type {string}
     * @memberof DesignPatternInquiry
     */
    'request'?: string;
    /**
     * 面積以上
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'sizeFrom'?: number;
    /**
     * 面積以下
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'sizeTo'?: number;
    /**
     * 賃料以上
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'rentFrom'?: number;
    /**
     * 賃料以下
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'rentTo'?: number;
    /**
     * 階数
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'floor'?: number;
    /**
     * 最寄り駅までの徒歩時間
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'access'?: number;
    /**
     * 開業資金額
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'openingFunds'?: number;
    /**
     * 自己資金額
     * @type {number}
     * @memberof DesignPatternInquiry
     */
    'ownFunds'?: number;
    /**
     * 物件選定サポートProフラグ
     * @type {boolean}
     * @memberof DesignPatternInquiry
     */
    'supportInquiryFlg'?: boolean;
}
/**
 * 
 * @export
 * @interface DesignPatternRequestRequest
 */
export interface DesignPatternRequestRequest {
    /**
     * 苗字
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'family_name'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'first_name'?: string;
    /**
     * フリガナ苗字
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'family_name_kana'?: string;
    /**
     * フリガナ名前
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'first_name_kana'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'phone_number'?: string;
    /**
     * 業態(m_option)
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'category': number;
    /**
     * 開業予定日
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'open_day'?: string;
    /**
     * 開業予定地域
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'open_area': string;
    /**
     * 予算
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'budget': number;
    /**
     * 物件契約状況
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'property_contract_status': number;
    /**
     * 物件の状態
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'property_condition'?: number;
    /**
     * 業種詳細
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'business_detail'?: string;
    /**
     * 物件広さ
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'property_surface'?: string;
    /**
     * 物件備考
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'property_remark'?: string;
    /**
     * 厨房機器
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'equipment'?: number;
    /**
     * 融資の予定
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'financing'?: number;
    /**
     * 内装イメージ
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'interior_image'?: string;
    /**
     * 法人or個人
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'contract_type'?: number;
    /**
     * 出店経験
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'experience'?: number;
    /**
     * 経歴
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'career'?: string;
    /**
     * ご要望
     * @type {string}
     * @memberof DesignPatternRequestRequest
     */
    'request'?: string;
    /**
     * 面積以上
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'sizeFrom': number;
    /**
     * 面積以下
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'sizeTo': number;
    /**
     * 賃料以上
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'rentFrom': number;
    /**
     * 賃料以下
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'rentTo': number;
    /**
     * 階数
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'floor': number;
    /**
     * 最寄り駅までの徒歩時間
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'access': number;
    /**
     * 開業資金額
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'openingFunds': number;
    /**
     * 自己資金額
     * @type {number}
     * @memberof DesignPatternRequestRequest
     */
    'ownFunds': number;
    /**
     * 物件選定サポートProフラグ
     * @type {boolean}
     * @memberof DesignPatternRequestRequest
     */
    'supportInquiryFlg': boolean;
}
/**
 * Dummyスキーマ
 * @export
 * @interface Dummy
 */
export interface Dummy {
    /**
     * dummy Id
     * @type {number}
     * @memberof Dummy
     */
    'id'?: number;
    /**
     * 
     * @type {PrefectureEnum}
     * @memberof Dummy
     */
    'status'?: PrefectureEnum;
}


/**
 * エラー
 * @export
 * @interface ErrorItem
 */
export interface ErrorItem {
    /**
     * ID
     * @type {string}
     * @memberof ErrorItem
     */
    'id': string;
    /**
     * コード
     * @type {string}
     * @memberof ErrorItem
     */
    'code': string;
    /**
     * メッセージ
     * @type {string}
     * @memberof ErrorItem
     */
    'message': string;
    /**
     * エラープロパティ
     * @type {string}
     * @memberof ErrorItem
     */
    'caused_by'?: string;
}
/**
 * エラーリスト
 * @export
 * @interface Errors
 */
export interface Errors {
    /**
     * 
     * @type {Array<ErrorItem>}
     * @memberof Errors
     */
    'errors': Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetBalance200Response
 */
export interface GetBalance200Response {
    /**
     * 
     * @type {GetBalance200ResponseBody}
     * @memberof GetBalance200Response
     */
    'body': GetBalance200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetBalance200ResponseBody
 */
export interface GetBalance200ResponseBody {
    /**
     * Cognito ID
     * @type {string}
     * @memberof GetBalance200ResponseBody
     */
    'member_id'?: string;
    /**
     * 
     * @type {BalanceInput}
     * @memberof GetBalance200ResponseBody
     */
    'input_json'?: BalanceInput;
    /**
     * 営業利益
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'operating_income'?: number;
    /**
     * 売上
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'total_sales'?: number;
    /**
     * 昼売上
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'daytime_sales'?: number;
    /**
     * 昼客数
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'daytime_customers'?: number;
    /**
     * 夜売上
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'night_sales'?: number;
    /**
     * 昼客数
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'night_customers'?: number;
    /**
     * 経費
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'cost'?: number;
    /**
     * F(原価率)
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'food_cost_rate'?: number;
    /**
     * L(人件費)
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'labor_cost'?: number;
    /**
     * L(人件費率)
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'labor_cost_rate'?: number;
    /**
     * R(家賃比率)
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'rent_rate'?: number;
    /**
     * R(家賃)
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'rent'?: number;
    /**
     * 初期費用合計
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'total_initial_cost'?: number;
    /**
     * 物件取得費
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'property_acquisition_cost'?: number;
    /**
     * 内装費
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'interior_cost'?: number;
    /**
     * 厨房設備費
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'kitchen_equipment_cost'?: number;
    /**
     * その他設備費
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'other_equipment_cost'?: number;
    /**
     * 運営費
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'operating_cost'?: number;
    /**
     * 投資回収期間
     * @type {number}
     * @memberof GetBalance200ResponseBody
     */
    'payback_period'?: number;
    /**
     * 投資回収期間
     * @type {string}
     * @memberof GetBalance200ResponseBody
     */
    'payback_period_message'?: string;
}
/**
 * 
 * @export
 * @interface GetConcept200Response
 */
export interface GetConcept200Response {
    /**
     * 
     * @type {GetConcept200ResponseBody}
     * @memberof GetConcept200Response
     */
    'body': GetConcept200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetConcept200ResponseBody
 */
export interface GetConcept200ResponseBody {
    /**
     * Cognito ID
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'member_id': string;
    /**
     * 
     * @type {ConceptInput}
     * @memberof GetConcept200ResponseBody
     */
    'input_json'?: ConceptInput;
    /**
     * 店舗コンセプト作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'concept'?: string;
    /**
     * What (何を) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'what_detail'?: string;
    /**
     * Who (誰に) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'who_detail'?: string;
    /**
     * Where (どこで) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'where_detail'?: string;
    /**
     * When (いつ) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'when_detail'?: string;
    /**
     * How Much (いくらで) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'how_much_detail'?: string;
    /**
     * How (どのように) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'how_detail'?: string;
    /**
     * Whom (誰が) 作成文言
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'whom_detail'?: string;
    /**
     * Why (なぜ)
     * @type {string}
     * @memberof GetConcept200ResponseBody
     */
    'why_detail'?: string;
    /**
     * 完了情報
     * @type {boolean}
     * @memberof GetConcept200ResponseBody
     */
    'complete'?: boolean;
}
/**
 * 
 * @export
 * @interface GetConstructionCases200ResponseInner
 */
export interface GetConstructionCases200ResponseInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetConstructionCases200ResponseInner
     */
    'id'?: number;
    /**
     * 内装会社ID
     * @type {number}
     * @memberof GetConstructionCases200ResponseInner
     */
    'interior_design_company_id'?: number;
    /**
     * 業態（例カフェ、居酒屋など）
     * @type {string}
     * @memberof GetConstructionCases200ResponseInner
     */
    'category'?: string;
    /**
     * 面積（坪）decimal(10,2)
     * @type {number}
     * @memberof GetConstructionCases200ResponseInner
     */
    'area_tsubo'?: number;
    /**
     * 完工年
     * @type {string}
     * @memberof GetConstructionCases200ResponseInner
     */
    'completion_year'?: string;
    /**
     * 席数
     * @type {number}
     * @memberof GetConstructionCases200ResponseInner
     */
    'seat_count'?: number;
    /**
     * 工事費用
     * @type {number}
     * @memberof GetConstructionCases200ResponseInner
     */
    'construction_cost'?: number;
    /**
     * こだわりポイント
     * @type {string}
     * @memberof GetConstructionCases200ResponseInner
     */
    'focus_points'?: string;
    /**
     * 
     * @type {Array<ConstructionCaseImages>}
     * @memberof GetConstructionCases200ResponseInner
     */
    'images'?: Array<ConstructionCaseImages>;
}
/**
 * 
 * @export
 * @interface GetDesignInteriorDesignOrder200Response
 */
export interface GetDesignInteriorDesignOrder200Response {
    /**
     * 
     * @type {GetDesignInteriorDesignOrder200ResponseItem}
     * @memberof GetDesignInteriorDesignOrder200Response
     */
    'item': GetDesignInteriorDesignOrder200ResponseItem;
}
/**
 * 
 * @export
 * @interface GetDesignInteriorDesignOrder200ResponseItem
 */
export interface GetDesignInteriorDesignOrder200ResponseItem {
    /**
     * ID
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'memberId'?: number;
    /**
     * 伴走者オペレーターID
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'operatorId'?: number;
    /**
     * タイトル
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'title'?: string;
    /**
     * 業態
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'category'?: string;
    /**
     * 出店予定時期
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'storeOpeningPeriod'?: string;
    /**
     * 出店予定地
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'storeOpeningLocation'?: string;
    /**
     * 都道府県
     * @type {Array<MPrefecture>}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'prefecture'?: Array<MPrefecture>;
    /**
     * 面積（坪）from
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'areaTsuboFrom'?: number;
    /**
     * 面積（坪）to
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'areaTsuboTo'?: number;
    /**
     * 
     * @type {InteriorDesignOrderStatus}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'status'?: InteriorDesignOrderStatus;
    /**
     * 
     * @type {InteriorDesignOrderPropertyStatus}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'propertyStatus'?: InteriorDesignOrderPropertyStatus;
    /**
     * 
     * @type {InteriorDesignOrderPropertyCondition}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'propertyCondition'?: InteriorDesignOrderPropertyCondition;
    /**
     * 
     * @type {InteriorDesignOrderRequestType}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'requestType'?: InteriorDesignOrderRequestType;
    /**
     * 内装費予算
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'budgetAmount'?: number;
    /**
     * 
     * @type {InteriorDesignOrderBusinessType}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientBusinessType'?: InteriorDesignOrderBusinessType;
    /**
     * 依頼主の要望
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientRequest'?: string;
    /**
     * ご経歴
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientCareer'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientEmailAddress'?: string;
    /**
     * 氏名
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientName'?: string;
    /**
     * フリガナ
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientKana'?: string;
    /**
     * 
     * @type {InteriorDesignOrderClientAgeRange}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientAgeRange'?: InteriorDesignOrderClientAgeRange;
    /**
     * 
     * @type {InteriorDesignOrderClientGender}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientGender'?: InteriorDesignOrderClientGender;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientPhoneNumber'?: string;
    /**
     * 顧客会社名
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'clientCompanyName'?: string;
    /**
     * 
     * @type {InteriorDesignOrderLoanStatus}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'loanStatus'?: InteriorDesignOrderLoanStatus;
    /**
     * 案件依頼日
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'requestedAt'?: string;
    /**
     * 期限
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'deadlineAt'?: string;
    /**
     * 案件送付日
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'sentAt'?: string;
    /**
     * 既存店舗数
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'existingStoreCount'?: number;
    /**
     * 開業総予算（万円）
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'openingFundsMillionYen'?: number;
    /**
     * 内装会社向け共有事項
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'interiorCompanySharedNote'?: string;
    /**
     * システム備考
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'systemNote'?: string;
    /**
     * 備考
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'note'?: string;
    /**
     * 内装会社向け共有事項
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'interiorCompanyNote'?: string;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'delete_flg'?: boolean;
    /**
     * 
     * @type {InteriorDesignOrderDropReason}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'dropReason'?: InteriorDesignOrderDropReason;
    /**
     * エントリー数（ENTRY_IN_PROGRESS 件数）
     * @type {number}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'entryCount'?: number;
    /**
     * マッチング済み内装会社一覧
     * @type {Array<InteriorDesignMatchedCompany>}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'matchedCompanies'?: Array<InteriorDesignMatchedCompany>;
    /**
     * ステータスの更新履歴
     * @type {Array<string>}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'propertyStatusHistory'?: Array<string>;
    /**
     * メンバーが削除済みか否か
     * @type {boolean}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'isMemberDeleted'?: boolean;
    /**
     * マッチング日
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'matchedAt'?: string;
    /**
     * エントリー日
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'enteredAt'?: string;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'interiorDesignCompanyInteriorDesignOrderStatus'?: InteriorDesignCompanyInteriorDesignOrderStatus;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'companySharedNote'?: string;
    /**
     * ステータスの更新履歴
     * @type {Array<string>}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'interiorDesignOrderPropertyStatusHistory'?: Array<string>;
    /**
     * 中間テーブル作成日時
     * @type {string}
     * @memberof GetDesignInteriorDesignOrder200ResponseItem
     */
    'createdAt'?: string;
}


/**
 * 
 * @export
 * @interface GetDesignMatchingDetail200Response
 */
export interface GetDesignMatchingDetail200Response {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetDesignMatchingDetail200Response
     */
    'interior_design_company_id'?: number;
    /**
     * 名前
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'name': string;
    /**
     * 所在地
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'address'?: string;
    /**
     * 設立年
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'established_year'?: string;
    /**
     * 従業員数
     * @type {number}
     * @memberof GetDesignMatchingDetail200Response
     */
    'employee_count'?: number;
    /**
     * 飲食店施工実績件数
     * @type {number}
     * @memberof GetDesignMatchingDetail200Response
     */
    'construction_restaurant_count'?: number;
    /**
     * 得意な飲食店業種やテイスト
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'specialties'?: string;
    /**
     * 対応可能エリア
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'service_prefectures'?: string;
    /**
     * 特徴
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'features'?: string;
    /**
     * アピールポイント
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'appeal_point'?: string;
    /**
     * HPのURL
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'url'?: string;
    /**
     * 代表者名
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'representative_name'?: string;
    /**
     * 可能役務（物件選定、設計施工、デザインのみ、施工のみ）
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'available_services'?: string;
    /**
     * 目安坪単価（円）
     * @type {number}
     * @memberof GetDesignMatchingDetail200Response
     */
    'unit_price_per_tsubo'?: number;
    /**
     * 建設業許可番号
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'license_number'?: string;
    /**
     * 担当者名
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'contact_name'?: string;
    /**
     * 担当者名カナ
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'contact_kana'?: string;
    /**
     * 担当者電話番号
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'contact_phone_number'?: string;
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'contact_email_address'?: string;
    /**
     * 
     * @type {Array<GetDesignMatchingDetail200ResponseCasesInner>}
     * @memberof GetDesignMatchingDetail200Response
     */
    'cases'?: Array<GetDesignMatchingDetail200ResponseCasesInner>;
    /**
     * 内装会社から依頼主への一言コメント
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'comment'?: string;
    /**
     * 会社が問い合わせにエントリーした日付
     * @type {string}
     * @memberof GetDesignMatchingDetail200Response
     */
    'entry_date'?: string;
}
/**
 * 
 * @export
 * @interface GetDesignMatchingDetail200ResponseCasesInner
 */
export interface GetDesignMatchingDetail200ResponseCasesInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'case_id'?: number;
    /**
     * 内装会社ID
     * @type {number}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'interior_design_company_id'?: number;
    /**
     * 業態（例カフェ、居酒屋など）
     * @type {string}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'category'?: string;
    /**
     * 面積（坪）decimal(10,2)
     * @type {number}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'area_tsubo'?: number;
    /**
     * 完工年
     * @type {string}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'completion_year'?: string;
    /**
     * 席数
     * @type {number}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'seat_count'?: number;
    /**
     * こだわりポイント
     * @type {string}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'focus_points'?: string;
    /**
     * 工事費用
     * @type {number}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'construction_cost'?: number;
    /**
     * 
     * @type {Array<ConstructionCaseImages>}
     * @memberof GetDesignMatchingDetail200ResponseCasesInner
     */
    'images'?: Array<ConstructionCaseImages>;
}
/**
 * 
 * @export
 * @interface GetDesignMatchingOrderList200ResponseInner
 */
export interface GetDesignMatchingOrderList200ResponseInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'id'?: number;
    /**
     * 申込NO（会員内での申込順を表す番号）
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'ordinalNumber'?: string;
    /**
     * 業態
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'category'?: string;
    /**
     * 出店予定時期
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'storeOpeningPeriod'?: string;
    /**
     * 出店予定地
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'storeOpeningLocation'?: string;
    /**
     * 面積（坪）from
     * @type {number}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'areaTsuboFrom'?: number;
    /**
     * 面積（坪）to
     * @type {number}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'areaTsuboTo'?: number;
    /**
     * 
     * @type {InteriorDesignOrderPropertyStatus}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'propertyStatus'?: InteriorDesignOrderPropertyStatus;
    /**
     * 
     * @type {InteriorDesignOrderRequestType}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'requestType'?: InteriorDesignOrderRequestType;
    /**
     * 内装費予算
     * @type {number}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'budgetAmount'?: number;
    /**
     * 
     * @type {InteriorDesignOrderBusinessType}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'clientBusinessType'?: InteriorDesignOrderBusinessType;
    /**
     * 期限
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'deadlineAt'?: string;
    /**
     * 開業総予算（万円）
     * @type {number}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'openingFundsMillionYen'?: number;
    /**
     * 依頼主の要望
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'clientRequest'?: string;
    /**
     * 
     * @type {InteriorDesignOrderPropertyCondition}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'propertyCondition'?: InteriorDesignOrderPropertyCondition;
    /**
     * 案件依頼日
     * @type {string}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'requestedAt'?: string;
    /**
     * 
     * @type {InteriorDesignOrderStatus}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'interiorDesignOrderStatus'?: InteriorDesignOrderStatus;
    /**
     * 
     * @type {number}
     * @memberof GetDesignMatchingOrderList200ResponseInner
     */
    'entryInProgressCount'?: number;
}


/**
 * 
 * @export
 * @interface GetDesignPatternForAdmin200Response
 */
export interface GetDesignPatternForAdmin200Response {
    /**
     * 
     * @type {GetDesignPatternForAdmin200ResponseBody}
     * @memberof GetDesignPatternForAdmin200Response
     */
    'body': GetDesignPatternForAdmin200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetDesignPatternForAdmin200ResponseBody
 */
export interface GetDesignPatternForAdmin200ResponseBody {
    /**
     * 内装会社マッチングID
     * @type {number}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'id': number;
    /**
     * 種別
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'class'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'name'?: string;
    /**
     * 公開・非公開
     * @type {boolean}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'open_flg': boolean;
    /**
     * 説明
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'description'?: string;
    /**
     * 
     * @type {GetDesignPatternForAdmin200ResponseBodyThumbnail}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'thumbnail'?: GetDesignPatternForAdmin200ResponseBodyThumbnail;
    /**
     * 
     * @type {Array<GetDesignPatternForAdmin200ResponseBodyOtherImagesInner>}
     * @memberof GetDesignPatternForAdmin200ResponseBody
     */
    'other_images'?: Array<GetDesignPatternForAdmin200ResponseBodyOtherImagesInner>;
}
/**
 * その他画像
 * @export
 * @interface GetDesignPatternForAdmin200ResponseBodyOtherImagesInner
 */
export interface GetDesignPatternForAdmin200ResponseBodyOtherImagesInner {
    /**
     * URL
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBodyOtherImagesInner
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBodyOtherImagesInner
     */
    'comment'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBodyOtherImagesInner
     */
    'filename'?: string;
}
/**
 * サムネイル画像
 * @export
 * @interface GetDesignPatternForAdmin200ResponseBodyThumbnail
 */
export interface GetDesignPatternForAdmin200ResponseBodyThumbnail {
    /**
     * URL
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBodyThumbnail
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBodyThumbnail
     */
    'comment'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof GetDesignPatternForAdmin200ResponseBodyThumbnail
     */
    'filename'?: string;
}
/**
 * GetDesignPatternInquiryListResponse
 * @export
 * @interface GetDesignPatternInquiryListResponse
 */
export interface GetDesignPatternInquiryListResponse {
    /**
     * 
     * @type {Array<DesignPatternInquiry>}
     * @memberof GetDesignPatternInquiryListResponse
     */
    'designPatternInquiries'?: Array<DesignPatternInquiry>;
}
/**
 * 
 * @export
 * @interface GetDesignPatternList200Response
 */
export interface GetDesignPatternList200Response {
    /**
     * 
     * @type {GetDesignPatternList200ResponseBody}
     * @memberof GetDesignPatternList200Response
     */
    'body': GetDesignPatternList200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetDesignPatternList200ResponseBody
 */
export interface GetDesignPatternList200ResponseBody {
    /**
     * 
     * @type {Array<GetDesignPatternList200ResponseBodyDesignPatternsInner>}
     * @memberof GetDesignPatternList200ResponseBody
     */
    'design_patterns': Array<GetDesignPatternList200ResponseBodyDesignPatternsInner>;
}
/**
 * 
 * @export
 * @interface GetDesignPatternList200ResponseBodyDesignPatternsInner
 */
export interface GetDesignPatternList200ResponseBodyDesignPatternsInner {
    /**
     * 内装会社マッチングID
     * @type {number}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'id': number;
    /**
     * 種別
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'class'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'name'?: string;
    /**
     * 公開・非公開
     * @type {boolean}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'open_flg': boolean;
    /**
     * 説明
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'description'?: string;
    /**
     * 
     * @type {GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'thumbnail'?: GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail;
    /**
     * 
     * @type {Array<GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner>}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'other_images'?: Array<GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner>;
    /**
     * 
     * @type {number}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInner
     */
    'dummy_for_design_pattern_list_get'?: number;
}
/**
 * その他画像
 * @export
 * @interface GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner
 */
export interface GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner {
    /**
     * URL
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner
     */
    'comment'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerOtherImagesInner
     */
    'dummy_for_design_pattern_list_get'?: number;
}
/**
 * サムネイル画像
 * @export
 * @interface GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail
 */
export interface GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail {
    /**
     * URL
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail
     */
    'comment'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDesignPatternList200ResponseBodyDesignPatternsInnerThumbnail
     */
    'dummy_for_design_pattern_list_get'?: number;
}
/**
 * 
 * @export
 * @interface GetEntryCompanyList200ResponseInner
 */
export interface GetEntryCompanyList200ResponseInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'interior_design_order_id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'interior_design_company_id'?: number;
    /**
     * 名前
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'name': string;
    /**
     * 所在地
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'address'?: string;
    /**
     * 特徴
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'features'?: string;
    /**
     * アピールポイント
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'appeal_point'?: string;
    /**
     * HPのURL
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'url'?: string;
    /**
     * 
     * @type {Array<GetEntryCompanyList200ResponseInnerCasesInner>}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'cases'?: Array<GetEntryCompanyList200ResponseInnerCasesInner>;
    /**
     * 内装会社から依頼主への一言コメント
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'comment'?: string;
    /**
     * エントリー日
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInner
     */
    'entered_at'?: string;
}
/**
 * 
 * @export
 * @interface GetEntryCompanyList200ResponseInnerCasesInner
 */
export interface GetEntryCompanyList200ResponseInnerCasesInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetEntryCompanyList200ResponseInnerCasesInner
     */
    'case_id'?: number;
    /**
     * 内装会社ID
     * @type {number}
     * @memberof GetEntryCompanyList200ResponseInnerCasesInner
     */
    'interior_design_company_id'?: number;
    /**
     * 業態（例カフェ、居酒屋など）
     * @type {string}
     * @memberof GetEntryCompanyList200ResponseInnerCasesInner
     */
    'category'?: string;
    /**
     * 
     * @type {Array<ConstructionCaseImages>}
     * @memberof GetEntryCompanyList200ResponseInnerCasesInner
     */
    'images'?: Array<ConstructionCaseImages>;
}
/**
 * 
 * @export
 * @interface GetEstablishedMatchingCompanyList200ResponseInner
 */
export interface GetEstablishedMatchingCompanyList200ResponseInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'interior_design_order_id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'interior_design_company_id'?: number;
    /**
     * 名前
     * @type {string}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'name': string;
    /**
     * 担当者名
     * @type {string}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'contact_name'?: string;
    /**
     * 担当者名カナ
     * @type {string}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'contact_kana'?: string;
    /**
     * 担当者電話番号
     * @type {string}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'contact_phone_number'?: string;
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'contact_email_address'?: string;
    /**
     * 内装会社の1番目の事例画像
     * @type {string}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'image_url'?: string;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus}
     * @memberof GetEstablishedMatchingCompanyList200ResponseInner
     */
    'interior_design_company_interior_design_order_status'?: InteriorDesignCompanyInteriorDesignOrderStatus;
}


/**
 * 
 * @export
 * @interface GetFavoritePropertyList200Response
 */
export interface GetFavoritePropertyList200Response {
    /**
     * 
     * @type {GetFavoritePropertyList200ResponseBody}
     * @memberof GetFavoritePropertyList200Response
     */
    'body': GetFavoritePropertyList200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetFavoritePropertyList200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetFavoritePropertyList200ResponseBody
 */
export interface GetFavoritePropertyList200ResponseBody {
    /**
     * 
     * @type {PageInfo}
     * @memberof GetFavoritePropertyList200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * お気に入り物件一覧
     * @type {Array<GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner>}
     * @memberof GetFavoritePropertyList200ResponseBody
     */
    'favorite_properties': Array<GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner>;
}
/**
 * 
 * @export
 * @interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
 */
export interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner {
    /**
     * お気に入り物件ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'favorite_property_id': number;
    /**
     * 物件ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'id': number;
    /**
     * 物件名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'name': string;
    /**
     * 土地面積
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'surface_area': number;
    /**
     * 面積
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'used_surface_area'?: number;
    /**
     * 坪数
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'tsubo': number;
    /**
     * 築年数
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'tikunennsu': string;
    /**
     * 最寄り駅徒歩n分1
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'access1'?: number;
    /**
     * 最寄り駅徒歩n分2
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'access2'?: number;
    /**
     * 最寄り駅徒歩n分3
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'access3'?: number;
    /**
     * 地上/地下
     * @type {boolean}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'ground_or_basement'?: boolean;
    /**
     * 階数
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'floor': string;
    /**
     * ビル全体の階数
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'biru_no_kaisu': number;
    /**
     * 郵便番号
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'post_number': string;
    /**
     * 都道府県名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'address1': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'prefecture_id'?: number;
    /**
     * エリア名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'address2': string;
    /**
     * 住所_町域名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'address3'?: string;
    /**
     * エリアID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'area_id'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'station_id1'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'station_id2'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'station_id3'?: number;
    /**
     * 駅名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'station_name1'?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'station_name2'?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'station_name3'?: string;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'line_id1'?: number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'line_id2'?: number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'line_id3'?: number;
    /**
     * 路線名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'line_name1'?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'line_name2'?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'line_name3'?: string;
    /**
     * 前業態/テナント(新築/事務所/居酒屋/etc)
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'previous_style'?: number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'previous_style_name'?: string;
    /**
     * 状態（スケルトン、居抜き）
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'condition': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'condition_name'?: string;
    /**
     * 設備
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'facility'?: string;
    /**
     * アピールコメント
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'appeal_comment': string;
    /**
     * 賃料
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'rent': number;
    /**
     * 管理費
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'management_fee': number;
    /**
     * 償却
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'depreciation'?: string;
    /**
     * 敷金
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'security_deposit'?: string;
    /**
     * 礼金
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'key_money': string;
    /**
     * 仲介手数料
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'brokerage_fee'?: string;
    /**
     * 契約期間
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'agreement_period': string;
    /**
     * 契約形態
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'contract_type': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'contract_type_name'?: string;
    /**
     * 構造
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'structure'?: number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'structure_name'?: string;
    /**
     * 出店可能業態
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'possible_usage': number;
    /**
     * 引渡し可能時期
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'possible_surrender'?: string;
    /**
     * 造作譲渡
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'creation_transfer'?: number;
    /**
     * 駐車場
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'parking_area'?: number;
    /**
     * 坪単価
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'tsubo_fee'?: number;
    /**
     * 備考
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'remarks'?: string;
    /**
     * 公開開始日時
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'public_start_at'?: string;
    /**
     * 公開終了日時
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'public_end_at'?: string;
    /**
     * 
     * @type {GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'thumbnail'?: GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail;
    /**
     * 
     * @type {GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'madori'?: GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori;
    /**
     * 
     * @type {Array<GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner>}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'other_images'?: Array<GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner>;
    /**
     * 条件
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInner
     */
    'term'?: string;
}
/**
 * 間取り画像
 * @export
 * @interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori
 */
export interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori {
    /**
     * URL
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerMadori
     */
    'dummy_for_favorite_property_list_get'?: number;
}
/**
 * その他画像
 * @export
 * @interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner
 */
export interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner {
    /**
     * URL
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerOtherImagesInner
     */
    'dummy_for_favorite_property_list_get'?: number;
}
/**
 * サムネイル画像
 * @export
 * @interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail
 */
export interface GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail {
    /**
     * URL
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetFavoritePropertyList200ResponseBodyFavoritePropertiesInnerThumbnail
     */
    'dummy_for_favorite_property_list_get'?: number;
}
/**
 * 
 * @export
 * @interface GetInteriorDesignCompanyDetail200Response
 */
export interface GetInteriorDesignCompanyDetail200Response {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'id': number;
    /**
     * 名前
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'name': string;
    /**
     * 所在地
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'address'?: string;
    /**
     * 設立年
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'established_year'?: string;
    /**
     * 従業員数
     * @type {number}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'employee_count'?: number;
    /**
     * 飲食店施工実績件数
     * @type {number}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'construction_restaurant_count'?: number;
    /**
     * 得意な飲食店業種やテイスト
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'specialties'?: string;
    /**
     * 対応可能エリア
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'service_prefectures'?: string;
    /**
     * 特徴
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'features'?: string;
    /**
     * アピールポイント
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'appeal_point'?: string;
    /**
     * HPのURL
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'url'?: string;
    /**
     * 代表者名
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'representative_name'?: string;
    /**
     * 可能役務（物件選定、設計施工、デザインのみ、施工のみ）
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'available_services'?: string;
    /**
     * 目安坪単価（円）
     * @type {number}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'unit_price_per_tsubo'?: number;
    /**
     * 建設業許可番号
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'license_number'?: string;
    /**
     * 担当者名
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'contact_name'?: string;
    /**
     * 担当者名カナ
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'contact_kana'?: string;
    /**
     * 担当者電話番号
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'contact_phone_number'?: string;
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof GetInteriorDesignCompanyDetail200Response
     */
    'contact_email_address'?: string;
}
/**
 * 
 * @export
 * @interface GetInteriorDesignCompanyFilterItems200Response
 */
export interface GetInteriorDesignCompanyFilterItems200Response {
    /**
     * 内装会社ID
     * @type {number}
     * @memberof GetInteriorDesignCompanyFilterItems200Response
     */
    'interior_design_company_id'?: number;
    /**
     * 案件受け取りフラグ
     * @type {boolean}
     * @memberof GetInteriorDesignCompanyFilterItems200Response
     */
    'receive_order_flg'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetInteriorDesignCompanyFilterItems200Response
     */
    'prefectures'?: Array<number>;
    /**
     * 内装費予算
     * @type {number}
     * @memberof GetInteriorDesignCompanyFilterItems200Response
     */
    'interior_budget'?: number;
    /**
     * 工事坪単価
     * @type {number}
     * @memberof GetInteriorDesignCompanyFilterItems200Response
     */
    'construction_cost_per_tsubo'?: number;
}
/**
 * 
 * @export
 * @interface GetInteriorDesignCompanyList200ResponseInner
 */
export interface GetInteriorDesignCompanyList200ResponseInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'id'?: number;
    /**
     * 名前
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'name'?: string;
    /**
     * 所在地
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'address'?: string;
    /**
     * 設立年
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'established_year'?: string;
    /**
     * 従業員数
     * @type {number}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'employee_count'?: number;
    /**
     * 飲食店施工実績件数
     * @type {number}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'construction_restaurant_count'?: number;
    /**
     * 得意な飲食店業種やテイスト
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'specialties'?: string;
    /**
     * 対応可能エリア
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'service_prefectures'?: string;
    /**
     * 特徴
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'features'?: string;
    /**
     * アピールポイント
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'appeal_point'?: string;
    /**
     * HPのURL
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'url'?: string;
    /**
     * 代表者名
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'representative_name'?: string;
    /**
     * 可能役務（物件選定、設計施工、デザインのみ、施工のみ）
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'available_services'?: string;
    /**
     * 目安坪単価（円）
     * @type {number}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'unit_price_per_tsubo'?: number;
    /**
     * 建設業許可番号
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'license_number'?: string;
    /**
     * 担当者名
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'contact_name'?: string;
    /**
     * 担当者名カナ
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'contact_kana'?: string;
    /**
     * 担当者電話番号
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'contact_phone_number'?: string;
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof GetInteriorDesignCompanyList200ResponseInner
     */
    'contact_email_address'?: string;
}
/**
 * 
 * @export
 * @interface GetInteriorDesignOrders200Response
 */
export interface GetInteriorDesignOrders200Response {
    /**
     * 
     * @type {InteriorDesignOrdersPageInfo}
     * @memberof GetInteriorDesignOrders200Response
     */
    'pageInfo': InteriorDesignOrdersPageInfo;
    /**
     * 
     * @type {Array<InteriorDesignOrdersItem>}
     * @memberof GetInteriorDesignOrders200Response
     */
    'items': Array<InteriorDesignOrdersItem>;
}
/**
 * 
 * @export
 * @interface GetIsMatched200Response
 */
export interface GetIsMatched200Response {
    /**
     * true
     * @type {boolean}
     * @memberof GetIsMatched200Response
     */
    'isMatched'?: boolean;
}
/**
 * 
 * @export
 * @interface GetMAreaList200Response
 */
export interface GetMAreaList200Response {
    /**
     * 
     * @type {GetMAreaList200ResponseBody}
     * @memberof GetMAreaList200Response
     */
    'body': GetMAreaList200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetMAreaList200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetMAreaList200ResponseBody
 */
export interface GetMAreaList200ResponseBody {
    /**
     * 
     * @type {PageInfo}
     * @memberof GetMAreaList200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * 地域マスター
     * @type {Array<GetMAreaList200ResponseBodyAreasInner>}
     * @memberof GetMAreaList200ResponseBody
     */
    'areas': Array<GetMAreaList200ResponseBodyAreasInner>;
}
/**
 * 
 * @export
 * @interface GetMAreaList200ResponseBodyAreasInner
 */
export interface GetMAreaList200ResponseBodyAreasInner {
    /**
     * エリアID
     * @type {number}
     * @memberof GetMAreaList200ResponseBodyAreasInner
     */
    'id': number;
    /**
     * 市区町村ID
     * @type {number}
     * @memberof GetMAreaList200ResponseBodyAreasInner
     */
    'city_id': number;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof GetMAreaList200ResponseBodyAreasInner
     */
    'prefecture_id': number;
    /**
     * エリア名
     * @type {string}
     * @memberof GetMAreaList200ResponseBodyAreasInner
     */
    'name': string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof GetMAreaList200ResponseBodyAreasInner
     */
    'post_number': string;
    /**
     * 物件件数
     * @type {number}
     * @memberof GetMAreaList200ResponseBodyAreasInner
     */
    'property_count': number;
}
/**
 * 
 * @export
 * @interface GetMLineList200Response
 */
export interface GetMLineList200Response {
    /**
     * 
     * @type {GetMLineList200ResponseBody}
     * @memberof GetMLineList200Response
     */
    'body': GetMLineList200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetMLineList200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetMLineList200ResponseBody
 */
export interface GetMLineList200ResponseBody {
    /**
     * 
     * @type {PageInfo}
     * @memberof GetMLineList200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * 路線マスター
     * @type {Array<GetMLineList200ResponseBodyLinesInner>}
     * @memberof GetMLineList200ResponseBody
     */
    'lines': Array<GetMLineList200ResponseBodyLinesInner>;
}
/**
 * 
 * @export
 * @interface GetMLineList200ResponseBodyLinesInner
 */
export interface GetMLineList200ResponseBodyLinesInner {
    /**
     * 路線ID
     * @type {number}
     * @memberof GetMLineList200ResponseBodyLinesInner
     */
    'id': number;
    /**
     * 路線名
     * @type {string}
     * @memberof GetMLineList200ResponseBodyLinesInner
     */
    'name': string;
    /**
     * 物件件数
     * @type {number}
     * @memberof GetMLineList200ResponseBodyLinesInner
     */
    'property_count': number;
}
/**
 * 
 * @export
 * @interface GetMOptionList200Response
 */
export interface GetMOptionList200Response {
    /**
     * 
     * @type {GetMOptionList200ResponseBody}
     * @memberof GetMOptionList200Response
     */
    'body': GetMOptionList200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetMOptionList200ResponseBody
 */
export interface GetMOptionList200ResponseBody {
    /**
     * 
     * @type {Array<GetMOptionList200ResponseBodyOptionCategoriesInner>}
     * @memberof GetMOptionList200ResponseBody
     */
    'option_categories': Array<GetMOptionList200ResponseBodyOptionCategoriesInner>;
}
/**
 * 
 * @export
 * @interface GetMOptionList200ResponseBodyOptionCategoriesInner
 */
export interface GetMOptionList200ResponseBodyOptionCategoriesInner {
    /**
     * 選択肢カテゴリID
     * @type {number}
     * @memberof GetMOptionList200ResponseBodyOptionCategoriesInner
     */
    'id': number;
    /**
     * 選択肢カテゴリ名
     * @type {string}
     * @memberof GetMOptionList200ResponseBodyOptionCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {Array<GetMOptionList200ResponseBodyOptionCategoriesInnerOptionsInner>}
     * @memberof GetMOptionList200ResponseBodyOptionCategoriesInner
     */
    'options': Array<GetMOptionList200ResponseBodyOptionCategoriesInnerOptionsInner>;
}
/**
 * 
 * @export
 * @interface GetMOptionList200ResponseBodyOptionCategoriesInnerOptionsInner
 */
export interface GetMOptionList200ResponseBodyOptionCategoriesInnerOptionsInner {
    /**
     * 選択肢ID
     * @type {number}
     * @memberof GetMOptionList200ResponseBodyOptionCategoriesInnerOptionsInner
     */
    'id': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetMOptionList200ResponseBodyOptionCategoriesInnerOptionsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMPrefectureList200Response
 */
export interface GetMPrefectureList200Response {
    /**
     * 
     * @type {GetMPrefectureList200ResponseBody}
     * @memberof GetMPrefectureList200Response
     */
    'body': GetMPrefectureList200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetMPrefectureList200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetMPrefectureList200ResponseBody
 */
export interface GetMPrefectureList200ResponseBody {
    /**
     * 
     * @type {PageInfo}
     * @memberof GetMPrefectureList200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * 都道府県マスター
     * @type {Array<GetMPrefectureList200ResponseBodyPrefecturesInner>}
     * @memberof GetMPrefectureList200ResponseBody
     */
    'prefectures': Array<GetMPrefectureList200ResponseBodyPrefecturesInner>;
}
/**
 * 
 * @export
 * @interface GetMPrefectureList200ResponseBodyPrefecturesInner
 */
export interface GetMPrefectureList200ResponseBodyPrefecturesInner {
    /**
     * 都道府県ID
     * @type {number}
     * @memberof GetMPrefectureList200ResponseBodyPrefecturesInner
     */
    'id': number;
    /**
     * 都道府県名
     * @type {string}
     * @memberof GetMPrefectureList200ResponseBodyPrefecturesInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMStationList200Response
 */
export interface GetMStationList200Response {
    /**
     * 
     * @type {GetMStationList200ResponseBody}
     * @memberof GetMStationList200Response
     */
    'body': GetMStationList200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetMStationList200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetMStationList200ResponseBody
 */
export interface GetMStationList200ResponseBody {
    /**
     * 
     * @type {PageInfo}
     * @memberof GetMStationList200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * 駅マスター
     * @type {Array<GetMStationList200ResponseBodyStationsInner>}
     * @memberof GetMStationList200ResponseBody
     */
    'stations': Array<GetMStationList200ResponseBodyStationsInner>;
}
/**
 * 
 * @export
 * @interface GetMStationList200ResponseBodyStationsInner
 */
export interface GetMStationList200ResponseBodyStationsInner {
    /**
     * 駅ID
     * @type {number}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'id': number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'line_id': number;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'prefecture_id': number;
    /**
     * 路線の連番
     * @type {number}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'rosen_num': number;
    /**
     * 駅名
     * @type {string}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'name': string;
    /**
     * 乗降者数
     * @type {string}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'zyokousyasuu'?: string;
    /**
     * 立地タイプ
     * @type {string}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'type'?: string;
    /**
     * 物件件数
     * @type {number}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'property_count': number;
    /**
     * 路線名
     * @type {string}
     * @memberof GetMStationList200ResponseBodyStationsInner
     */
    'line_name': string;
}
/**
 * 
 * @export
 * @interface GetMTaxRate200Response
 */
export interface GetMTaxRate200Response {
    /**
     * 
     * @type {GetMTaxRate200ResponseBody}
     * @memberof GetMTaxRate200Response
     */
    'body': GetMTaxRate200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetMTaxRate200ResponseBody
 */
export interface GetMTaxRate200ResponseBody {
    /**
     * 税率ID
     * @type {number}
     * @memberof GetMTaxRate200ResponseBody
     */
    'id': number;
    /**
     * 税率
     * @type {number}
     * @memberof GetMTaxRate200ResponseBody
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface GetMailLetterProperty200Response
 */
export interface GetMailLetterProperty200Response {
    /**
     * 
     * @type {GetMailLetterProperty200ResponseBody}
     * @memberof GetMailLetterProperty200Response
     */
    'body': GetMailLetterProperty200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetMailLetterProperty200ResponseBody
 */
export interface GetMailLetterProperty200ResponseBody {
    /**
     * 結果の内容
     * @type {Array<MailLetterPropertyItem>}
     * @memberof GetMailLetterProperty200ResponseBody
     */
    'list'?: Array<MailLetterPropertyItem>;
}
/**
 * 
 * @export
 * @interface GetMailLetterSetting200Response
 */
export interface GetMailLetterSetting200Response {
    /**
     * 
     * @type {GetMailLetterSetting200ResponseBody}
     * @memberof GetMailLetterSetting200Response
     */
    'body': GetMailLetterSetting200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetMailLetterSetting200ResponseBody
 */
export interface GetMailLetterSetting200ResponseBody {
    /**
     * コラム配信フラグ
     * @type {boolean}
     * @memberof GetMailLetterSetting200ResponseBody
     */
    'column_flg'?: boolean;
    /**
     * セミナー配信フラグ
     * @type {boolean}
     * @memberof GetMailLetterSetting200ResponseBody
     */
    'seminar_flg'?: boolean;
    /**
     * キャンペーン配信フラグ
     * @type {boolean}
     * @memberof GetMailLetterSetting200ResponseBody
     */
    'campaign_flg'?: boolean;
    /**
     * 新着物件配信フラグ
     * @type {boolean}
     * @memberof GetMailLetterSetting200ResponseBody
     */
    'property_flg'?: boolean;
    /**
     * 物件LINEメッセージ配信フラグ
     * @type {boolean}
     * @memberof GetMailLetterSetting200ResponseBody
     */
    'property_line_messaging_flg'?: boolean;
}
/**
 * 
 * @export
 * @interface GetMember200Response
 */
export interface GetMember200Response {
    /**
     * 
     * @type {GetMember200ResponseBody}
     * @memberof GetMember200Response
     */
    'body': GetMember200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetMember200ResponseBody
 */
export interface GetMember200ResponseBody {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'id': number;
    /**
     * Cognito ID
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'cognito_id': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'email_address': string;
    /**
     * 苗字
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'family_name': string;
    /**
     * 名前
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'first_name': string;
    /**
     * 苗字カナ
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'familyNameKana'?: string;
    /**
     * 名前カナ
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'firstNameKana'?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'post_number'?: string;
    /**
     * 都道府県
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'prefecture'?: number;
    /**
     * 都道府県名
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'prefecture_name'?: string;
    /**
     * 市区町村
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'city'?: number;
    /**
     * 市区町村名
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'city_name'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'street_address'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'building'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'phone_number'?: string;
    /**
     * ニックネーム
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'nickname'?: string;
    /**
     * 生年月日
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'birthday'?: string;
    /**
     * 性別
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'gender'?: number;
    /**
     * 飲食店経験有無
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'diner_experience'?: number;
    /**
     * 飲食店経験有種別リスト
     * @type {Array<number>}
     * @memberof GetMember200ResponseBody
     */
    'diner_exp_type'?: Array<number>;
    /**
     * 出店予定時期
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'opn_sched_time'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'company_name'?: string;
    /**
     * 担当コンサルタントID
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'rep_consultant_id'?: number;
    /**
     * 利用規約同意日時
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'terms_agreed_at'?: string;
    /**
     * 利用規約文書更新日時
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'terms_updated_at'?: string;
    /**
     * メール配信同意日時
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'mail_agreed_at'?: string;
    /**
     * 利用規約再同意依頼
     * @type {boolean}
     * @memberof GetMember200ResponseBody
     */
    'hasNeedReAgree'?: boolean;
    /**
     * 機能通知バージョン
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'featureNotiVersion'?: number;
    /**
     * 開業資金額
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'openingFunds'?: number;
    /**
     * 開業状況
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'openingStatus'?: string;
    /**
     * 自己資金額
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'ownFunds'?: number;
    /**
     * 開業予定業種
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'openingIndustryType'?: number;
    /**
     * 既存店数
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'existingStoreCount'?: number;
    /**
     * 開業予定エリア（都道府県）
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'openingPrefecture'?: number;
    /**
     * QualifiedRank
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'qualifiedRank'?: number;
    /**
     * 開業予定者フラグ
     * @type {boolean}
     * @memberof GetMember200ResponseBody
     */
    'willOpenFlg'?: boolean;
    /**
     * 事業形態
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'businessType'?: number;
    /**
     * 店舗数
     * @type {number}
     * @memberof GetMember200ResponseBody
     */
    'storeCount'?: number;
    /**
     * 利用中システム
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'usedSystem'?: string;
    /**
     * 悩み事
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'concern'?: string;
    /**
     * 将来の展望
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'futureVision'?: string;
    /**
     * 
     * @type {Array<MemberStore>}
     * @memberof GetMember200ResponseBody
     */
    'memberStores'?: Array<MemberStore>;
    /**
     * LINE ID
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'lineMessagingId'?: string;
    /**
     * LINE表示名
     * @type {string}
     * @memberof GetMember200ResponseBody
     */
    'lineMessagingDisplayName'?: string;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof GetMember200ResponseBody
     */
    'deleteFlg'?: boolean;
}
/**
 * 
 * @export
 * @interface GetMemberListForAdmin200Response
 */
export interface GetMemberListForAdmin200Response {
    /**
     * 
     * @type {GetMemberListForAdmin200ResponseBody}
     * @memberof GetMemberListForAdmin200Response
     */
    'body': GetMemberListForAdmin200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetMemberListForAdmin200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetMemberListForAdmin200ResponseBody
 */
export interface GetMemberListForAdmin200ResponseBody {
    /**
     * 
     * @type {PageInfo}
     * @memberof GetMemberListForAdmin200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * 会員一覧
     * @type {Array<GetMemberListForAdmin200ResponseBodyMembersInner>}
     * @memberof GetMemberListForAdmin200ResponseBody
     */
    'members': Array<GetMemberListForAdmin200ResponseBodyMembersInner>;
}
/**
 * 
 * @export
 * @interface GetMemberListForAdmin200ResponseBodyMembersInner
 */
export interface GetMemberListForAdmin200ResponseBodyMembersInner {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'id': number;
    /**
     * Cognito ID
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'cognito_id': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'email_address': string;
    /**
     * 権限ロール
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'role'?: number;
    /**
     * 苗字
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'family_name'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'first_name'?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'post_number'?: string;
    /**
     * 都道府県
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'prefecture'?: number;
    /**
     * 都道府県名
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'prefecture_name'?: string;
    /**
     * 市区町村
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'city'?: number;
    /**
     * 市区町村名
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'city_name'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'street_address'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'building'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'phone_number'?: string;
    /**
     * ニックネーム
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'nickname': string;
    /**
     * 生年月日
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'birthday'?: string;
    /**
     * 性別
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'gender'?: number;
    /**
     * 飲食店経験有無
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'diner_experience'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'company_name'?: string;
    /**
     * 担当コンサルタントID
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'rep_consultant_id'?: number;
    /**
     * 担当コンサルタント名
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'rep_consultant_name'?: string;
    /**
     * 利用規約同意日時
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'terms_agreed_at'?: string;
    /**
     * 利用規約文書更新日時
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'terms_updated_at'?: string;
    /**
     * 出店予定時期
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'opn_sched_time'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'dummy_get_member_list_for_admin'?: string;
    /**
     * QualifiedRank
     * @type {number}
     * @memberof GetMemberListForAdmin200ResponseBodyMembersInner
     */
    'qualifiedRank'?: number;
}
/**
 * 
 * @export
 * @interface GetNearestProperties200ResponseInner
 */
export interface GetNearestProperties200ResponseInner {
    /**
     * 物件ID
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'id': number;
    /**
     * 運用者ID
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'operator_id'?: number;
    /**
     * 物件名
     * @type {string}
     * @memberof GetNearestProperties200ResponseInner
     */
    'name': string;
    /**
     * 土地面積
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'surface_area': number;
    /**
     * 坪数
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'tsubo': number;
    /**
     * 最寄り駅徒歩n分1
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'access1': number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'station_id1': number;
    /**
     * 状態（スケルトン、居抜き）
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'condition'?: number;
    /**
     * 駅名
     * @type {string}
     * @memberof GetNearestProperties200ResponseInner
     */
    'station_name1': string;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'line_id1': number;
    /**
     * 路線名
     * @type {string}
     * @memberof GetNearestProperties200ResponseInner
     */
    'line_name1': string;
    /**
     * 賃料
     * @type {number}
     * @memberof GetNearestProperties200ResponseInner
     */
    'rent': number;
    /**
     * 
     * @type {GetPropertyList200ResponseBodyPropertiesInnerThumbnail}
     * @memberof GetNearestProperties200ResponseInner
     */
    'thumbnail'?: GetPropertyList200ResponseBodyPropertiesInnerThumbnail;
}
/**
 * 
 * @export
 * @interface GetPreLineMessagingUserList200Response
 */
export interface GetPreLineMessagingUserList200Response {
    /**
     * 
     * @type {Array<PreLineMessagingUser>}
     * @memberof GetPreLineMessagingUserList200Response
     */
    'userList'?: Array<PreLineMessagingUser>;
}
/**
 * 
 * @export
 * @interface GetProperty200Response
 */
export interface GetProperty200Response {
    /**
     * 
     * @type {GetProperty200ResponseBody}
     * @memberof GetProperty200Response
     */
    'body': GetProperty200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetProperty200ResponseBody
 */
export interface GetProperty200ResponseBody {
    /**
     * 物件ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'id': number;
    /**
     * 運用者ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'operator_id'?: number;
    /**
     * 物件名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'name': string;
    /**
     * 土地面積
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'surface_area': number;
    /**
     * 面積
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'used_surface_area'?: number;
    /**
     * 坪数
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'tsubo': number;
    /**
     * 築年数
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'tikunennsu': string;
    /**
     * 最寄り駅徒歩n分1
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'access1'?: number;
    /**
     * 最寄り駅徒歩n分2
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'access2'?: number;
    /**
     * 最寄り駅徒歩n分3
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'access3'?: number;
    /**
     * 地上/地下
     * @type {boolean}
     * @memberof GetProperty200ResponseBody
     */
    'ground_or_basement'?: boolean;
    /**
     * 階数
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'floor': string;
    /**
     * ビル全体の階数
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'biru_no_kaisu': number;
    /**
     * 郵便番号
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'post_number': string;
    /**
     * 都道府県名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'address1': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'prefecture_id'?: number;
    /**
     * エリア名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'address2': string;
    /**
     * 住所_町域名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'address3'?: string;
    /**
     * 住所_番地
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'address4'?: string;
    /**
     * ビル名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'address5'?: string;
    /**
     * エリアID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'area_id'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'station_id1'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'station_id2'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'station_id3'?: number;
    /**
     * 駅名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'station_name1'?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'station_name2'?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'station_name3'?: string;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'line_id1'?: number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'line_id2'?: number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'line_id3'?: number;
    /**
     * 路線名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'line_name1'?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'line_name2'?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'line_name3'?: string;
    /**
     * 前業態/テナント(新築/事務所/居酒屋/etc)
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'previous_style'?: number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'previous_style_name'?: string;
    /**
     * 状態（スケルトン、居抜き）
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'condition': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'condition_name'?: string;
    /**
     * 設備
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'facility'?: string;
    /**
     * アピールコメント
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'appeal_comment': string;
    /**
     * 賃料
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'rent'?: number;
    /**
     * 管理費
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'management_fee': number;
    /**
     * 償却
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'depreciation'?: string;
    /**
     * 敷金
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'security_deposit'?: string;
    /**
     * 礼金
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'key_money': string;
    /**
     * 更新料
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'renewal_payment'?: string;
    /**
     * 仲介手数料
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'brokerage_fee'?: string;
    /**
     * 契約期間
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'agreement_period': string;
    /**
     * 契約形態
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'contract_type': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'contract_type_name'?: string;
    /**
     * 構造
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'structure'?: number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'structure_name'?: string;
    /**
     * 出店可能業態
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'possible_usage': number;
    /**
     * 引渡し可能時期
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'possible_surrender'?: string;
    /**
     * 造作譲渡
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'creation_transfer'?: number;
    /**
     * 駐車場
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'parking_area'?: number;
    /**
     * 坪単価
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'tsubo_fee'?: number;
    /**
     * 不動産会社ID
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'real_estate_id'?: number;
    /**
     * 不動産会社名
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'real_estate_name'?: string;
    /**
     * 不動産会社Emailアドレス
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'real_estate_email'?: string;
    /**
     * 不動産会社Emailアドレス（初期値）
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'real_estate_email_org'?: string;
    /**
     * 備考
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'remarks'?: string;
    /**
     * 
     * @type {GetProperty200ResponseBodyThumbnail}
     * @memberof GetProperty200ResponseBody
     */
    'thumbnail'?: GetProperty200ResponseBodyThumbnail;
    /**
     * 
     * @type {GetProperty200ResponseBodyMadori}
     * @memberof GetProperty200ResponseBody
     */
    'madori'?: GetProperty200ResponseBodyMadori;
    /**
     * 
     * @type {Array<GetProperty200ResponseBodyOtherImagesInner>}
     * @memberof GetProperty200ResponseBody
     */
    'other_images'?: Array<GetProperty200ResponseBodyOtherImagesInner>;
    /**
     * 条件
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'term'?: string;
    /**
     * 
     * @type {PublicStatus}
     * @memberof GetProperty200ResponseBody
     */
    'public_status'?: PublicStatus;
    /**
     * 
     * @type {PublicRange}
     * @memberof GetProperty200ResponseBody
     */
    'public_range'?: PublicRange;
    /**
     * 公開開始日時
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'public_start_at'?: string;
    /**
     * 公開終了日時
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'public_end_at'?: string;
    /**
     * 無料公開枠
     * @type {boolean}
     * @memberof GetProperty200ResponseBody
     */
    'info_for_free'?: boolean;
    /**
     * 取引態様
     * @type {number}
     * @memberof GetProperty200ResponseBody
     */
    'conditions_of_transactions'?: number;
    /**
     * 住宅総合保険等の損害保険料等を必要とするときはその旨及びその額
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'insurance_information'?: string;
    /**
     * 家賃保証会社等と契約することを条件とするときはその旨及びその額
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'guarantor_company_information'?: string;
    /**
     * 定期建物賃貸借であるときはその旨
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'leasehold_right_information'?: string;
    /**
     * 広告主の事務所の所在地
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'estate_company_address'?: string;
    /**
     * 広告主の事務所の電話番号
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'estate_company_tel'?: string;
    /**
     * 広告主の宅建業法による免許番号
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'estate_company_licence_no'?: string;
    /**
     * 広告主の所属団体及び公正取引協議会加盟事業者である旨
     * @type {string}
     * @memberof GetProperty200ResponseBody
     */
    'estate_company_affiliation'?: string;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof GetProperty200ResponseBody
     */
    'delete_flg'?: boolean;
}


/**
 * 間取り画像
 * @export
 * @interface GetProperty200ResponseBodyMadori
 */
export interface GetProperty200ResponseBodyMadori {
    /**
     * URL
     * @type {string}
     * @memberof GetProperty200ResponseBodyMadori
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetProperty200ResponseBodyMadori
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetProperty200ResponseBodyMadori
     */
    'filename'?: string;
}
/**
 * その他画像
 * @export
 * @interface GetProperty200ResponseBodyOtherImagesInner
 */
export interface GetProperty200ResponseBodyOtherImagesInner {
    /**
     * URL
     * @type {string}
     * @memberof GetProperty200ResponseBodyOtherImagesInner
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetProperty200ResponseBodyOtherImagesInner
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetProperty200ResponseBodyOtherImagesInner
     */
    'filename'?: string;
}
/**
 * サムネイル画像
 * @export
 * @interface GetProperty200ResponseBodyThumbnail
 */
export interface GetProperty200ResponseBodyThumbnail {
    /**
     * URL
     * @type {string}
     * @memberof GetProperty200ResponseBodyThumbnail
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetProperty200ResponseBodyThumbnail
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetProperty200ResponseBodyThumbnail
     */
    'filename'?: string;
}
/**
 * 
 * @export
 * @interface GetPropertyList200Response
 */
export interface GetPropertyList200Response {
    /**
     * 
     * @type {GetPropertyList200ResponseBody}
     * @memberof GetPropertyList200Response
     */
    'body': GetPropertyList200ResponseBody;
    /**
     * ページエラー情報
     * @type {Array<ErrorItem>}
     * @memberof GetPropertyList200Response
     */
    'errors'?: Array<ErrorItem>;
}
/**
 * 
 * @export
 * @interface GetPropertyList200ResponseBody
 */
export interface GetPropertyList200ResponseBody {
    /**
     * 駅IDリスト
     * @type {Array<number>}
     * @memberof GetPropertyList200ResponseBody
     */
    'stationIds'?: Array<number>;
    /**
     * 
     * @type {PageInfo}
     * @memberof GetPropertyList200ResponseBody
     */
    'page_info': PageInfo;
    /**
     * 物件一覧
     * @type {Array<GetPropertyList200ResponseBodyPropertiesInner>}
     * @memberof GetPropertyList200ResponseBody
     */
    'properties': Array<GetPropertyList200ResponseBodyPropertiesInner>;
}
/**
 * 
 * @export
 * @interface GetPropertyList200ResponseBodyPropertiesInner
 */
export interface GetPropertyList200ResponseBodyPropertiesInner {
    /**
     * 物件ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'id': number;
    /**
     * 運用者ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'operator_id'?: number;
    /**
     * 物件名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'name': string;
    /**
     * 土地面積
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'surface_area': number;
    /**
     * 面積
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'used_surface_area'?: number;
    /**
     * 坪数
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'tsubo': number;
    /**
     * 築年数
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'tikunennsu': string;
    /**
     * 最寄り駅徒歩n分1
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'access1'?: number;
    /**
     * 最寄り駅徒歩n分2
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'access2'?: number;
    /**
     * 最寄り駅徒歩n分3
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'access3'?: number;
    /**
     * 地上/地下
     * @type {boolean}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'ground_or_basement'?: boolean;
    /**
     * 階数
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'floor': string;
    /**
     * ビル全体の階数
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'biru_no_kaisu': number;
    /**
     * 郵便番号
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'post_number': string;
    /**
     * 都道府県名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'address1': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'prefecture_id'?: number;
    /**
     * エリア名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'address2': string;
    /**
     * 住所_町域名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'address3'?: string;
    /**
     * 住所_番地
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'address4'?: string;
    /**
     * エリアID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'area_id'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'station_id1'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'station_id2'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'station_id3'?: number;
    /**
     * 駅名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'station_name1'?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'station_name2'?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'station_name3'?: string;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'line_id1'?: number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'line_id2'?: number;
    /**
     * 路線ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'line_id3'?: number;
    /**
     * 路線名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'line_name1'?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'line_name2'?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'line_name3'?: string;
    /**
     * 前業態/テナント(新築/事務所/居酒屋/etc)
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'previous_style'?: number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'previous_style_name'?: string;
    /**
     * 状態（スケルトン、居抜き）
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'condition': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'condition_name'?: string;
    /**
     * 設備
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'facility'?: string;
    /**
     * アピールコメント
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'appeal_comment': string;
    /**
     * 賃料
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'rent'?: number;
    /**
     * 管理費
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'management_fee': number;
    /**
     * 償却
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'depreciation'?: string;
    /**
     * 敷金
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'security_deposit'?: string;
    /**
     * 礼金
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'key_money': string;
    /**
     * 更新料
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'renewal_payment'?: string;
    /**
     * 仲介手数料
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'brokerage_fee'?: string;
    /**
     * 契約期間
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'agreement_period': string;
    /**
     * 契約形態
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'contract_type': number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'contract_type_name'?: string;
    /**
     * 構造
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'structure'?: number;
    /**
     * 選択肢名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'structure_name'?: string;
    /**
     * 出店可能業態
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'possible_usage': number;
    /**
     * 引渡し可能時期
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'possible_surrender'?: string;
    /**
     * 造作譲渡
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'creation_transfer'?: number;
    /**
     * 駐車場
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'parking_area'?: number;
    /**
     * 坪単価
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'tsubo_fee'?: number;
    /**
     * 不動産会社ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'real_estate_id'?: number;
    /**
     * 備考
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'remarks'?: string;
    /**
     * 
     * @type {GetPropertyList200ResponseBodyPropertiesInnerThumbnail}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'thumbnail'?: GetPropertyList200ResponseBodyPropertiesInnerThumbnail;
    /**
     * 
     * @type {GetPropertyList200ResponseBodyPropertiesInnerMadori}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'madori'?: GetPropertyList200ResponseBodyPropertiesInnerMadori;
    /**
     * 
     * @type {Array<GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner>}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'other_images'?: Array<GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner>;
    /**
     * 条件
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'term'?: string;
    /**
     * 
     * @type {PublicStatus}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'public_status'?: PublicStatus;
    /**
     * 
     * @type {PublicRange}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'public_range'?: PublicRange;
    /**
     * 公開開始日時
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'public_start_at'?: string;
    /**
     * 公開終了日時
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'public_end_at'?: string;
    /**
     * 無料公開枠
     * @type {boolean}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'info_for_free'?: boolean;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'delete_flg'?: boolean;
    /**
     * お気に入りフラグ
     * @type {boolean}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'favorite_flg'?: boolean;
    /**
     * 不動産会社名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'real_estate_name'?: string;
    /**
     * 広告主の事務所の所在地
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'estate_company_address'?: string;
    /**
     * 広告主の事務所の電話番号
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'estate_company_tel'?: string;
    /**
     * 広告主の宅建業法による免許番号
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'estate_company_licence_no'?: string;
    /**
     * 広告主の所属団体及び公正取引協議会加盟事業者である旨
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'estate_company_affiliation'?: string;
    /**
     * お気に入り物件ID
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'favorite_property_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInner
     */
    'dummy_for_property_list_get'?: number;
}


/**
 * 間取り画像
 * @export
 * @interface GetPropertyList200ResponseBodyPropertiesInnerMadori
 */
export interface GetPropertyList200ResponseBodyPropertiesInnerMadori {
    /**
     * URL
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerMadori
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerMadori
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerMadori
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerMadori
     */
    'dummy_for_property_list_get'?: number;
}
/**
 * その他画像
 * @export
 * @interface GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner
 */
export interface GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner {
    /**
     * URL
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerOtherImagesInner
     */
    'dummy_for_property_list_get'?: number;
}
/**
 * サムネイル画像
 * @export
 * @interface GetPropertyList200ResponseBodyPropertiesInnerThumbnail
 */
export interface GetPropertyList200ResponseBodyPropertiesInnerThumbnail {
    /**
     * URL
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerThumbnail
     */
    'url': string;
    /**
     * コメント
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerThumbnail
     */
    'comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerThumbnail
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetPropertyList200ResponseBodyPropertiesInnerThumbnail
     */
    'dummy_for_property_list_get'?: number;
}
/**
 * 
 * @export
 * @interface GetPropertySelectionSupportLatestInquiry200Response
 */
export interface GetPropertySelectionSupportLatestInquiry200Response {
    /**
     * 会員ID
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'memberId': number;
    /**
     * 苗字
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'familyName': string;
    /**
     * 名前
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'firstName': string;
    /**
     * フリガナ苗字
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'familyNameKana': string;
    /**
     * フリガナ名前
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'firstNameKana': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'phoneNumber': string;
    /**
     * 業種
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'industryType': number;
    /**
     * 業種詳細
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'industryDetail'?: string;
    /**
     * 開業予定地域
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'openArea': string;
    /**
     * 開業予定日
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'openDay': string;
    /**
     * 物件の状態
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'propertyCondition': number;
    /**
     * 面積以上
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'sizeFrom': number;
    /**
     * 面積以下
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'sizeTo': number;
    /**
     * 賃料以上
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'rentFrom': number;
    /**
     * 賃料以下
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'rentTo': number;
    /**
     * 階数
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'floor': number;
    /**
     * 最寄り駅までの徒歩時間
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'access': number;
    /**
     * 物件備考
     * @type {string}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'propertyRemark'?: string;
    /**
     * 法人or個人
     * @type {number}
     * @memberof GetPropertySelectionSupportLatestInquiry200Response
     */
    'contractType': number;
}
/**
 * 
 * @export
 * @interface GetReferenceList200Response
 */
export interface GetReferenceList200Response {
    /**
     * 
     * @type {Array<ReferenceValueItem>}
     * @memberof GetReferenceList200Response
     */
    'body'?: Array<ReferenceValueItem>;
}
/**
 * 成功レスポンス
 * @export
 * @interface GetRegistrationTemp200Response
 */
export interface GetRegistrationTemp200Response {
    /**
     * 
     * @type {GetRegistrationTemp200ResponseBody}
     * @memberof GetRegistrationTemp200Response
     */
    'body': GetRegistrationTemp200ResponseBody;
}
/**
 * 会員仮登録確認レスポンス
 * @export
 * @interface GetRegistrationTemp200ResponseBody
 */
export interface GetRegistrationTemp200ResponseBody {
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetRegistrationTemp200ResponseBody
     */
    'email': string;
    /**
     * 有効期限
     * @type {string}
     * @memberof GetRegistrationTemp200ResponseBody
     */
    'expired_at': string;
}
/**
 * 
 * @export
 * @interface GetRole200Response
 */
export interface GetRole200Response {
    /**
     * 
     * @type {GetRole200ResponseBody}
     * @memberof GetRole200Response
     */
    'body'?: GetRole200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetRole200ResponseBody
 */
export interface GetRole200ResponseBody {
    /**
     * 権限ロール
     * @type {number}
     * @memberof GetRole200ResponseBody
     */
    'role_id'?: number;
}
/**
 * 
 * @export
 * @interface GetTodoList200Response
 */
export interface GetTodoList200Response {
    /**
     * 
     * @type {GetTodoList200ResponseBody}
     * @memberof GetTodoList200Response
     */
    'body': GetTodoList200ResponseBody;
}
/**
 * 
 * @export
 * @interface GetTodoList200ResponseBody
 */
export interface GetTodoList200ResponseBody {
    /**
     * 
     * @type {Array<GetTodoList200ResponseBodyTodosInner>}
     * @memberof GetTodoList200ResponseBody
     */
    'todos': Array<GetTodoList200ResponseBodyTodosInner>;
    /**
     * 
     * @type {Array<GetTodoList200ResponseBodyPeriodsInner>}
     * @memberof GetTodoList200ResponseBody
     */
    'periods': Array<GetTodoList200ResponseBodyPeriodsInner>;
}
/**
 * 
 * @export
 * @interface GetTodoList200ResponseBodyPeriodsInner
 */
export interface GetTodoList200ResponseBodyPeriodsInner {
    /**
     * タスクマスタ期間ID
     * @type {number}
     * @memberof GetTodoList200ResponseBodyPeriodsInner
     */
    'id': number;
    /**
     * 名称
     * @type {string}
     * @memberof GetTodoList200ResponseBodyPeriodsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetTodoList200ResponseBodyTodosInner
 */
export interface GetTodoList200ResponseBodyTodosInner {
    /**
     * タスクマスタID
     * @type {number}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'id': number;
    /**
     * カテゴリーID
     * @type {number}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'category_id': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'dependency_ids': Array<number>;
    /**
     * タイトル
     * @type {string}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'title': string;
    /**
     * 期間
     * @type {number}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'period': number;
    /**
     * ヘルプ
     * @type {string}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'help'?: string;
    /**
     * コラムリンク
     * @type {string}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'column_url'?: string;
    /**
     * コラムタイトル
     * @type {string}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'column_title'?: string;
    /**
     * X軸
     * @type {number}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'vertical_axis': number;
    /**
     * Y軸
     * @type {number}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'horizontal_axis': number;
    /**
     * チェック
     * @type {boolean}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'check_flg': boolean;
    /**
     * メモ
     * @type {string}
     * @memberof GetTodoList200ResponseBodyTodosInner
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface InquiryPropertyRequest
 */
export interface InquiryPropertyRequest {
    /**
     * 姓
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'family_name': string;
    /**
     * 名
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'first_name': string;
    /**
     * フリガナ（セイ）
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'family_name_kana': string;
    /**
     * フリガナ（メイ）
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'first_name_kana': string;
    /**
     * 会社名
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'company_name'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'phone_number': string;
    /**
     * 業態
     * @type {number}
     * @memberof InquiryPropertyRequest
     */
    'gyotai': number;
    /**
     * 問合せ内容
     * @type {string}
     * @memberof InquiryPropertyRequest
     */
    'body': string;
}
/**
 * 
 * @export
 * @interface InteriorDesignCompanyForOrderListResponse
 */
export interface InteriorDesignCompanyForOrderListResponse {
    /**
     * 
     * @type {Array<InteriorDesignCompanyForOrderListResponseItemsInner>}
     * @memberof InteriorDesignCompanyForOrderListResponse
     */
    'items': Array<InteriorDesignCompanyForOrderListResponseItemsInner>;
}
/**
 * 
 * @export
 * @interface InteriorDesignCompanyForOrderListResponseItemsInner
 */
export interface InteriorDesignCompanyForOrderListResponseItemsInner {
    /**
     * 
     * @type {object}
     * @memberof InteriorDesignCompanyForOrderListResponseItemsInner
     */
    'company': object;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrder}
     * @memberof InteriorDesignCompanyForOrderListResponseItemsInner
     */
    'companyOrder': InteriorDesignCompanyInteriorDesignOrder;
}
/**
 * 
 * @export
 * @interface InteriorDesignCompanyInteriorDesignOrder
 */
export interface InteriorDesignCompanyInteriorDesignOrder {
    /**
     * ID
     * @type {number}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'id'?: number;
    /**
     * 内装案件ID
     * @type {number}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'interiorDesignOrderId'?: number;
    /**
     * 内装会社ID
     * @type {number}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'interiorDesignCompanyId'?: number;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'status': InteriorDesignCompanyInteriorDesignOrderStatus;
    /**
     * メッセージ
     * @type {string}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'message'?: string;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'companySharedNote'?: string;
    /**
     * エントリー日
     * @type {string}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'enteredAt'?: string;
    /**
     * マッチング日
     * @type {string}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'matchedAt'?: string;
    /**
     * 内定フラグ
     * @type {boolean}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'orderGuaranteedFlg'?: boolean;
    /**
     * マッチング前に Drop（辞退）されたかどうか
     * @type {boolean}
     * @memberof InteriorDesignCompanyInteriorDesignOrder
     */
    'isDropBeforeMatching'?: boolean;
}


/**
 * 内装会社エントリー状況ステータス（内装会社ステータス）
 * @export
 * @enum {string}
 */

export const InteriorDesignCompanyInteriorDesignOrderStatus = {
    PRE_ENTRY: 'エントリー前',
    ENTRY_IN_PROGRESS: 'エントリー中',
    MATCHING_ESTABLISHED: 'マッチング成立',
    MATCHING_FAILED: 'マッチング不成立',
    DECLINE: '辞退',
    CONTACTED: '連絡済み',
    MEETING_DONE: '打ち合わせ済み',
    SITE_VISITED: '内見同行済み',
    ESTIMATE_IN_PROGRESS: '見積もり中',
    ESTIMATE_SUBMITTED: '見積もり提出済み',
    CONTRACTED: '成約',
    DROP: 'Drop'
} as const;

export type InteriorDesignCompanyInteriorDesignOrderStatus = typeof InteriorDesignCompanyInteriorDesignOrderStatus[keyof typeof InteriorDesignCompanyInteriorDesignOrderStatus];


/**
 * 
 * @export
 * @interface InteriorDesignCompanyMatchingRequest
 */
export interface InteriorDesignCompanyMatchingRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof InteriorDesignCompanyMatchingRequest
     */
    'company_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface InteriorDesignMatchedCompany
 */
export interface InteriorDesignMatchedCompany {
    /**
     * 内装会社ID
     * @type {number}
     * @memberof InteriorDesignMatchedCompany
     */
    'companyId'?: number;
    /**
     * 内装会社名
     * @type {string}
     * @memberof InteriorDesignMatchedCompany
     */
    'companyName'?: string;
}
/**
 * 
 * @export
 * @interface InteriorDesignOrder
 */
export interface InteriorDesignOrder {
    /**
     * ID
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'memberId'?: number;
    /**
     * 伴走者オペレーターID
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'operatorId'?: number;
    /**
     * タイトル
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'title'?: string;
    /**
     * 業態
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'category'?: string;
    /**
     * 出店予定時期
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'storeOpeningPeriod'?: string;
    /**
     * 出店予定地
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'storeOpeningLocation'?: string;
    /**
     * 都道府県
     * @type {Array<MPrefecture>}
     * @memberof InteriorDesignOrder
     */
    'prefecture'?: Array<MPrefecture>;
    /**
     * 面積（坪）from
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'areaTsuboFrom'?: number;
    /**
     * 面積（坪）to
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'areaTsuboTo'?: number;
    /**
     * 
     * @type {InteriorDesignOrderStatus}
     * @memberof InteriorDesignOrder
     */
    'status'?: InteriorDesignOrderStatus;
    /**
     * 
     * @type {InteriorDesignOrderPropertyStatus}
     * @memberof InteriorDesignOrder
     */
    'propertyStatus'?: InteriorDesignOrderPropertyStatus;
    /**
     * 
     * @type {InteriorDesignOrderPropertyCondition}
     * @memberof InteriorDesignOrder
     */
    'propertyCondition'?: InteriorDesignOrderPropertyCondition;
    /**
     * 
     * @type {InteriorDesignOrderRequestType}
     * @memberof InteriorDesignOrder
     */
    'requestType'?: InteriorDesignOrderRequestType;
    /**
     * 内装費予算
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'budgetAmount'?: number;
    /**
     * 
     * @type {InteriorDesignOrderBusinessType}
     * @memberof InteriorDesignOrder
     */
    'clientBusinessType'?: InteriorDesignOrderBusinessType;
    /**
     * 依頼主の要望
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientRequest'?: string;
    /**
     * ご経歴
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientCareer'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientEmailAddress'?: string;
    /**
     * 氏名
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientName'?: string;
    /**
     * フリガナ
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientKana'?: string;
    /**
     * 
     * @type {InteriorDesignOrderClientAgeRange}
     * @memberof InteriorDesignOrder
     */
    'clientAgeRange'?: InteriorDesignOrderClientAgeRange;
    /**
     * 
     * @type {InteriorDesignOrderClientGender}
     * @memberof InteriorDesignOrder
     */
    'clientGender'?: InteriorDesignOrderClientGender;
    /**
     * 電話番号
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientPhoneNumber'?: string;
    /**
     * 顧客会社名
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'clientCompanyName'?: string;
    /**
     * 
     * @type {InteriorDesignOrderLoanStatus}
     * @memberof InteriorDesignOrder
     */
    'loanStatus'?: InteriorDesignOrderLoanStatus;
    /**
     * 案件依頼日
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'requestedAt'?: string;
    /**
     * 期限
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'deadlineAt'?: string;
    /**
     * 案件送付日
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'sentAt'?: string;
    /**
     * 既存店舗数
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'existingStoreCount'?: number;
    /**
     * 開業総予算（万円）
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'openingFundsMillionYen'?: number;
    /**
     * 内装会社向け共有事項
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'interiorCompanySharedNote'?: string;
    /**
     * システム備考
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'systemNote'?: string;
    /**
     * 備考
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'note'?: string;
    /**
     * 内装会社向け共有事項
     * @type {string}
     * @memberof InteriorDesignOrder
     */
    'interiorCompanyNote'?: string;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof InteriorDesignOrder
     */
    'delete_flg'?: boolean;
    /**
     * 
     * @type {InteriorDesignOrderDropReason}
     * @memberof InteriorDesignOrder
     */
    'dropReason'?: InteriorDesignOrderDropReason;
    /**
     * エントリー数（ENTRY_IN_PROGRESS 件数）
     * @type {number}
     * @memberof InteriorDesignOrder
     */
    'entryCount'?: number;
    /**
     * マッチング済み内装会社一覧
     * @type {Array<InteriorDesignMatchedCompany>}
     * @memberof InteriorDesignOrder
     */
    'matchedCompanies'?: Array<InteriorDesignMatchedCompany>;
    /**
     * ステータスの更新履歴
     * @type {Array<string>}
     * @memberof InteriorDesignOrder
     */
    'propertyStatusHistory'?: Array<string>;
    /**
     * メンバーが削除済みか否か
     * @type {boolean}
     * @memberof InteriorDesignOrder
     */
    'isMemberDeleted'?: boolean;
}


/**
 * 種別
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderBusinessType = {
    CORPORATION: '法人',
    INDIVIDUAL: '個人',
    PLANNING_INCORPORATE: '法人成り予定'
} as const;

export type InteriorDesignOrderBusinessType = typeof InteriorDesignOrderBusinessType[keyof typeof InteriorDesignOrderBusinessType];


/**
 * 年代
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderClientAgeRange = {
    AGE_10: '10代',
    AGE_20: '20代',
    AGE_30: '30代',
    AGE_40: '40代',
    AGE_50: '50代',
    AGE_60: '60代',
    AGE_70: '70代',
    AGE_80: '80代'
} as const;

export type InteriorDesignOrderClientAgeRange = typeof InteriorDesignOrderClientAgeRange[keyof typeof InteriorDesignOrderClientAgeRange];


/**
 * 性別
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderClientGender = {
    MALE: '男性',
    FEMALE: '女性',
    OTHER: 'その他'
} as const;

export type InteriorDesignOrderClientGender = typeof InteriorDesignOrderClientGender[keyof typeof InteriorDesignOrderClientGender];


/**
 * 案件のDrop理由
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderDropReason = {
    CANCEL_PROJECT_CANCELED: 'キャンセル：案件キャンセル',
    CANCEL_CANCELLED_DUE_TO_PREVIOUS_TENANT: 'キャンセル：居抜きの為キャンセル',
    CANCEL_OTHER: 'キャンセル：その他',
    DROP: '失注'
} as const;

export type InteriorDesignOrderDropReason = typeof InteriorDesignOrderDropReason[keyof typeof InteriorDesignOrderDropReason];


/**
 * 
 * @export
 * @interface InteriorDesignOrderEntry
 */
export interface InteriorDesignOrderEntry {
    /**
     * コメント
     * @type {string}
     * @memberof InteriorDesignOrderEntry
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface InteriorDesignOrderEntryPatchResponse
 */
export interface InteriorDesignOrderEntryPatchResponse {
    /**
     * 会員ID
     * @type {number}
     * @memberof InteriorDesignOrderEntryPatchResponse
     */
    'id': number;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus}
     * @memberof InteriorDesignOrderEntryPatchResponse
     */
    'interiorDesignCompanyInteriorDesignOrderStatus': InteriorDesignCompanyInteriorDesignOrderStatus;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof InteriorDesignOrderEntryPatchResponse
     */
    'companySharedNote'?: string;
}


/**
 * 
 * @export
 * @interface InteriorDesignOrderListGetResponse
 */
export interface InteriorDesignOrderListGetResponse {
    /**
     * 
     * @type {Array<InteriorDesignOrder>}
     * @memberof InteriorDesignOrderListGetResponse
     */
    'items': Array<InteriorDesignOrder>;
    /**
     * 最大ページ数
     * @type {number}
     * @memberof InteriorDesignOrderListGetResponse
     */
    'maxPage': number;
    /**
     * 総案件数
     * @type {number}
     * @memberof InteriorDesignOrderListGetResponse
     */
    'totalOrderCount'?: number;
}
/**
 * 借入状況
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderLoanStatus = {
    HAS_PLAN: '予定あり',
    NO_PLAN: '予定なし',
    UNDECIDED: '未定'
} as const;

export type InteriorDesignOrderLoanStatus = typeof InteriorDesignOrderLoanStatus[keyof typeof InteriorDesignOrderLoanStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderOperators = {
    id_1: '西 和彦',
    id_53: '小山 大空'
} as const;

export type InteriorDesignOrderOperators = typeof InteriorDesignOrderOperators[keyof typeof InteriorDesignOrderOperators];


/**
 * 
 * @export
 * @interface InteriorDesignOrderPostCompanySharedNoteResponse
 */
export interface InteriorDesignOrderPostCompanySharedNoteResponse {
    /**
     * 会員ID
     * @type {number}
     * @memberof InteriorDesignOrderPostCompanySharedNoteResponse
     */
    'id': number;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof InteriorDesignOrderPostCompanySharedNoteResponse
     */
    'companySharedNote': string;
}
/**
 * 物件の状態
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderPropertyCondition = {
    INUKI: '居抜き',
    SKELETON: 'スケルトン',
    INUKI_SKELETON: '居抜き・スケルトン'
} as const;

export type InteriorDesignOrderPropertyCondition = typeof InteriorDesignOrderPropertyCondition[keyof typeof InteriorDesignOrderPropertyCondition];


/**
 * 
 * @export
 * @interface InteriorDesignOrderPropertyPatchResponse
 */
export interface InteriorDesignOrderPropertyPatchResponse {
    /**
     * 会員ID
     * @type {number}
     * @memberof InteriorDesignOrderPropertyPatchResponse
     */
    'id': number;
    /**
     * 
     * @type {InteriorDesignOrderPropertyStatus}
     * @memberof InteriorDesignOrderPropertyPatchResponse
     */
    'propertyStatus': InteriorDesignOrderPropertyStatus;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof InteriorDesignOrderPropertyPatchResponse
     */
    'companySharedNote'?: string;
}


/**
 * 物件ステータス
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderPropertyStatus = {
    SEARCHING: '探し中',
    HAS_CANDIDATE: '候補物件あり',
    APPLYING: '申込中',
    CONTRACTED: '物件成約'
} as const;

export type InteriorDesignOrderPropertyStatus = typeof InteriorDesignOrderPropertyStatus[keyof typeof InteriorDesignOrderPropertyStatus];


/**
 * 依頼内容
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderRequestType = {
    DESIGN_CONSTRUCTION: '設計施工',
    DESIGN_ONLY: '設計のみ',
    CONSTRUCTION_ONLY: '施工のみ',
    OTHER: 'その他'
} as const;

export type InteriorDesignOrderRequestType = typeof InteriorDesignOrderRequestType[keyof typeof InteriorDesignOrderRequestType];


/**
 * 内装ステータス（案件側）
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderStatus = {
    CASE_SENT_BEFORE: '案件送付前',
    OPEN_FOR_ENTRIES: '募集中',
    COMPANY_NOT_SELECTED: '内装会社未選択',
    NO_ENTRY: 'エントリーなし',
    COMPANY_UNMATCHED: '内装会社未マッチ',
    MATCHING_COMPLETE: 'マッチング完了',
    CONTRACTED: '成約',
    DROP_MATCH_BEFORE: 'Drop (マッチング前)',
    DROP_BEFORE_ESTIMATE: 'Drop (見積もり前)',
    DROP_AFTER_ESTIMATE: 'Drop (見積もり後)'
} as const;

export type InteriorDesignOrderStatus = typeof InteriorDesignOrderStatus[keyof typeof InteriorDesignOrderStatus];


/**
 * ステータスサマリーのラベル（日本語）
 * @export
 * @enum {string}
 */

export const InteriorDesignOrderSummaryLabel = {
    CASE_SENT_BEFORE: '案件送付前',
    COMPANY_NOT_SELECTED: '内装会社未選択',
    NO_ENTRY: 'エントリーなし',
    COMPANY_UNMATCHED: '内装会社未マッチ',
    PROPERTY_SEARCHING: '物件探し中',
    PROPERTY_HAS_CANDIDATE: '候補物件あり',
    PROPERTY_APPLYING: '申込中',
    PROPERTY_CONTRACTED: '物件成約',
    INTERIOR_DESIGN_CONTRACTED: '成約',
    DROPS: 'Drop'
} as const;

export type InteriorDesignOrderSummaryLabel = typeof InteriorDesignOrderSummaryLabel[keyof typeof InteriorDesignOrderSummaryLabel];


/**
 * 
 * @export
 * @interface InteriorDesignOrdersItem
 */
export interface InteriorDesignOrdersItem {
    /**
     * ID
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'memberId'?: number;
    /**
     * 伴走者オペレーターID
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'operatorId'?: number;
    /**
     * タイトル
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'title'?: string;
    /**
     * 業態
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'category'?: string;
    /**
     * 出店予定時期
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'storeOpeningPeriod'?: string;
    /**
     * 出店予定地
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'storeOpeningLocation'?: string;
    /**
     * 都道府県
     * @type {Array<MPrefecture>}
     * @memberof InteriorDesignOrdersItem
     */
    'prefecture'?: Array<MPrefecture>;
    /**
     * 面積（坪）from
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'areaTsuboFrom'?: number;
    /**
     * 面積（坪）to
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'areaTsuboTo'?: number;
    /**
     * 
     * @type {InteriorDesignOrderStatus}
     * @memberof InteriorDesignOrdersItem
     */
    'status'?: InteriorDesignOrderStatus;
    /**
     * 
     * @type {InteriorDesignOrderPropertyStatus}
     * @memberof InteriorDesignOrdersItem
     */
    'propertyStatus'?: InteriorDesignOrderPropertyStatus;
    /**
     * 
     * @type {InteriorDesignOrderPropertyCondition}
     * @memberof InteriorDesignOrdersItem
     */
    'propertyCondition'?: InteriorDesignOrderPropertyCondition;
    /**
     * 
     * @type {InteriorDesignOrderRequestType}
     * @memberof InteriorDesignOrdersItem
     */
    'requestType'?: InteriorDesignOrderRequestType;
    /**
     * 内装費予算
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'budgetAmount'?: number;
    /**
     * 
     * @type {InteriorDesignOrderBusinessType}
     * @memberof InteriorDesignOrdersItem
     */
    'clientBusinessType'?: InteriorDesignOrderBusinessType;
    /**
     * 依頼主の要望
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientRequest'?: string;
    /**
     * ご経歴
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientCareer'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientEmailAddress'?: string;
    /**
     * 氏名
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientName'?: string;
    /**
     * フリガナ
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientKana'?: string;
    /**
     * 
     * @type {InteriorDesignOrderClientAgeRange}
     * @memberof InteriorDesignOrdersItem
     */
    'clientAgeRange'?: InteriorDesignOrderClientAgeRange;
    /**
     * 
     * @type {InteriorDesignOrderClientGender}
     * @memberof InteriorDesignOrdersItem
     */
    'clientGender'?: InteriorDesignOrderClientGender;
    /**
     * 電話番号
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientPhoneNumber'?: string;
    /**
     * 顧客会社名
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'clientCompanyName'?: string;
    /**
     * 
     * @type {InteriorDesignOrderLoanStatus}
     * @memberof InteriorDesignOrdersItem
     */
    'loanStatus'?: InteriorDesignOrderLoanStatus;
    /**
     * 案件依頼日
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'requestedAt'?: string;
    /**
     * 期限
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'deadlineAt'?: string;
    /**
     * 案件送付日
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'sentAt'?: string;
    /**
     * 既存店舗数
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'existingStoreCount'?: number;
    /**
     * 開業総予算（万円）
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'openingFundsMillionYen'?: number;
    /**
     * 内装会社向け共有事項
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'interiorCompanySharedNote'?: string;
    /**
     * システム備考
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'systemNote'?: string;
    /**
     * 備考
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'note'?: string;
    /**
     * 内装会社向け共有事項
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'interiorCompanyNote'?: string;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof InteriorDesignOrdersItem
     */
    'delete_flg'?: boolean;
    /**
     * 
     * @type {InteriorDesignOrderDropReason}
     * @memberof InteriorDesignOrdersItem
     */
    'dropReason'?: InteriorDesignOrderDropReason;
    /**
     * エントリー数（ENTRY_IN_PROGRESS 件数）
     * @type {number}
     * @memberof InteriorDesignOrdersItem
     */
    'entryCount'?: number;
    /**
     * マッチング済み内装会社一覧
     * @type {Array<InteriorDesignMatchedCompany>}
     * @memberof InteriorDesignOrdersItem
     */
    'matchedCompanies'?: Array<InteriorDesignMatchedCompany>;
    /**
     * ステータスの更新履歴
     * @type {Array<string>}
     * @memberof InteriorDesignOrdersItem
     */
    'propertyStatusHistory'?: Array<string>;
    /**
     * メンバーが削除済みか否か
     * @type {boolean}
     * @memberof InteriorDesignOrdersItem
     */
    'isMemberDeleted'?: boolean;
    /**
     * エントリー日
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'enteredAt'?: string;
    /**
     * マッチング日
     * @type {string}
     * @memberof InteriorDesignOrdersItem
     */
    'matchedAt'?: string;
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus}
     * @memberof InteriorDesignOrdersItem
     */
    'interiorDesignCompanyInteriorDesignOrderStatus'?: InteriorDesignCompanyInteriorDesignOrderStatus;
}


/**
 * ページ情報を含むメタデータオブジェクト。現在のページ番号、1ページあたりの件数、全ページ数、全件数を定義する。
 * @export
 * @interface InteriorDesignOrdersPageInfo
 */
export interface InteriorDesignOrdersPageInfo {
    /**
     * 現在のページ番号（1始まり）
     * @type {number}
     * @memberof InteriorDesignOrdersPageInfo
     */
    'currentPage': number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof InteriorDesignOrdersPageInfo
     */
    'perPage': number;
    /**
     * 全ページ数
     * @type {number}
     * @memberof InteriorDesignOrdersPageInfo
     */
    'totalPages': number;
    /**
     * 全件数
     * @type {number}
     * @memberof InteriorDesignOrdersPageInfo
     */
    'totalCount': number;
}
/**
 * ステータスサマリーの1項目
 * @export
 * @interface InteriorDesignOrdersStatusSummaryItem
 */
export interface InteriorDesignOrdersStatusSummaryItem {
    /**
     * 
     * @type {InteriorDesignOrderSummaryLabel}
     * @memberof InteriorDesignOrdersStatusSummaryItem
     */
    'label': InteriorDesignOrderSummaryLabel;
    /**
     * 件数
     * @type {number}
     * @memberof InteriorDesignOrdersStatusSummaryItem
     */
    'count': number;
}


/**
 * 
 * @export
 * @interface Line
 */
export interface Line {
    /**
     * チャネルID
     * @type {string}
     * @memberof Line
     */
    'destination'?: string;
    /**
     * 
     * @type {Array<LineEvent>}
     * @memberof Line
     */
    'events'?: Array<LineEvent>;
}
/**
 * 
 * @export
 * @interface LineEvent
 */
export interface LineEvent {
    /**
     * 
     * @type {string}
     * @memberof LineEvent
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LineEvent
     */
    'timestamp'?: number;
    /**
     * 
     * @type {LineEventSource}
     * @memberof LineEvent
     */
    'source'?: LineEventSource;
    /**
     * 
     * @type {string}
     * @memberof LineEvent
     */
    'replyToken'?: string;
    /**
     * 
     * @type {LineEventMessage}
     * @memberof LineEvent
     */
    'message'?: LineEventMessage;
}
/**
 * 
 * @export
 * @interface LineEventMessage
 */
export interface LineEventMessage {
    /**
     * 
     * @type {string}
     * @memberof LineEventMessage
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineEventMessage
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineEventMessage
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface LineEventSource
 */
export interface LineEventSource {
    /**
     * 
     * @type {string}
     * @memberof LineEventSource
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineEventSource
     */
    'userId'?: string;
}
/**
 * 都道府県
 * @export
 * @enum {string}
 */

export const MPrefecture = {
    m_1: '北海道',
    m_2: '青森県',
    m_3: '岩手県',
    m_4: '宮城県',
    m_5: '秋田県',
    m_6: '山形県',
    m_7: '福島県',
    m_8: '茨城県',
    m_9: '栃木県',
    m_10: '群馬県',
    m_11: '埼玉県',
    m_12: '千葉県',
    m_13: '東京都',
    m_14: '神奈川県',
    m_15: '新潟県',
    m_16: '富山県',
    m_17: '石川県',
    m_18: '福井県',
    m_19: '山梨県',
    m_20: '長野県',
    m_21: '岐阜県',
    m_22: '静岡県',
    m_23: '愛知県',
    m_24: '三重県',
    m_25: '滋賀県',
    m_26: '京都府',
    m_27: '大阪府',
    m_28: '兵庫県',
    m_29: '奈良県',
    m_30: '和歌山県',
    m_31: '鳥取県',
    m_32: '島根県',
    m_33: '岡山県',
    m_34: '広島県',
    m_35: '山口県',
    m_36: '徳島県',
    m_37: '香川県',
    m_38: '愛媛県',
    m_39: '高知県',
    m_40: '福岡県',
    m_41: '佐賀県',
    m_42: '長崎県',
    m_43: '熊本県',
    m_44: '大分県',
    m_45: '宮崎県',
    m_46: '鹿児島県',
    m_47: '沖縄県'
} as const;

export type MPrefecture = typeof MPrefecture[keyof typeof MPrefecture];


/**
 * メール配信（新着物件）アイテム
 * @export
 * @interface MailLetterPropertyItem
 */
export interface MailLetterPropertyItem {
    /**
     * メール配信（新着物件）ID
     * @type {number}
     * @memberof MailLetterPropertyItem
     */
    'Id'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof MailLetterPropertyItem
     */
    'StationId'?: number;
    /**
     * 路線の連番
     * @type {number}
     * @memberof MailLetterPropertyItem
     */
    'RosenNum'?: number;
    /**
     * 駅名
     * @type {string}
     * @memberof MailLetterPropertyItem
     */
    'StationName'?: string;
    /**
     * エリアID
     * @type {number}
     * @memberof MailLetterPropertyItem
     */
    'AreaId'?: number;
    /**
     * 都道府県名
     * @type {string}
     * @memberof MailLetterPropertyItem
     */
    'PrefectureName'?: string;
    /**
     * エリア名
     * @type {string}
     * @memberof MailLetterPropertyItem
     */
    'AreaName'?: string;
}
/**
 * 
 * @export
 * @interface MemberStore
 */
export interface MemberStore {
    /**
     * 店舗情報ID
     * @type {number}
     * @memberof MemberStore
     */
    'Id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof MemberStore
     */
    'memberId'?: number;
    /**
     * 店舗名
     * @type {string}
     * @memberof MemberStore
     */
    'storeName'?: string;
    /**
     * 所在地
     * @type {string}
     * @memberof MemberStore
     */
    'address'?: string;
    /**
     * 業態や営業時間等
     * @type {string}
     * @memberof MemberStore
     */
    'industryTypeAndOpeningHours'?: string;
    /**
     * 順番
     * @type {number}
     * @memberof MemberStore
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface MemberStoreRequest
 */
export interface MemberStoreRequest {
    /**
     * 
     * @type {Array<MemberStore>}
     * @memberof MemberStoreRequest
     */
    'memberStores': Array<MemberStore>;
}
/**
 * 
 * @export
 * @interface MemberStoreResponse
 */
export interface MemberStoreResponse {
    /**
     * 
     * @type {Array<MemberStore>}
     * @memberof MemberStoreResponse
     */
    'memberStores': Array<MemberStore>;
}
/**
 * 
 * @export
 * @interface MemberStoreTemp
 */
export interface MemberStoreTemp {
    /**
     * 店舗情報ID
     * @type {number}
     * @memberof MemberStoreTemp
     */
    'Id'?: number;
    /**
     * 仮登録ID
     * @type {number}
     * @memberof MemberStoreTemp
     */
    'preMemberId'?: number;
    /**
     * 店舗名
     * @type {string}
     * @memberof MemberStoreTemp
     */
    'storeName'?: string;
    /**
     * 所在地
     * @type {string}
     * @memberof MemberStoreTemp
     */
    'address'?: string;
    /**
     * 業態や営業時間等
     * @type {string}
     * @memberof MemberStoreTemp
     */
    'industryTypeAndOpeningHours'?: string;
    /**
     * 順番
     * @type {number}
     * @memberof MemberStoreTemp
     */
    'order'?: number;
}
/**
 * （運用者）メール配信同意更新リクエスト
 * @export
 * @interface OpeMailLetterAgreeRequest
 */
export interface OpeMailLetterAgreeRequest {
    /**
     * メール配信に同意するかどうか
     * @type {boolean}
     * @memberof OpeMailLetterAgreeRequest
     */
    'is_agreed': boolean;
}
/**
 * メール配信（新着物件）設定情報登録リクエスト
 * @export
 * @interface OpeMailLetterPropertyRequest
 */
export interface OpeMailLetterPropertyRequest {
    /**
     * 
     * @type {Array<PostMailLetterPropertyRequestListInner>}
     * @memberof OpeMailLetterPropertyRequest
     */
    'list': Array<PostMailLetterPropertyRequestListInner>;
}
/**
 * （運用者）メール配信（新着物件）設定情報レスポンス
 * @export
 * @interface OpeMailLetterPropertyResponse
 */
export interface OpeMailLetterPropertyResponse {
    /**
     * 
     * @type {OpeMailLetterPropertyResponseBody}
     * @memberof OpeMailLetterPropertyResponse
     */
    'body': OpeMailLetterPropertyResponseBody;
}
/**
 * （運用者）メール配信（新着物件）設定情報レスポンス ボディ
 * @export
 * @interface OpeMailLetterPropertyResponseBody
 */
export interface OpeMailLetterPropertyResponseBody {
    /**
     * 結果の内容
     * @type {Array<MailLetterPropertyItem>}
     * @memberof OpeMailLetterPropertyResponseBody
     */
    'list': Array<MailLetterPropertyItem>;
}
/**
 * メール配信同意設定更新リクエスト
 * @export
 * @interface OpeMailLetterRequest
 */
export interface OpeMailLetterRequest {
    /**
     * コラム配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterRequest
     */
    'column_flg': boolean;
    /**
     * セミナー配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterRequest
     */
    'seminar_flg': boolean;
    /**
     * キャンペーン配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterRequest
     */
    'campaign_flg': boolean;
    /**
     * 新着物件配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterRequest
     */
    'property_flg': boolean;
    /**
     * 新着物件配信初期設定フラグ
     * @type {boolean}
     * @memberof OpeMailLetterRequest
     */
    'property_init_flg'?: boolean;
    /**
     * 物件LINEメッセージ配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterRequest
     */
    'property_line_messaging_flg': boolean;
}
/**
 * （運用者）メール配信同意設定レスポンス
 * @export
 * @interface OpeMailLetterSettingResponse
 */
export interface OpeMailLetterSettingResponse {
    /**
     * 
     * @type {OpeMailLetterSettingResponseBody}
     * @memberof OpeMailLetterSettingResponse
     */
    'body': OpeMailLetterSettingResponseBody;
}
/**
 * （運用者）メール配信同意設定レスポンス ボディ
 * @export
 * @interface OpeMailLetterSettingResponseBody
 */
export interface OpeMailLetterSettingResponseBody {
    /**
     * コラム配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterSettingResponseBody
     */
    'column_flg': boolean;
    /**
     * セミナー配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterSettingResponseBody
     */
    'seminar_flg': boolean;
    /**
     * キャンペーン配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterSettingResponseBody
     */
    'campaign_flg': boolean;
    /**
     * 新着物件配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterSettingResponseBody
     */
    'property_flg': boolean;
    /**
     * 物件LINEメッセージ配信フラグ
     * @type {boolean}
     * @memberof OpeMailLetterSettingResponseBody
     */
    'property_line_messaging_flg': boolean;
}
/**
 * ページ情報
 * @export
 * @interface PageInfo
 */
export interface PageInfo {
    /**
     * 総件数
     * @type {number}
     * @memberof PageInfo
     */
    'total': number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof PageInfo
     */
    'total_page': number;
    /**
     * 現在のページ
     * @type {number}
     * @memberof PageInfo
     */
    'current_page': number;
    /**
     * ページ内リストの最初のアイテムの順番
     * @type {number}
     * @memberof PageInfo
     */
    'first': number;
    /**
     * ページ内リストの最後のアイテムの順番
     * @type {number}
     * @memberof PageInfo
     */
    'last': number;
}
/**
 * 
 * @export
 * @interface PatchInteriorDesignOrderEntryStatusRequest
 */
export interface PatchInteriorDesignOrderEntryStatusRequest {
    /**
     * 
     * @type {InteriorDesignCompanyInteriorDesignOrderStatus}
     * @memberof PatchInteriorDesignOrderEntryStatusRequest
     */
    'status': InteriorDesignCompanyInteriorDesignOrderStatus;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof PatchInteriorDesignOrderEntryStatusRequest
     */
    'companySharedNote'?: string;
}


/**
 * 
 * @export
 * @interface PatchInteriorDesignOrderPropertyStatusRequest
 */
export interface PatchInteriorDesignOrderPropertyStatusRequest {
    /**
     * 
     * @type {InteriorDesignOrderPropertyStatus}
     * @memberof PatchInteriorDesignOrderPropertyStatusRequest
     */
    'status': InteriorDesignOrderPropertyStatus;
    /**
     * 内装会社との個別共有事項
     * @type {string}
     * @memberof PatchInteriorDesignOrderPropertyStatusRequest
     */
    'companySharedNote'?: string;
}


/**
 * 
 * @export
 * @interface PatchPropertyRequest
 */
export interface PatchPropertyRequest {
    /**
     * 
     * @type {PropertyPublicStatus}
     * @memberof PatchPropertyRequest
     */
    'public_status'?: PropertyPublicStatus;
}


/**
 * 
 * @export
 * @interface PostInteriorDesignOrderCompanySharedNoteRequest
 */
export interface PostInteriorDesignOrderCompanySharedNoteRequest {
    /**
     * 運営への共有事項
     * @type {string}
     * @memberof PostInteriorDesignOrderCompanySharedNoteRequest
     */
    'sharedNote': string;
}
/**
 * 
 * @export
 * @interface PostMailLetterPropertyRequest
 */
export interface PostMailLetterPropertyRequest {
    /**
     * 
     * @type {Array<PostMailLetterPropertyRequestListInner>}
     * @memberof PostMailLetterPropertyRequest
     */
    'list': Array<PostMailLetterPropertyRequestListInner>;
}
/**
 * 
 * @export
 * @interface PostMailLetterPropertyRequestListInner
 */
export interface PostMailLetterPropertyRequestListInner {
    /**
     * 
     * @type {number}
     * @memberof PostMailLetterPropertyRequestListInner
     */
    'stationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostMailLetterPropertyRequestListInner
     */
    'areaId'?: number;
}
/**
 * LINE未連携ユーザーのリスト
 * @export
 * @interface PreLineMessagingUser
 */
export interface PreLineMessagingUser {
    /**
     * リストID
     * @type {number}
     * @memberof PreLineMessagingUser
     */
    'id'?: number;
    /**
     * LINE ID
     * @type {string}
     * @memberof PreLineMessagingUser
     */
    'lineMessagingId'?: string;
    /**
     * 表示名
     * @type {string}
     * @memberof PreLineMessagingUser
     */
    'displayName'?: string;
    /**
     * 登録日時
     * @type {string}
     * @memberof PreLineMessagingUser
     */
    'registeredAt'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof PreLineMessagingUser
     */
    'phoneNumber'?: string;
}
/**
 * 都道府県（ファイル名をPrefectureにするとPrefecture2型になるので命名にEnumを付与）
 * @export
 * @enum {string}
 */

export const PrefectureEnum = {
    /**
    * 北海道
    */
    HOKKAIDO: 1,
    /**
    * 青森県
    */
    AOMORI: 2,
    /**
    * 岩手県
    */
    IWATE: 3,
    /**
    * 宮城県
    */
    MIYAGI: 4,
    /**
    * 秋田県
    */
    AKITA: 5,
    /**
    * 山形県
    */
    YAMAGATA: 6,
    /**
    * 福島県
    */
    FUKUSHIMA: 7,
    /**
    * 茨城県
    */
    IBARAKI: 8,
    /**
    * 栃木県
    */
    TOCHIGI: 9,
    /**
    * 群馬県
    */
    GUNMA: 10,
    /**
    * 埼玉県
    */
    SAITAMA: 11,
    /**
    * 千葉県
    */
    CHIBA: 12,
    /**
    * 東京都
    */
    TOKYO: 13,
    /**
    * 神奈川県
    */
    KANAGAWA: 14,
    /**
    * 新潟県
    */
    NIIGATA: 15,
    /**
    * 富山県
    */
    TOYAMA: 16,
    /**
    * 石川県
    */
    ISHIKAWA: 17,
    /**
    * 福井県
    */
    FUKUI: 18,
    /**
    * 山梨県
    */
    YAMANASHI: 19,
    /**
    * 長野県
    */
    NAGANO: 20,
    /**
    * 岐阜県
    */
    GIFU: 21,
    /**
    * 静岡県
    */
    SHIZUOKA: 22,
    /**
    * 愛知県
    */
    AICHI: 23,
    /**
    * 三重県
    */
    MIE: 24,
    /**
    * 滋賀県
    */
    SHIGA: 25,
    /**
    * 京都府
    */
    KYOTO: 26,
    /**
    * 大阪府
    */
    OSAKA: 27,
    /**
    * 兵庫県
    */
    HYOGO: 28,
    /**
    * 奈良県
    */
    NARA: 29,
    /**
    * 和歌山県
    */
    WAKAYAMA: 30,
    /**
    * 鳥取県
    */
    TOTTORI: 31,
    /**
    * 島根県
    */
    SHIMANE: 32,
    /**
    * 岡山県
    */
    OKAYAMA: 33,
    /**
    * 広島県
    */
    HIROSHIMA: 34,
    /**
    * 山口県
    */
    YAMAGUCHI: 35,
    /**
    * 徳島県
    */
    TOKUSHIMA: 36,
    /**
    * 香川県
    */
    KAGAWA: 37,
    /**
    * 愛媛県
    */
    EHIME: 38,
    /**
    * 高知県
    */
    KOCHI: 39,
    /**
    * 福岡県
    */
    FUKUOKA: 40,
    /**
    * 佐賀県
    */
    SAGA: 41,
    /**
    * 長崎県
    */
    NAGASAKI: 42,
    /**
    * 熊本県
    */
    KUMAMOTO: 43,
    /**
    * 大分県
    */
    OITA: 44,
    /**
    * 宮崎県
    */
    MIYAZAKI: 45,
    /**
    * 鹿児島県
    */
    KAGOSHIMA: 46,
    /**
    * 沖縄県
    */
    OKINAWA: 47
} as const;

export type PrefectureEnum = typeof PrefectureEnum[keyof typeof PrefectureEnum];


/**
 * 物件登録画像情報
 * @export
 * @interface PropertyImageFiles
 */
export interface PropertyImageFiles {
    /**
     * S3キー
     * @type {string}
     * @memberof PropertyImageFiles
     */
    'S3Key'?: string;
    /**
     * URL
     * @type {string}
     * @memberof PropertyImageFiles
     */
    'Url'?: string;
    /**
     * 種類 * `0`: その他 * `1`: サムネイル * `2`: 間取り
     * @type {number}
     * @memberof PropertyImageFiles
     */
    'Type'?: PropertyImageFilesTypeEnum;
    /**
     * 順序
     * @type {number}
     * @memberof PropertyImageFiles
     */
    'Order'?: number;
    /**
     * コメント
     * @type {string}
     * @memberof PropertyImageFiles
     */
    'Comment'?: string;
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof PropertyImageFiles
     */
    'Filename'?: string;
}

export const PropertyImageFilesTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type PropertyImageFilesTypeEnum = typeof PropertyImageFilesTypeEnum[keyof typeof PropertyImageFilesTypeEnum];

/**
 * ステータス * `0`: 非公開 * `1`: 公開
 * @export
 * @enum {string}
 */

export const PropertyPublicStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type PropertyPublicStatus = typeof PropertyPublicStatus[keyof typeof PropertyPublicStatus];


/**
 * 
 * @export
 * @interface PropertySelectionSupportInquiry200Response
 */
export interface PropertySelectionSupportInquiry200Response {
    /**
     * ID
     * @type {number}
     * @memberof PropertySelectionSupportInquiry200Response
     */
    'id'?: number;
    /**
     * 会員ID
     * @type {number}
     * @memberof PropertySelectionSupportInquiry200Response
     */
    'member_id': number;
}
/**
 * 
 * @export
 * @interface PropertySelectionSupportInquiryRequest
 */
export interface PropertySelectionSupportInquiryRequest {
    /**
     * 苗字
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'familyName': string;
    /**
     * 名前
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'firstName': string;
    /**
     * フリガナ苗字
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'familyNameKana': string;
    /**
     * フリガナ名前
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'firstNameKana': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'phoneNumber': string;
    /**
     * 業種
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'industryType': number;
    /**
     * 業種詳細
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'industryDetail'?: string;
    /**
     * 開業予定地域
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'openArea': string;
    /**
     * 開業予定日
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'openDay': string;
    /**
     * 物件の状態
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'propertyCondition': number;
    /**
     * 面積以上
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'sizeFrom': number;
    /**
     * 面積以下
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'sizeTo': number;
    /**
     * 賃料以上
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'rentFrom': number;
    /**
     * 賃料以下
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'rentTo': number;
    /**
     * 階数
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'floor': number;
    /**
     * 最寄り駅までの徒歩時間
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'access': number;
    /**
     * 物件備考
     * @type {string}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'propertyRemark'?: string;
    /**
     * 法人or個人
     * @type {number}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'contractType': number;
    /**
     * 初回申し込みフラグ(初回の場合、true、それ以外はfalse)
     * @type {boolean}
     * @memberof PropertySelectionSupportInquiryRequest
     */
    'isFirst'?: boolean;
}
/**
 * 公開範囲 * `0`: 無料 * `1`: 会員 * `2`: 有料
 * @export
 * @enum {string}
 */

export const PublicRange = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type PublicRange = typeof PublicRange[keyof typeof PublicRange];


/**
 * ステータス * `0`: 非公開 * `1`: 公開
 * @export
 * @enum {string}
 */

export const PublicStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type PublicStatus = typeof PublicStatus[keyof typeof PublicStatus];


/**
 * 
 * @export
 * @interface PutPropertyRequest
 */
export interface PutPropertyRequest {
    /**
     * 物件ID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'id': number;
    /**
     * 運用者ID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'operator_id'?: number;
    /**
     * 物件名
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'name': string;
    /**
     * 土地面積
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'surface_area': number;
    /**
     * 面積
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'used_surface_area'?: number;
    /**
     * 坪数
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'tsubo': number;
    /**
     * 築年数
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'tikunennsu': string;
    /**
     * 最寄り駅徒歩n分1
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'access1'?: number;
    /**
     * 最寄り駅徒歩n分2
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'access2'?: number;
    /**
     * 最寄り駅徒歩n分3
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'access3'?: number;
    /**
     * 地上/地下
     * @type {boolean}
     * @memberof PutPropertyRequest
     */
    'ground_or_basement'?: boolean;
    /**
     * 階数
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'floor': string;
    /**
     * ビル全体の階数
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'biru_no_kaisu': number;
    /**
     * 郵便番号
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'post_number': string;
    /**
     * 住所_都道府県
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'address1': string;
    /**
     * 住所_市区町村
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'address2': string;
    /**
     * 住所_町域名
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'address3'?: string;
    /**
     * 住所_番地
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'address4'?: string;
    /**
     * ビル名
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'address5'?: string;
    /**
     * エリアID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'area_id'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'station_id1'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'station_id2'?: number;
    /**
     * 駅ID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'station_id3'?: number;
    /**
     * 前業態/テナント(新築/事務所/居酒屋/etc)
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'previous_style'?: number;
    /**
     * 状態（スケルトン、居抜き）
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'condition': number;
    /**
     * 設備
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'facility'?: string;
    /**
     * アピールコメント
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'appeal_comment': string;
    /**
     * 賃料
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'rent'?: number;
    /**
     * 管理費
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'management_fee': number;
    /**
     * 償却
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'depreciation'?: string;
    /**
     * 敷金
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'security_deposit'?: string;
    /**
     * 礼金
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'key_money': string;
    /**
     * 更新料
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'renewal_payment'?: string;
    /**
     * 仲介手数料
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'brokerage_fee'?: string;
    /**
     * 契約期間
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'agreement_period': string;
    /**
     * 契約形態
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'contract_type': number;
    /**
     * 構造
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'structure'?: number;
    /**
     * 出店可能業態
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'possible_usage': number;
    /**
     * 引渡し可能時期
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'possible_surrender'?: string;
    /**
     * 造作譲渡
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'creation_transfer'?: number;
    /**
     * 駐車場
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'parking_area'?: number;
    /**
     * 坪単価
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'tsubo_fee'?: number;
    /**
     * 不動産会社ID
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'real_estate_id'?: number;
    /**
     * 不動産会社メールアドレス
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'real_estate_email'?: string;
    /**
     * 備考
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'remarks'?: string;
    /**
     * サムネイル画像URL
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'thumbnail_url': string;
    /**
     * 間取り画像URL
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'madori_url'?: string;
    /**
     * その他画像URL
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'other_image_url'?: string;
    /**
     * 飲食店の種類
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'diner_type'?: number;
    /**
     * 条件
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'term'?: string;
    /**
     * 
     * @type {PropertyPublicStatus}
     * @memberof PutPropertyRequest
     */
    'public_status'?: PropertyPublicStatus;
    /**
     * 
     * @type {PublicRange}
     * @memberof PutPropertyRequest
     */
    'public_range'?: PublicRange;
    /**
     * 公開開始日時
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'public_start_at'?: string;
    /**
     * 公開終了日時
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'public_end_at'?: string;
    /**
     * 無料公開枠
     * @type {boolean}
     * @memberof PutPropertyRequest
     */
    'info_for_free'?: boolean;
    /**
     * 取引態様
     * @type {number}
     * @memberof PutPropertyRequest
     */
    'conditions_of_transactions'?: number;
    /**
     * 住宅総合保険等の損害保険料等を必要とするときはその旨及びその額
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'insurance_information'?: string;
    /**
     * 家賃保証会社等と契約することを条件とするときはその旨及びその額
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'guarantor_company_information'?: string;
    /**
     * 定期建物賃貸借であるときはその旨
     * @type {string}
     * @memberof PutPropertyRequest
     */
    'leasehold_right_information'?: string;
    /**
     * 削除フラグ
     * @type {boolean}
     * @memberof PutPropertyRequest
     */
    'delete_flg'?: boolean;
    /**
     * 
     * @type {Array<PropertyImageFiles>}
     * @memberof PutPropertyRequest
     */
    'files'?: Array<PropertyImageFiles>;
}


/**
 * 基準値リスト
 * @export
 * @interface ReferenceValueItem
 */
export interface ReferenceValueItem {
    /**
     * 区分名
     * @type {string}
     * @memberof ReferenceValueItem
     */
    'sectionName'?: string;
    /**
     * 基準値
     * @type {string}
     * @memberof ReferenceValueItem
     */
    'referenceValue'?: string;
}
/**
 * 
 * @export
 * @interface RegisterLineMessagingIdRequest
 */
export interface RegisterLineMessagingIdRequest {
    /**
     * 会員ID
     * @type {number}
     * @memberof RegisterLineMessagingIdRequest
     */
    'memberId': number;
    /**
     * LINE ID
     * @type {string}
     * @memberof RegisterLineMessagingIdRequest
     */
    'lineMessagingId': string;
    /**
     * LINE表示名
     * @type {string}
     * @memberof RegisterLineMessagingIdRequest
     */
    'lineMessagingDisplayName'?: string;
}
/**
 * reCapchaレスポンス
 * @export
 * @interface Registration
 */
export interface Registration {
    /**
     * reCapchaレスポンス
     * @type {string}
     * @memberof Registration
     */
    'recapcha_response': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof Registration
     */
    'email': string;
    /**
     * 認証コード
     * @type {string}
     * @memberof Registration
     */
    'checksum'?: string;
    /**
     * メール配信フラグ
     * @type {boolean}
     * @memberof Registration
     */
    'mailCheck'?: boolean;
    /**
     * ニックネーム
     * @type {string}
     * @memberof Registration
     */
    'nick_name'?: string;
    /**
     * パスワード
     * @type {string}
     * @memberof Registration
     */
    'password'?: string;
    /**
     * 生年月日
     * @type {string}
     * @memberof Registration
     */
    'birthday'?: string;
    /**
     * 性別
     * @type {number}
     * @memberof Registration
     */
    'gender'?: number;
    /**
     * 飲食店経験有無
     * @type {number}
     * @memberof Registration
     */
    'diner_experience'?: number;
    /**
     * 飲食店経験有種別リスト
     * @type {Array<number>}
     * @memberof Registration
     */
    'diner_exp_type'?: Array<number>;
    /**
     * 出店予定時期
     * @type {number}
     * @memberof Registration
     */
    'opn_sched_time'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof Registration
     */
    'companyName'?: string;
    /**
     * 開業資金額
     * @type {number}
     * @memberof Registration
     */
    'openingFunds'?: number;
    /**
     * 開業状況
     * @type {string}
     * @memberof Registration
     */
    'openingStatus'?: string;
    /**
     * 自己資金額
     * @type {number}
     * @memberof Registration
     */
    'ownFunds'?: number;
    /**
     * 開業予定業種
     * @type {number}
     * @memberof Registration
     */
    'openingIndustryType'?: number;
    /**
     * 既存店数
     * @type {number}
     * @memberof Registration
     */
    'existingStoreCount'?: number;
    /**
     * 開業予定エリア（都道府県）
     * @type {number}
     * @memberof Registration
     */
    'openingPrefecture'?: number;
    /**
     * Cognito ID
     * @type {string}
     * @memberof Registration
     */
    'cognitoId'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof Registration
     */
    'phoneNumber'?: string;
    /**
     * 新規登録後リダイレクト先パス
     * @type {string}
     * @memberof Registration
     */
    'postSignupRedirectPath'?: string;
    /**
     * 開業予定者フラグ
     * @type {boolean}
     * @memberof Registration
     */
    'willOpenFlg'?: boolean;
    /**
     * 事業形態
     * @type {number}
     * @memberof Registration
     */
    'businessType'?: number;
    /**
     * 店舗数
     * @type {number}
     * @memberof Registration
     */
    'storeCount'?: number;
    /**
     * 利用中システム
     * @type {string}
     * @memberof Registration
     */
    'usedSystem'?: string;
    /**
     * 悩み事
     * @type {string}
     * @memberof Registration
     */
    'concern'?: string;
    /**
     * 将来の展望
     * @type {string}
     * @memberof Registration
     */
    'futureVision'?: string;
    /**
     * 苗字
     * @type {string}
     * @memberof Registration
     */
    'familyName'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof Registration
     */
    'firstName'?: string;
    /**
     * 苗字カナ
     * @type {string}
     * @memberof Registration
     */
    'familyNameKana'?: string;
    /**
     * 名前カナ
     * @type {string}
     * @memberof Registration
     */
    'firstNameKana'?: string;
    /**
     * 
     * @type {Array<MemberStoreTemp>}
     * @memberof Registration
     */
    'memberStores'?: Array<MemberStoreTemp>;
}
/**
 * 
 * @export
 * @interface ResetPasswordConfirm200Response
 */
export interface ResetPasswordConfirm200Response {
    /**
     * 
     * @type {ResetPasswordConfirm200ResponseBody}
     * @memberof ResetPasswordConfirm200Response
     */
    'body': ResetPasswordConfirm200ResponseBody;
}
/**
 * 
 * @export
 * @interface ResetPasswordConfirm200ResponseBody
 */
export interface ResetPasswordConfirm200ResponseBody {
    /**
     * メールアドレス
     * @type {string}
     * @memberof ResetPasswordConfirm200ResponseBody
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SearchPostNumber200Response
 */
export interface SearchPostNumber200Response {
    /**
     * 
     * @type {SearchPostNumber200ResponseBody}
     * @memberof SearchPostNumber200Response
     */
    'body': SearchPostNumber200ResponseBody;
}
/**
 * 
 * @export
 * @interface SearchPostNumber200ResponseBody
 */
export interface SearchPostNumber200ResponseBody {
    /**
     * 
     * @type {GetMPrefectureList200ResponseBodyPrefecturesInner}
     * @memberof SearchPostNumber200ResponseBody
     */
    'prefecture'?: GetMPrefectureList200ResponseBodyPrefecturesInner;
    /**
     * 
     * @type {SearchPostNumber200ResponseBodyArea}
     * @memberof SearchPostNumber200ResponseBody
     */
    'area'?: SearchPostNumber200ResponseBodyArea;
    /**
     * 郵便番号
     * @type {string}
     * @memberof SearchPostNumber200ResponseBody
     */
    'post_number'?: string;
}
/**
 * 
 * @export
 * @interface SearchPostNumber200ResponseBodyArea
 */
export interface SearchPostNumber200ResponseBodyArea {
    /**
     * エリアID
     * @type {number}
     * @memberof SearchPostNumber200ResponseBodyArea
     */
    'id': number;
    /**
     * エリア名
     * @type {string}
     * @memberof SearchPostNumber200ResponseBodyArea
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UpdateEmailRequest
 */
export interface UpdateEmailRequest {
    /**
     * メールアドレス
     * @type {string}
     * @memberof UpdateEmailRequest
     */
    'email': string;
    /**
     * パスワード
     * @type {string}
     * @memberof UpdateEmailRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface UpdateInteriorDesignCompanyFilterItemsRequestBody
 */
export interface UpdateInteriorDesignCompanyFilterItemsRequestBody {
    /**
     * 内装会社ID
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyFilterItemsRequestBody
     */
    'interior_design_company_id': number;
    /**
     * 案件受け取りフラグ
     * @type {boolean}
     * @memberof UpdateInteriorDesignCompanyFilterItemsRequestBody
     */
    'receive_order_flg'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateInteriorDesignCompanyFilterItemsRequestBody
     */
    'prefectures'?: Array<number>;
    /**
     * 内装費予算
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyFilterItemsRequestBody
     */
    'interior_budget'?: number;
    /**
     * 工事坪単価
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyFilterItemsRequestBody
     */
    'construction_cost_per_tsubo'?: number;
}
/**
 * 
 * @export
 * @interface UpdateInteriorDesignCompanyRequestBody
 */
export interface UpdateInteriorDesignCompanyRequestBody {
    /**
     * 会員ID
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'id': number;
    /**
     * 名前
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'name': string;
    /**
     * 所在地
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'address'?: string;
    /**
     * 設立年
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'established_year'?: string;
    /**
     * 従業員数
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'employee_count'?: number;
    /**
     * 飲食店施工実績件数
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'construction_restaurant_count'?: number;
    /**
     * 得意な飲食店業種やテイスト
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'specialties'?: string;
    /**
     * 対応可能エリア
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'service_prefectures'?: string;
    /**
     * 特徴
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'features'?: string;
    /**
     * アピールポイント
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'appeal_point'?: string;
    /**
     * HPのURL
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'url'?: string;
    /**
     * 代表者名
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'representative_name'?: string;
    /**
     * 可能役務（物件選定、設計施工、デザインのみ、施工のみ）
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'available_services'?: string;
    /**
     * 目安坪単価（円）
     * @type {number}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'unit_price_per_tsubo'?: number;
    /**
     * 建設業許可番号
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'license_number'?: string;
    /**
     * 
     * @type {Array<ConstructionCaseImages>}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'image_urls'?: Array<ConstructionCaseImages>;
    /**
     * 担当者名
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'contact_name'?: string;
    /**
     * 担当者名カナ
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'contact_kana'?: string;
    /**
     * 担当者電話番号
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'contact_phone_number'?: string;
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof UpdateInteriorDesignCompanyRequestBody
     */
    'contact_email_address'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMailLetterSettingRequest
 */
export interface UpdateMailLetterSettingRequest {
    /**
     * コラム配信フラグ
     * @type {boolean}
     * @memberof UpdateMailLetterSettingRequest
     */
    'column_flg': boolean;
    /**
     * セミナー配信フラグ
     * @type {boolean}
     * @memberof UpdateMailLetterSettingRequest
     */
    'seminar_flg': boolean;
    /**
     * キャンペーン配信フラグ
     * @type {boolean}
     * @memberof UpdateMailLetterSettingRequest
     */
    'campaign_flg': boolean;
    /**
     * 新着物件配信フラグ
     * @type {boolean}
     * @memberof UpdateMailLetterSettingRequest
     */
    'property_flg': boolean;
    /**
     * 新着物件配信初期設定フラグ
     * @type {boolean}
     * @memberof UpdateMailLetterSettingRequest
     */
    'property_init_flg'?: boolean;
    /**
     * 物件LINEメッセージ配信フラグ
     * @type {boolean}
     * @memberof UpdateMailLetterSettingRequest
     */
    'property_line_messaging_flg'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateMemberRequest
 */
export interface UpdateMemberRequest {
    /**
     * 苗字
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'family_name'?: string;
    /**
     * 名前
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'first_name'?: string;
    /**
     * 苗字カナ
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'familyNameKana'?: string;
    /**
     * 名前カナ
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'firstNameKana'?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'post_number'?: string;
    /**
     * 都道府県
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'prefecture'?: number;
    /**
     * 市区町村
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'city'?: number;
    /**
     * 番地
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'street_address'?: string;
    /**
     * 番地
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'building'?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'phone_number'?: string;
    /**
     * ニックネーム
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'nickname'?: string;
    /**
     * 生年月日
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'birthday'?: string;
    /**
     * 性別
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'gender'?: number;
    /**
     * 飲食店経験有無
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'diner_experience'?: number;
    /**
     * 飲食店経験有種別リスト
     * @type {Array<number>}
     * @memberof UpdateMemberRequest
     */
    'diner_exp_type'?: Array<number>;
    /**
     * 出店予定時期
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'opn_sched_time'?: number;
    /**
     * 会社名（法人名）
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'company_name'?: string;
    /**
     * 担当コンサルタントID
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'rep_consultant_id'?: number;
    /**
     * 利用規約同意日時
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'terms_agreed_at'?: string;
    /**
     * 利用規約文書更新日時
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'terms_updated_at'?: string;
    /**
     * 開業資金額
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'openingFunds'?: number;
    /**
     * 開業状況
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'openingStatus'?: string;
    /**
     * 自己資金額
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'ownFunds'?: number;
    /**
     * 開業予定業種
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'openingIndustryType'?: number;
    /**
     * 既存店数
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'existingStoreCount'?: number;
    /**
     * 開業予定エリア（都道府県）
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'openingPrefecture'?: number;
    /**
     * 事業形態
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'businessType'?: number;
    /**
     * 店舗数
     * @type {number}
     * @memberof UpdateMemberRequest
     */
    'storeCount'?: number;
    /**
     * 利用中システム
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'usedSystem'?: string;
    /**
     * 悩み事
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'concern'?: string;
    /**
     * 将来の展望
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'futureVision'?: string;
    /**
     * 
     * @type {Array<MemberStore>}
     * @memberof UpdateMemberRequest
     */
    'memberStores'?: Array<MemberStore>;
    /**
     * LINE ID
     * @type {string}
     * @memberof UpdateMemberRequest
     */
    'lineMessagingId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateOpeMailLetterAgree200Response
 */
export interface UpdateOpeMailLetterAgree200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateOpeMailLetterAgree200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
    /**
     * 旧パスワード
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    'old_password': string;
    /**
     * 新パスワード
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    'new_password': string;
}
/**
 * 
 * @export
 * @interface UpdatePasswordResetRequest
 */
export interface UpdatePasswordResetRequest {
    /**
     * 新パスワード
     * @type {string}
     * @memberof UpdatePasswordResetRequest
     */
    'new_password': string;
    /**
     * 管理者かどうか
     * @type {boolean}
     * @memberof UpdatePasswordResetRequest
     */
    'isAdmin'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateQualifiedRankForce200Response
 */
export interface UpdateQualifiedRankForce200Response {
    /**
     * 
     * @type {UpdateQualifiedRankForce200ResponseBody}
     * @memberof UpdateQualifiedRankForce200Response
     */
    'body': UpdateQualifiedRankForce200ResponseBody;
}
/**
 * 
 * @export
 * @interface UpdateQualifiedRankForce200ResponseBody
 */
export interface UpdateQualifiedRankForce200ResponseBody {
    /**
     * Cognito ID
     * @type {string}
     * @memberof UpdateQualifiedRankForce200ResponseBody
     */
    'cognito_id': string;
    /**
     * QualifiedRank
     * @type {number}
     * @memberof UpdateQualifiedRankForce200ResponseBody
     */
    'qualified_rank': number;
}
/**
 * 
 * @export
 * @interface UploadConstructionCaseImage
 */
export interface UploadConstructionCaseImage {
    /**
     * ID
     * @type {number}
     * @memberof UploadConstructionCaseImage
     */
    'id'?: number;
    /**
     * 事例ID
     * @type {number}
     * @memberof UploadConstructionCaseImage
     */
    'construction_case_id'?: number;
    /**
     * 事例画像URL
     * @type {string}
     * @memberof UploadConstructionCaseImage
     */
    'image_url'?: string;
    /**
     * base64ファイルデータ
     * @type {string}
     * @memberof UploadConstructionCaseImage
     */
    'payload'?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof UploadConstructionCaseImage
     */
    'file_name'?: string;
}
/**
 * 
 * @export
 * @interface UploadDesignPatternImage200Response
 */
export interface UploadDesignPatternImage200Response {
    /**
     * 
     * @type {UploadDesignPatternImage200ResponseBody}
     * @memberof UploadDesignPatternImage200Response
     */
    'body': UploadDesignPatternImage200ResponseBody;
}
/**
 * 
 * @export
 * @interface UploadDesignPatternImage200ResponseBody
 */
export interface UploadDesignPatternImage200ResponseBody {
    /**
     * URL
     * @type {string}
     * @memberof UploadDesignPatternImage200ResponseBody
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof UploadDesignPatternImage200ResponseBody
     */
    'dummy_for_design_pattern_image_upload'?: number;
}
/**
 * 
 * @export
 * @interface UploadDesignPatternImageRequest
 */
export interface UploadDesignPatternImageRequest {
    /**
     * ファイル名
     * @type {string}
     * @memberof UploadDesignPatternImageRequest
     */
    'filename': string;
    /**
     * base64ファイルデータ
     * @type {string}
     * @memberof UploadDesignPatternImageRequest
     */
    'payload': string;
}
/**
 * 
 * @export
 * @interface UploadPropertyImage200Response
 */
export interface UploadPropertyImage200Response {
    /**
     * 
     * @type {UploadPropertyImage200ResponseBody}
     * @memberof UploadPropertyImage200Response
     */
    'body': UploadPropertyImage200ResponseBody;
}
/**
 * 
 * @export
 * @interface UploadPropertyImage200ResponseBody
 */
export interface UploadPropertyImage200ResponseBody {
    /**
     * URL
     * @type {string}
     * @memberof UploadPropertyImage200ResponseBody
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof UploadPropertyImage200ResponseBody
     */
    'dummy_for_property_image_upload'?: number;
}
/**
 * 
 * @export
 * @interface UploadPropertyImageRequest
 */
export interface UploadPropertyImageRequest {
    /**
     * 表示用ファイル名
     * @type {string}
     * @memberof UploadPropertyImageRequest
     */
    'filename': string;
    /**
     * base64ファイルデータ
     * @type {string}
     * @memberof UploadPropertyImageRequest
     */
    'payload': string;
    /**
     * 
     * @type {number}
     * @memberof UploadPropertyImageRequest
     */
    'dummy_for_property_image_upload'?: number;
}
/**
 * 
 * @export
 * @interface VerifyEmail200Response
 */
export interface VerifyEmail200Response {
    /**
     * パスワード
     * @type {string}
     * @memberof VerifyEmail200Response
     */
    'password'?: string;
    /**
     * 新規登録後リダイレクト先パス
     * @type {string}
     * @memberof VerifyEmail200Response
     */
    'postSignupRedirectPath'?: string;
}
/**
 * Who (誰に) 入力・選択項目
 * @export
 * @interface WhoInputDetail
 */
export interface WhoInputDetail {
    /**
     * Who (誰に) 年代リスト
     * @type {Array<number>}
     * @memberof WhoInputDetail
     */
    'age_groups'?: Array<number>;
    /**
     * Who (誰に) 性別リスト
     * @type {Array<number>}
     * @memberof WhoInputDetail
     */
    'genders'?: Array<number>;
    /**
     * Who (誰に) 職業リスト
     * @type {Array<number>}
     * @memberof WhoInputDetail
     */
    'jobs'?: Array<number>;
    /**
     * When (いつ) 利用シーンリスト
     * @type {Array<number>}
     * @memberof WhoInputDetail
     */
    'use_scenes'?: Array<number>;
    /**
     * Who (誰に) 職業その他
     * @type {string}
     * @memberof WhoInputDetail
     */
    'industry_other'?: string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ログイン処理を実施する。
         * @summary ログイン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者のログイン処理を実施する。
         * @summary 運用認証
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginForAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * ログイン処理を実施する。
         * @summary ログイン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者のログイン処理を実施する。
         * @summary 運用認証
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLoginForAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLoginForAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginForAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * ログイン処理を実施する。
         * @summary ログイン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogin(options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.authLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者のログイン処理を実施する。
         * @summary 運用認証
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginForAdmin(options?: any): AxiosPromise<AuthLoginForAdmin200Response> {
            return localVarFp.authLoginForAdmin(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * ログイン処理を実施する。
     * @summary ログイン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authLogin(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者のログイン処理を実施する。
     * @summary 運用認証
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authLoginForAdmin(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authLoginForAdmin(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BalanceApi - axios parameter creator
 * @export
 */
export const BalanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 簡易損益シミュレーションを取得する
         * @summary 簡易損益シミュレーション取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalance: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceApi - functional programming interface
 * @export
 */
export const BalanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 簡易損益シミュレーションを取得する
         * @summary 簡易損益シミュレーション取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalance(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBalance200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalance(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BalanceApi - factory interface
 * @export
 */
export const BalanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalanceApiFp(configuration)
    return {
        /**
         * 簡易損益シミュレーションを取得する
         * @summary 簡易損益シミュレーション取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalance(uid?: string, options?: any): AxiosPromise<GetBalance200Response> {
            return localVarFp.getBalance(uid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BalanceApi - object-oriented interface
 * @export
 * @class BalanceApi
 * @extends {BaseAPI}
 */
export class BalanceApi extends BaseAPI {
    /**
     * 簡易損益シミュレーションを取得する
     * @summary 簡易損益シミュレーション取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public getBalance(uid?: string, options?: AxiosRequestConfig) {
        return BalanceApiFp(this.configuration).getBalance(uid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BalanceSimulateApi - axios parameter creator
 * @export
 */
export const BalanceSimulateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザの簡易損益シミュレーションを行って結果も保存する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 簡易損益シミュレーション実行
         * @param {string} [uid] 会員ID
         * @param {BalanceInput} [balanceInput] 簡易損益シミュレーション実行リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateBalance: async (uid?: string, balanceInput?: BalanceInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/balance/simulate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(balanceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceSimulateApi - functional programming interface
 * @export
 */
export const BalanceSimulateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalanceSimulateApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザの簡易損益シミュレーションを行って結果も保存する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 簡易損益シミュレーション実行
         * @param {string} [uid] 会員ID
         * @param {BalanceInput} [balanceInput] 簡易損益シミュレーション実行リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateBalance(uid?: string, balanceInput?: BalanceInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBalance200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateBalance(uid, balanceInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BalanceSimulateApi - factory interface
 * @export
 */
export const BalanceSimulateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalanceSimulateApiFp(configuration)
    return {
        /**
         * ユーザの簡易損益シミュレーションを行って結果も保存する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 簡易損益シミュレーション実行
         * @param {string} [uid] 会員ID
         * @param {BalanceInput} [balanceInput] 簡易損益シミュレーション実行リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateBalance(uid?: string, balanceInput?: BalanceInput, options?: any): AxiosPromise<GetBalance200Response> {
            return localVarFp.simulateBalance(uid, balanceInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BalanceSimulateApi - object-oriented interface
 * @export
 * @class BalanceSimulateApi
 * @extends {BaseAPI}
 */
export class BalanceSimulateApi extends BaseAPI {
    /**
     * ユーザの簡易損益シミュレーションを行って結果も保存する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 簡易損益シミュレーション実行
     * @param {string} [uid] 会員ID
     * @param {BalanceInput} [balanceInput] 簡易損益シミュレーション実行リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceSimulateApi
     */
    public simulateBalance(uid?: string, balanceInput?: BalanceInput, options?: AxiosRequestConfig) {
        return BalanceSimulateApiFp(this.configuration).simulateBalance(uid, balanceInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConceptCreateApi - axios parameter creator
 * @export
 */
export const ConceptCreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザの店舗コンセプトをアンケート形式で簡単に作成する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 店舗コンセプト作成
         * @param {string} [uid] 会員ID
         * @param {ConceptInput} [conceptInput] 店舗コンセプト作成リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConcept: async (uid?: string, conceptInput?: ConceptInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/concept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conceptInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConceptCreateApi - functional programming interface
 * @export
 */
export const ConceptCreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConceptCreateApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザの店舗コンセプトをアンケート形式で簡単に作成する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 店舗コンセプト作成
         * @param {string} [uid] 会員ID
         * @param {ConceptInput} [conceptInput] 店舗コンセプト作成リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConcept(uid?: string, conceptInput?: ConceptInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConcept200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConcept(uid, conceptInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConceptCreateApi - factory interface
 * @export
 */
export const ConceptCreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConceptCreateApiFp(configuration)
    return {
        /**
         * ユーザの店舗コンセプトをアンケート形式で簡単に作成する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 店舗コンセプト作成
         * @param {string} [uid] 会員ID
         * @param {ConceptInput} [conceptInput] 店舗コンセプト作成リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConcept(uid?: string, conceptInput?: ConceptInput, options?: any): AxiosPromise<GetConcept200Response> {
            return localVarFp.createConcept(uid, conceptInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConceptCreateApi - object-oriented interface
 * @export
 * @class ConceptCreateApi
 * @extends {BaseAPI}
 */
export class ConceptCreateApi extends BaseAPI {
    /**
     * ユーザの店舗コンセプトをアンケート形式で簡単に作成する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I004Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 店舗コンセプト作成
     * @param {string} [uid] 会員ID
     * @param {ConceptInput} [conceptInput] 店舗コンセプト作成リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConceptCreateApi
     */
    public createConcept(uid?: string, conceptInput?: ConceptInput, options?: AxiosRequestConfig) {
        return ConceptCreateApiFp(this.configuration).createConcept(uid, conceptInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConceptFileGetApi - axios parameter creator
 * @export
 */
export const ConceptFileGetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザの店舗コンセプトを出力する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 店舗コンセプトDL
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConceptFile: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/concept/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConceptFileGetApi - functional programming interface
 * @export
 */
export const ConceptFileGetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConceptFileGetApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザの店舗コンセプトを出力する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 店舗コンセプトDL
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConceptFile(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConceptFile(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConceptFileGetApi - factory interface
 * @export
 */
export const ConceptFileGetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConceptFileGetApiFp(configuration)
    return {
        /**
         * ユーザの店舗コンセプトを出力する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 店舗コンセプトDL
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConceptFile(uid?: string, options?: any): AxiosPromise<File> {
            return localVarFp.getConceptFile(uid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConceptFileGetApi - object-oriented interface
 * @export
 * @class ConceptFileGetApi
 * @extends {BaseAPI}
 */
export class ConceptFileGetApi extends BaseAPI {
    /**
     * ユーザの店舗コンセプトを出力する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/parameters/QueryUserId   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 店舗コンセプトDL
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConceptFileGetApi
     */
    public getConceptFile(uid?: string, options?: AxiosRequestConfig) {
        return ConceptFileGetApiFp(this.configuration).getConceptFile(uid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConceptGetApi - axios parameter creator
 * @export
 */
export const ConceptGetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザの店舗コンセプトを取得する。
         * @summary 店舗コンセプト取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConcept: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/concept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConceptGetApi - functional programming interface
 * @export
 */
export const ConceptGetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConceptGetApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザの店舗コンセプトを取得する。
         * @summary 店舗コンセプト取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConcept(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConcept200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConcept(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConceptGetApi - factory interface
 * @export
 */
export const ConceptGetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConceptGetApiFp(configuration)
    return {
        /**
         * ユーザの店舗コンセプトを取得する。
         * @summary 店舗コンセプト取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConcept(uid?: string, options?: any): AxiosPromise<GetConcept200Response> {
            return localVarFp.getConcept(uid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConceptGetApi - object-oriented interface
 * @export
 * @class ConceptGetApi
 * @extends {BaseAPI}
 */
export class ConceptGetApi extends BaseAPI {
    /**
     * ユーザの店舗コンセプトを取得する。
     * @summary 店舗コンセプト取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConceptGetApi
     */
    public getConcept(uid?: string, options?: AxiosRequestConfig) {
        return ConceptGetApiFp(this.configuration).getConcept(uid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConceptPlanFileApi - axios parameter creator
 * @export
 */
export const ConceptPlanFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 事業計画、商圏分析、資金繰り計画書、融資申込書をダウンロードする
         * @summary 各種ファイルDL
         * @param {string} conceptPlanFileId ファイルID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConceptPlanFile: async (conceptPlanFileId: string, uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conceptPlanFileId' is not null or undefined
            assertParamExists('downloadConceptPlanFile', 'conceptPlanFileId', conceptPlanFileId)
            const localVarPath = `/user/concept/plan/file/{concept_plan_file_id}`
                .replace(`{${"concept_plan_file_id"}}`, encodeURIComponent(String(conceptPlanFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConceptPlanFileApi - functional programming interface
 * @export
 */
export const ConceptPlanFileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConceptPlanFileApiAxiosParamCreator(configuration)
    return {
        /**
         * 事業計画、商圏分析、資金繰り計画書、融資申込書をダウンロードする
         * @summary 各種ファイルDL
         * @param {string} conceptPlanFileId ファイルID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadConceptPlanFile(conceptPlanFileId: string, uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadConceptPlanFile(conceptPlanFileId, uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConceptPlanFileApi - factory interface
 * @export
 */
export const ConceptPlanFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConceptPlanFileApiFp(configuration)
    return {
        /**
         * 事業計画、商圏分析、資金繰り計画書、融資申込書をダウンロードする
         * @summary 各種ファイルDL
         * @param {string} conceptPlanFileId ファイルID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadConceptPlanFile(conceptPlanFileId: string, uid?: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadConceptPlanFile(conceptPlanFileId, uid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConceptPlanFileApi - object-oriented interface
 * @export
 * @class ConceptPlanFileApi
 * @extends {BaseAPI}
 */
export class ConceptPlanFileApi extends BaseAPI {
    /**
     * 事業計画、商圏分析、資金繰り計画書、融資申込書をダウンロードする
     * @summary 各種ファイルDL
     * @param {string} conceptPlanFileId ファイルID
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConceptPlanFileApi
     */
    public downloadConceptPlanFile(conceptPlanFileId: string, uid?: string, options?: AxiosRequestConfig) {
        return ConceptPlanFileApiFp(this.configuration).downloadConceptPlanFile(conceptPlanFileId, uid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * システム全体の問い合わせのためメールを行う。
         * @summary 問合せ
         * @param {ContactRequest} contactRequest 問合せリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contact: async (contactRequest: ContactRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactRequest' is not null or undefined
            assertParamExists('contact', 'contactRequest', contactRequest)
            const localVarPath = `/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * システム全体の問い合わせのためメールを行う。
         * @summary 問合せ
         * @param {ContactRequest} contactRequest 問合せリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contact(contactRequest: ContactRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contact200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contact(contactRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * システム全体の問い合わせのためメールを行う。
         * @summary 問合せ
         * @param {ContactRequest} contactRequest 問合せリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contact(contactRequest: ContactRequest, options?: any): AxiosPromise<Contact200Response> {
            return localVarFp.contact(contactRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * システム全体の問い合わせのためメールを行う。
     * @summary 問合せ
     * @param {ContactRequest} contactRequest 問合せリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public contact(contactRequest: ContactRequest, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).contact(contactRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DesignMatchingApi - axios parameter creator
 * @export
 */
export const DesignMatchingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会員が内装会社をマッチングするか否かを選択する
         * @summary 内装会社マッチング成否選択
         * @param {ChooseDesignMatchingRequest} chooseDesignMatchingRequest 内装会社マッチング成否
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chooseDesignMatching: async (chooseDesignMatchingRequest: ChooseDesignMatchingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chooseDesignMatchingRequest' is not null or undefined
            assertParamExists('chooseDesignMatching', 'chooseDesignMatchingRequest', chooseDesignMatchingRequest)
            const localVarPath = `/design_matching/choose`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chooseDesignMatchingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員が内装会社の詳細を取得する
         * @summary 内装会社の詳細情報を取得する
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignMatchingDetail: async (interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design_matching/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }

            if (interiorDesignOrderId !== undefined) {
                localVarQueryParameter['interior_design_order_id'] = interiorDesignOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員が内装会社マッチング申込一覧を取得する
         * @summary 申込一覧取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignMatchingOrderList: async (memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design_matching/order_list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員が出した案件に対してエントリーした内装会社を取得する
         * @summary エントリーした内装会社を取得する
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCompanyList: async (interiorDesignOrderId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design_matching/enrty_list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignOrderId !== undefined) {
                localVarQueryParameter['interior_design_order_id'] = interiorDesignOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員が出した案件に対してマッチングした内装会社を取得する
         * @summary マッチングした内装会社を取得する
         * @param {Array<number>} [interiorDesignOrderId] 内装案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstablishedMatchingCompanyList: async (interiorDesignOrderId?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design_matching/established_matching_list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignOrderId) {
                localVarQueryParameter['interior_design_order_id'] = interiorDesignOrderId.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会社IDと案件IDからマッチング済みかどうかを返す
         * @summary マッチング済みかどうかを返す
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIsMatched: async (interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design_matching/is_matched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }

            if (interiorDesignOrderId !== undefined) {
                localVarQueryParameter['interior_design_order_id'] = interiorDesignOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignMatchingApi - functional programming interface
 * @export
 */
export const DesignMatchingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesignMatchingApiAxiosParamCreator(configuration)
    return {
        /**
         * 会員が内装会社をマッチングするか否かを選択する
         * @summary 内装会社マッチング成否選択
         * @param {ChooseDesignMatchingRequest} chooseDesignMatchingRequest 内装会社マッチング成否
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chooseDesignMatching(chooseDesignMatchingRequest: ChooseDesignMatchingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChooseDesignMatching200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chooseDesignMatching(chooseDesignMatchingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員が内装会社の詳細を取得する
         * @summary 内装会社の詳細情報を取得する
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignMatchingDetail(interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDesignMatchingDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignMatchingDetail(interiorDesignCompanyId, interiorDesignOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員が内装会社マッチング申込一覧を取得する
         * @summary 申込一覧取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignMatchingOrderList(memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDesignMatchingOrderList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignMatchingOrderList(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員が出した案件に対してエントリーした内装会社を取得する
         * @summary エントリーした内装会社を取得する
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntryCompanyList(interiorDesignOrderId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEntryCompanyList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntryCompanyList(interiorDesignOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員が出した案件に対してマッチングした内装会社を取得する
         * @summary マッチングした内装会社を取得する
         * @param {Array<number>} [interiorDesignOrderId] 内装案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstablishedMatchingCompanyList(interiorDesignOrderId?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEstablishedMatchingCompanyList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstablishedMatchingCompanyList(interiorDesignOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会社IDと案件IDからマッチング済みかどうかを返す
         * @summary マッチング済みかどうかを返す
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIsMatched(interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIsMatched200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIsMatched(interiorDesignCompanyId, interiorDesignOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesignMatchingApi - factory interface
 * @export
 */
export const DesignMatchingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesignMatchingApiFp(configuration)
    return {
        /**
         * 会員が内装会社をマッチングするか否かを選択する
         * @summary 内装会社マッチング成否選択
         * @param {ChooseDesignMatchingRequest} chooseDesignMatchingRequest 内装会社マッチング成否
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chooseDesignMatching(chooseDesignMatchingRequest: ChooseDesignMatchingRequest, options?: any): AxiosPromise<ChooseDesignMatching200Response> {
            return localVarFp.chooseDesignMatching(chooseDesignMatchingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員が内装会社の詳細を取得する
         * @summary 内装会社の詳細情報を取得する
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignMatchingDetail(interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options?: any): AxiosPromise<GetDesignMatchingDetail200Response> {
            return localVarFp.getDesignMatchingDetail(interiorDesignCompanyId, interiorDesignOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員が内装会社マッチング申込一覧を取得する
         * @summary 申込一覧取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignMatchingOrderList(memberId?: number, options?: any): AxiosPromise<Array<GetDesignMatchingOrderList200ResponseInner>> {
            return localVarFp.getDesignMatchingOrderList(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員が出した案件に対してエントリーした内装会社を取得する
         * @summary エントリーした内装会社を取得する
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryCompanyList(interiorDesignOrderId?: number, options?: any): AxiosPromise<Array<GetEntryCompanyList200ResponseInner>> {
            return localVarFp.getEntryCompanyList(interiorDesignOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員が出した案件に対してマッチングした内装会社を取得する
         * @summary マッチングした内装会社を取得する
         * @param {Array<number>} [interiorDesignOrderId] 内装案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstablishedMatchingCompanyList(interiorDesignOrderId?: Array<number>, options?: any): AxiosPromise<Array<GetEstablishedMatchingCompanyList200ResponseInner>> {
            return localVarFp.getEstablishedMatchingCompanyList(interiorDesignOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 会社IDと案件IDからマッチング済みかどうかを返す
         * @summary マッチング済みかどうかを返す
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIsMatched(interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options?: any): AxiosPromise<GetIsMatched200Response> {
            return localVarFp.getIsMatched(interiorDesignCompanyId, interiorDesignOrderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesignMatchingApi - object-oriented interface
 * @export
 * @class DesignMatchingApi
 * @extends {BaseAPI}
 */
export class DesignMatchingApi extends BaseAPI {
    /**
     * 会員が内装会社をマッチングするか否かを選択する
     * @summary 内装会社マッチング成否選択
     * @param {ChooseDesignMatchingRequest} chooseDesignMatchingRequest 内装会社マッチング成否
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignMatchingApi
     */
    public chooseDesignMatching(chooseDesignMatchingRequest: ChooseDesignMatchingRequest, options?: AxiosRequestConfig) {
        return DesignMatchingApiFp(this.configuration).chooseDesignMatching(chooseDesignMatchingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員が内装会社の詳細を取得する
     * @summary 内装会社の詳細情報を取得する
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignMatchingApi
     */
    public getDesignMatchingDetail(interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options?: AxiosRequestConfig) {
        return DesignMatchingApiFp(this.configuration).getDesignMatchingDetail(interiorDesignCompanyId, interiorDesignOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員が内装会社マッチング申込一覧を取得する
     * @summary 申込一覧取得
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignMatchingApi
     */
    public getDesignMatchingOrderList(memberId?: number, options?: AxiosRequestConfig) {
        return DesignMatchingApiFp(this.configuration).getDesignMatchingOrderList(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員が出した案件に対してエントリーした内装会社を取得する
     * @summary エントリーした内装会社を取得する
     * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignMatchingApi
     */
    public getEntryCompanyList(interiorDesignOrderId?: number, options?: AxiosRequestConfig) {
        return DesignMatchingApiFp(this.configuration).getEntryCompanyList(interiorDesignOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員が出した案件に対してマッチングした内装会社を取得する
     * @summary マッチングした内装会社を取得する
     * @param {Array<number>} [interiorDesignOrderId] 内装案件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignMatchingApi
     */
    public getEstablishedMatchingCompanyList(interiorDesignOrderId?: Array<number>, options?: AxiosRequestConfig) {
        return DesignMatchingApiFp(this.configuration).getEstablishedMatchingCompanyList(interiorDesignOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会社IDと案件IDからマッチング済みかどうかを返す
     * @summary マッチング済みかどうかを返す
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignMatchingApi
     */
    public getIsMatched(interiorDesignCompanyId?: number, interiorDesignOrderId?: number, options?: AxiosRequestConfig) {
        return DesignMatchingApiFp(this.configuration).getIsMatched(interiorDesignCompanyId, interiorDesignOrderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DesignPatternApi - axios parameter creator
 * @export
 */
export const DesignPatternApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 管理者が内装会社マッチングを登録・削除する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 内装会社マッチング登録・更新
         * @param {CreateOrUpdateDesignPatternRequest} [createOrUpdateDesignPatternRequest] 内装会社マッチング登録・更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateDesignPattern: async (createOrUpdateDesignPatternRequest?: CreateOrUpdateDesignPatternRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/design_pattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateDesignPatternRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者が内装会社マッチングを削除する。
         * @summary 内装会社マッチング削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesignPattern: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/design_pattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社マッチングの問い合わせを実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
         * @summary 内装会社マッチング問い合わせ
         * @param {DesignPatternRequestRequest} designPatternRequestRequest 内装会社マッチング問い合わせ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        designPatternRequest: async (designPatternRequestRequest: DesignPatternRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designPatternRequestRequest' is not null or undefined
            assertParamExists('designPatternRequest', 'designPatternRequestRequest', designPatternRequestRequest)
            const localVarPath = `/design/decide`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(designPatternRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者が内装会社マッチングを取得する。
         * @summary 内装会社マッチング取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignPatternForAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/design_pattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装マッチングの履歴を取得
         * @summary 自分の内装マッチングの履歴を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignPatternInquiryListMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design_pattern_inquiry/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社マッチング一覧を取得する。
         * @summary 内装会社マッチング一覧取得
         * @param {string} [_class] 内装会社マッチング種別
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignPatternList: async (_class?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (_class !== undefined) {
                localVarQueryParameter['class'] = _class;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者が内装会社マッチングの画像を一時アップロードする
         * @summary 内装会社マッチング画像一時アップロード
         * @param {UploadDesignPatternImageRequest} [uploadDesignPatternImageRequest] 内装会社マッチング画像一時アップロードリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDesignPatternImage: async (uploadDesignPatternImageRequest?: UploadDesignPatternImageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/design_pattern/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadDesignPatternImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignPatternApi - functional programming interface
 * @export
 */
export const DesignPatternApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesignPatternApiAxiosParamCreator(configuration)
    return {
        /**
         * 管理者が内装会社マッチングを登録・削除する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 内装会社マッチング登録・更新
         * @param {CreateOrUpdateDesignPatternRequest} [createOrUpdateDesignPatternRequest] 内装会社マッチング登録・更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateDesignPattern(createOrUpdateDesignPatternRequest?: CreateOrUpdateDesignPatternRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrUpdateDesignPattern200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateDesignPattern(createOrUpdateDesignPatternRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者が内装会社マッチングを削除する。
         * @summary 内装会社マッチング削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDesignPattern(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteDesignPattern200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDesignPattern(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社マッチングの問い合わせを実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
         * @summary 内装会社マッチング問い合わせ
         * @param {DesignPatternRequestRequest} designPatternRequestRequest 内装会社マッチング問い合わせ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async designPatternRequest(designPatternRequestRequest: DesignPatternRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.designPatternRequest(designPatternRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者が内装会社マッチングを取得する。
         * @summary 内装会社マッチング取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignPatternForAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDesignPatternForAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignPatternForAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装マッチングの履歴を取得
         * @summary 自分の内装マッチングの履歴を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignPatternInquiryListMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDesignPatternInquiryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignPatternInquiryListMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社マッチング一覧を取得する。
         * @summary 内装会社マッチング一覧取得
         * @param {string} [_class] 内装会社マッチング種別
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignPatternList(_class?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDesignPatternList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignPatternList(_class, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者が内装会社マッチングの画像を一時アップロードする
         * @summary 内装会社マッチング画像一時アップロード
         * @param {UploadDesignPatternImageRequest} [uploadDesignPatternImageRequest] 内装会社マッチング画像一時アップロードリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDesignPatternImage(uploadDesignPatternImageRequest?: UploadDesignPatternImageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDesignPatternImage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDesignPatternImage(uploadDesignPatternImageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesignPatternApi - factory interface
 * @export
 */
export const DesignPatternApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesignPatternApiFp(configuration)
    return {
        /**
         * 管理者が内装会社マッチングを登録・削除する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 内装会社マッチング登録・更新
         * @param {CreateOrUpdateDesignPatternRequest} [createOrUpdateDesignPatternRequest] 内装会社マッチング登録・更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateDesignPattern(createOrUpdateDesignPatternRequest?: CreateOrUpdateDesignPatternRequest, options?: any): AxiosPromise<CreateOrUpdateDesignPattern200Response> {
            return localVarFp.createOrUpdateDesignPattern(createOrUpdateDesignPatternRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者が内装会社マッチングを削除する。
         * @summary 内装会社マッチング削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesignPattern(options?: any): AxiosPromise<DeleteDesignPattern200Response> {
            return localVarFp.deleteDesignPattern(options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社マッチングの問い合わせを実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
         * @summary 内装会社マッチング問い合わせ
         * @param {DesignPatternRequestRequest} designPatternRequestRequest 内装会社マッチング問い合わせ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        designPatternRequest(designPatternRequestRequest: DesignPatternRequestRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.designPatternRequest(designPatternRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者が内装会社マッチングを取得する。
         * @summary 内装会社マッチング取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignPatternForAdmin(options?: any): AxiosPromise<GetDesignPatternForAdmin200Response> {
            return localVarFp.getDesignPatternForAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 内装マッチングの履歴を取得
         * @summary 自分の内装マッチングの履歴を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignPatternInquiryListMe(options?: any): AxiosPromise<GetDesignPatternInquiryListResponse> {
            return localVarFp.getDesignPatternInquiryListMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社マッチング一覧を取得する。
         * @summary 内装会社マッチング一覧取得
         * @param {string} [_class] 内装会社マッチング種別
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignPatternList(_class?: string, options?: any): AxiosPromise<GetDesignPatternList200Response> {
            return localVarFp.getDesignPatternList(_class, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者が内装会社マッチングの画像を一時アップロードする
         * @summary 内装会社マッチング画像一時アップロード
         * @param {UploadDesignPatternImageRequest} [uploadDesignPatternImageRequest] 内装会社マッチング画像一時アップロードリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDesignPatternImage(uploadDesignPatternImageRequest?: UploadDesignPatternImageRequest, options?: any): AxiosPromise<UploadDesignPatternImage200Response> {
            return localVarFp.uploadDesignPatternImage(uploadDesignPatternImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesignPatternApi - object-oriented interface
 * @export
 * @class DesignPatternApi
 * @extends {BaseAPI}
 */
export class DesignPatternApi extends BaseAPI {
    /**
     * 管理者が内装会社マッチングを登録・削除する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/AuthToken   * APIリソース別共通定義シート * #/components/schemas/E_A001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_A002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 内装会社マッチング登録・更新
     * @param {CreateOrUpdateDesignPatternRequest} [createOrUpdateDesignPatternRequest] 内装会社マッチング登録・更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public createOrUpdateDesignPattern(createOrUpdateDesignPatternRequest?: CreateOrUpdateDesignPatternRequest, options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).createOrUpdateDesignPattern(createOrUpdateDesignPatternRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者が内装会社マッチングを削除する。
     * @summary 内装会社マッチング削除
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public deleteDesignPattern(options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).deleteDesignPattern(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社マッチングの問い合わせを実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
     * @summary 内装会社マッチング問い合わせ
     * @param {DesignPatternRequestRequest} designPatternRequestRequest 内装会社マッチング問い合わせ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public designPatternRequest(designPatternRequestRequest: DesignPatternRequestRequest, options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).designPatternRequest(designPatternRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者が内装会社マッチングを取得する。
     * @summary 内装会社マッチング取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public getDesignPatternForAdmin(options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).getDesignPatternForAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装マッチングの履歴を取得
     * @summary 自分の内装マッチングの履歴を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public getDesignPatternInquiryListMe(options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).getDesignPatternInquiryListMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社マッチング一覧を取得する。
     * @summary 内装会社マッチング一覧取得
     * @param {string} [_class] 内装会社マッチング種別
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public getDesignPatternList(_class?: string, options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).getDesignPatternList(_class, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者が内装会社マッチングの画像を一時アップロードする
     * @summary 内装会社マッチング画像一時アップロード
     * @param {UploadDesignPatternImageRequest} [uploadDesignPatternImageRequest] 内装会社マッチング画像一時アップロードリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignPatternApi
     */
    public uploadDesignPatternImage(uploadDesignPatternImageRequest?: UploadDesignPatternImageRequest, options?: AxiosRequestConfig) {
        return DesignPatternApiFp(this.configuration).uploadDesignPatternImage(uploadDesignPatternImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DummyApi - axios parameter creator
 * @export
 */
export const DummyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 都道府県Enumファイルを作るための必要ないAPIです。
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyPrefecture: async (interiorDesignOrderId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dummyPrefecture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignOrderId !== undefined) {
                localVarQueryParameter['interior_design_order_id'] = interiorDesignOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DummyApi - functional programming interface
 * @export
 */
export const DummyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DummyApiAxiosParamCreator(configuration)
    return {
        /**
         * 都道府県Enumファイルを作るための必要ないAPIです。
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dummyPrefecture(interiorDesignOrderId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dummy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dummyPrefecture(interiorDesignOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DummyApi - factory interface
 * @export
 */
export const DummyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DummyApiFp(configuration)
    return {
        /**
         * 都道府県Enumファイルを作るための必要ないAPIです。
         * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyPrefecture(interiorDesignOrderId?: number, options?: any): AxiosPromise<Dummy> {
            return localVarFp.dummyPrefecture(interiorDesignOrderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DummyApi - object-oriented interface
 * @export
 * @class DummyApi
 * @extends {BaseAPI}
 */
export class DummyApi extends BaseAPI {
    /**
     * 都道府県Enumファイルを作るための必要ないAPIです。
     * @param {number} [interiorDesignOrderId] 内装案件ID（複数指定可）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DummyApi
     */
    public dummyPrefecture(interiorDesignOrderId?: number, options?: AxiosRequestConfig) {
        return DummyApiFp(this.configuration).dummyPrefecture(interiorDesignOrderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FavoritePropertyApi - axios parameter creator
 * @export
 */
export const FavoritePropertyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザの物件をお気に入りに登録する。
         * @summary 物件お気に入り
         * @param {string} [uid] 会員ID
         * @param {CreateFavoritePropertyRequest} [createFavoritePropertyRequest] 物件お気に入りリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavoriteProperty: async (uid?: string, createFavoritePropertyRequest?: CreateFavoritePropertyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/property/fav`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFavoritePropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのお気に入り物件を削除する。
         * @summary お気に入り物件解除
         * @param {number} favoritePropertyId お気に入り物件ID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteProperty: async (favoritePropertyId: number, uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoritePropertyId' is not null or undefined
            assertParamExists('deleteFavoriteProperty', 'favoritePropertyId', favoritePropertyId)
            const localVarPath = `/user/property/fav/{favorite_property_id}`
                .replace(`{${"favorite_property_id"}}`, encodeURIComponent(String(favoritePropertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのお気に入り物件を取得する。
         * @summary お気に入り物件取得
         * @param {string} [uid] 会員ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritePropertyList: async (uid?: string, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/property/fav`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoritePropertyApi - functional programming interface
 * @export
 */
export const FavoritePropertyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FavoritePropertyApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザの物件をお気に入りに登録する。
         * @summary 物件お気に入り
         * @param {string} [uid] 会員ID
         * @param {CreateFavoritePropertyRequest} [createFavoritePropertyRequest] 物件お気に入りリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFavoriteProperty(uid?: string, createFavoritePropertyRequest?: CreateFavoritePropertyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFavoriteProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFavoriteProperty(uid, createFavoritePropertyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのお気に入り物件を削除する。
         * @summary お気に入り物件解除
         * @param {number} favoritePropertyId お気に入り物件ID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoriteProperty(favoritePropertyId: number, uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFavoriteProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFavoriteProperty(favoritePropertyId, uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのお気に入り物件を取得する。
         * @summary お気に入り物件取得
         * @param {string} [uid] 会員ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoritePropertyList(uid?: string, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFavoritePropertyList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoritePropertyList(uid, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FavoritePropertyApi - factory interface
 * @export
 */
export const FavoritePropertyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FavoritePropertyApiFp(configuration)
    return {
        /**
         * ユーザの物件をお気に入りに登録する。
         * @summary 物件お気に入り
         * @param {string} [uid] 会員ID
         * @param {CreateFavoritePropertyRequest} [createFavoritePropertyRequest] 物件お気に入りリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavoriteProperty(uid?: string, createFavoritePropertyRequest?: CreateFavoritePropertyRequest, options?: any): AxiosPromise<CreateFavoriteProperty200Response> {
            return localVarFp.createFavoriteProperty(uid, createFavoritePropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのお気に入り物件を削除する。
         * @summary お気に入り物件解除
         * @param {number} favoritePropertyId お気に入り物件ID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteProperty(favoritePropertyId: number, uid?: string, options?: any): AxiosPromise<DeleteFavoriteProperty200Response> {
            return localVarFp.deleteFavoriteProperty(favoritePropertyId, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのお気に入り物件を取得する。
         * @summary お気に入り物件取得
         * @param {string} [uid] 会員ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritePropertyList(uid?: string, page?: number, options?: any): AxiosPromise<GetFavoritePropertyList200Response> {
            return localVarFp.getFavoritePropertyList(uid, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FavoritePropertyApi - object-oriented interface
 * @export
 * @class FavoritePropertyApi
 * @extends {BaseAPI}
 */
export class FavoritePropertyApi extends BaseAPI {
    /**
     * ユーザの物件をお気に入りに登録する。
     * @summary 物件お気に入り
     * @param {string} [uid] 会員ID
     * @param {CreateFavoritePropertyRequest} [createFavoritePropertyRequest] 物件お気に入りリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritePropertyApi
     */
    public createFavoriteProperty(uid?: string, createFavoritePropertyRequest?: CreateFavoritePropertyRequest, options?: AxiosRequestConfig) {
        return FavoritePropertyApiFp(this.configuration).createFavoriteProperty(uid, createFavoritePropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのお気に入り物件を削除する。
     * @summary お気に入り物件解除
     * @param {number} favoritePropertyId お気に入り物件ID
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritePropertyApi
     */
    public deleteFavoriteProperty(favoritePropertyId: number, uid?: string, options?: AxiosRequestConfig) {
        return FavoritePropertyApiFp(this.configuration).deleteFavoriteProperty(favoritePropertyId, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのお気に入り物件を取得する。
     * @summary お気に入り物件取得
     * @param {string} [uid] 会員ID
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritePropertyApi
     */
    public getFavoritePropertyList(uid?: string, page?: number, options?: AxiosRequestConfig) {
        return FavoritePropertyApiFp(this.configuration).getFavoritePropertyList(uid, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InteriorDesignCompanyApi - axios parameter creator
 * @export
 */
export const InteriorDesignCompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 内装会社の事例を削除する。
         * @summary 事例削除
         * @param {number} [id] 事例ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConstructionCase: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/construction_cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社の事例を削除する。
         * @summary 事例削除
         * @param {number} [id] 事例ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConstructionCaseMe: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/construction_cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
         * @summary 事例一覧取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstructionCases: async (interiorDesignCompanyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/construction_cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
         * @summary 事例一覧取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstructionCasesMe: async (interiorDesignCompanyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/construction_cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者が選択した内装会社詳細情報を取得する。
         * @summary 内装会社詳細情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyDetail: async (interiorDesignCompanyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者が選択した内装会社詳細情報を取得する。
         * @summary 内装会社詳細情報取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyDetailMe: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 選択した内装会社のマッチング設定情報を取得する。
         * @summary マッチング設定情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyFilterItems: async (interiorDesignCompanyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/filter_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 選択した内装会社のマッチング設定情報を取得する。
         * @summary マッチング設定情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyFilterItemsMe: async (interiorDesignCompanyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/filter_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interiorDesignCompanyId !== undefined) {
                localVarQueryParameter['interior_design_company_id'] = interiorDesignCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者が内装会社一覧情報を取得する。
         * @summary 内装会社情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社の事例を更新する。
         * @summary 事例更新
         * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConstructionCases: async (constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/construction_cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(constructionCasesRequestBodyInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社の事例を更新する。
         * @summary 事例更新
         * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConstructionCasesMe: async (constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/construction_cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(constructionCasesRequestBodyInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社情報を更新する。
         * @summary 内装会社情報更新
         * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompany: async (updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInteriorDesignCompanyRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マッチング設定情報を更新する。
         * @summary マッチング設定情報更新
         * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompanyFilterItems: async (updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_company/filter_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInteriorDesignCompanyFilterItemsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マッチング設定情報を更新する。
         * @summary マッチング設定情報更新
         * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompanyFilterItemsMe: async (updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/filter_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInteriorDesignCompanyFilterItemsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装会社情報を更新する。
         * @summary 内装会社情報更新
         * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompanyMe: async (updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interior_design_company/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInteriorDesignCompanyRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InteriorDesignCompanyApi - functional programming interface
 * @export
 */
export const InteriorDesignCompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InteriorDesignCompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 内装会社の事例を削除する。
         * @summary 事例削除
         * @param {number} [id] 事例ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConstructionCase(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConstructionCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConstructionCase(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社の事例を削除する。
         * @summary 事例削除
         * @param {number} [id] 事例ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConstructionCaseMe(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConstructionCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConstructionCaseMe(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
         * @summary 事例一覧取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConstructionCases(interiorDesignCompanyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConstructionCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConstructionCases(interiorDesignCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
         * @summary 事例一覧取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConstructionCasesMe(interiorDesignCompanyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConstructionCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConstructionCasesMe(interiorDesignCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者が選択した内装会社詳細情報を取得する。
         * @summary 内装会社詳細情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignCompanyDetail(interiorDesignCompanyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignCompanyDetail(interiorDesignCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者が選択した内装会社詳細情報を取得する。
         * @summary 内装会社詳細情報取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignCompanyDetailMe(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignCompanyDetailMe(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 選択した内装会社のマッチング設定情報を取得する。
         * @summary マッチング設定情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignCompanyFilterItems(interiorDesignCompanyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyFilterItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignCompanyFilterItems(interiorDesignCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 選択した内装会社のマッチング設定情報を取得する。
         * @summary マッチング設定情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignCompanyFilterItemsMe(interiorDesignCompanyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyFilterItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignCompanyFilterItemsMe(interiorDesignCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者が内装会社一覧情報を取得する。
         * @summary 内装会社情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignCompanyList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetInteriorDesignCompanyList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignCompanyList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社の事例を更新する。
         * @summary 事例更新
         * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConstructionCases(constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConstructionCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConstructionCases(constructionCasesRequestBodyInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社の事例を更新する。
         * @summary 事例更新
         * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConstructionCasesMe(constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetConstructionCases200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConstructionCasesMe(constructionCasesRequestBodyInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社情報を更新する。
         * @summary 内装会社情報更新
         * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInteriorDesignCompany(updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInteriorDesignCompany(updateInteriorDesignCompanyRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マッチング設定情報を更新する。
         * @summary マッチング設定情報更新
         * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInteriorDesignCompanyFilterItems(updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyFilterItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInteriorDesignCompanyFilterItems(updateInteriorDesignCompanyFilterItemsRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マッチング設定情報を更新する。
         * @summary マッチング設定情報更新
         * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInteriorDesignCompanyFilterItemsMe(updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyFilterItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInteriorDesignCompanyFilterItemsMe(updateInteriorDesignCompanyFilterItemsRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装会社情報を更新する。
         * @summary 内装会社情報更新
         * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInteriorDesignCompanyMe(updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignCompanyDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInteriorDesignCompanyMe(updateInteriorDesignCompanyRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InteriorDesignCompanyApi - factory interface
 * @export
 */
export const InteriorDesignCompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InteriorDesignCompanyApiFp(configuration)
    return {
        /**
         * 内装会社の事例を削除する。
         * @summary 事例削除
         * @param {number} [id] 事例ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConstructionCase(id?: number, options?: any): AxiosPromise<Array<GetConstructionCases200ResponseInner>> {
            return localVarFp.deleteConstructionCase(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社の事例を削除する。
         * @summary 事例削除
         * @param {number} [id] 事例ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConstructionCaseMe(id?: number, options?: any): AxiosPromise<Array<GetConstructionCases200ResponseInner>> {
            return localVarFp.deleteConstructionCaseMe(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
         * @summary 事例一覧取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstructionCases(interiorDesignCompanyId?: number, options?: any): AxiosPromise<Array<GetConstructionCases200ResponseInner>> {
            return localVarFp.getConstructionCases(interiorDesignCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
         * @summary 事例一覧取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstructionCasesMe(interiorDesignCompanyId?: number, options?: any): AxiosPromise<Array<GetConstructionCases200ResponseInner>> {
            return localVarFp.getConstructionCasesMe(interiorDesignCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者が選択した内装会社詳細情報を取得する。
         * @summary 内装会社詳細情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyDetail(interiorDesignCompanyId?: number, options?: any): AxiosPromise<GetInteriorDesignCompanyDetail200Response> {
            return localVarFp.getInteriorDesignCompanyDetail(interiorDesignCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者が選択した内装会社詳細情報を取得する。
         * @summary 内装会社詳細情報取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyDetailMe(uid?: string, options?: any): AxiosPromise<GetInteriorDesignCompanyDetail200Response> {
            return localVarFp.getInteriorDesignCompanyDetailMe(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 選択した内装会社のマッチング設定情報を取得する。
         * @summary マッチング設定情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyFilterItems(interiorDesignCompanyId?: number, options?: any): AxiosPromise<GetInteriorDesignCompanyFilterItems200Response> {
            return localVarFp.getInteriorDesignCompanyFilterItems(interiorDesignCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 選択した内装会社のマッチング設定情報を取得する。
         * @summary マッチング設定情報取得
         * @param {number} [interiorDesignCompanyId] 内装会社ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyFilterItemsMe(interiorDesignCompanyId?: number, options?: any): AxiosPromise<GetInteriorDesignCompanyFilterItems200Response> {
            return localVarFp.getInteriorDesignCompanyFilterItemsMe(interiorDesignCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者が内装会社一覧情報を取得する。
         * @summary 内装会社情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompanyList(options?: any): AxiosPromise<Array<GetInteriorDesignCompanyList200ResponseInner>> {
            return localVarFp.getInteriorDesignCompanyList(options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社の事例を更新する。
         * @summary 事例更新
         * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConstructionCases(constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options?: any): AxiosPromise<Array<GetConstructionCases200ResponseInner>> {
            return localVarFp.updateConstructionCases(constructionCasesRequestBodyInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社の事例を更新する。
         * @summary 事例更新
         * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConstructionCasesMe(constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options?: any): AxiosPromise<Array<GetConstructionCases200ResponseInner>> {
            return localVarFp.updateConstructionCasesMe(constructionCasesRequestBodyInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社情報を更新する。
         * @summary 内装会社情報更新
         * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompany(updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options?: any): AxiosPromise<GetInteriorDesignCompanyDetail200Response> {
            return localVarFp.updateInteriorDesignCompany(updateInteriorDesignCompanyRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * マッチング設定情報を更新する。
         * @summary マッチング設定情報更新
         * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompanyFilterItems(updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options?: any): AxiosPromise<GetInteriorDesignCompanyFilterItems200Response> {
            return localVarFp.updateInteriorDesignCompanyFilterItems(updateInteriorDesignCompanyFilterItemsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * マッチング設定情報を更新する。
         * @summary マッチング設定情報更新
         * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompanyFilterItemsMe(updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options?: any): AxiosPromise<GetInteriorDesignCompanyFilterItems200Response> {
            return localVarFp.updateInteriorDesignCompanyFilterItemsMe(updateInteriorDesignCompanyFilterItemsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装会社情報を更新する。
         * @summary 内装会社情報更新
         * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInteriorDesignCompanyMe(updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options?: any): AxiosPromise<GetInteriorDesignCompanyDetail200Response> {
            return localVarFp.updateInteriorDesignCompanyMe(updateInteriorDesignCompanyRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InteriorDesignCompanyApi - object-oriented interface
 * @export
 * @class InteriorDesignCompanyApi
 * @extends {BaseAPI}
 */
export class InteriorDesignCompanyApi extends BaseAPI {
    /**
     * 内装会社の事例を削除する。
     * @summary 事例削除
     * @param {number} [id] 事例ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public deleteConstructionCase(id?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).deleteConstructionCase(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社の事例を削除する。
     * @summary 事例削除
     * @param {number} [id] 事例ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public deleteConstructionCaseMe(id?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).deleteConstructionCaseMe(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
     * @summary 事例一覧取得
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getConstructionCases(interiorDesignCompanyId?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getConstructionCases(interiorDesignCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者または内装会社が選択した内装会社の事例一覧を取得する。
     * @summary 事例一覧取得
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getConstructionCasesMe(interiorDesignCompanyId?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getConstructionCasesMe(interiorDesignCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者が選択した内装会社詳細情報を取得する。
     * @summary 内装会社詳細情報取得
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getInteriorDesignCompanyDetail(interiorDesignCompanyId?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getInteriorDesignCompanyDetail(interiorDesignCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者が選択した内装会社詳細情報を取得する。
     * @summary 内装会社詳細情報取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getInteriorDesignCompanyDetailMe(uid?: string, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getInteriorDesignCompanyDetailMe(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 選択した内装会社のマッチング設定情報を取得する。
     * @summary マッチング設定情報取得
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getInteriorDesignCompanyFilterItems(interiorDesignCompanyId?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getInteriorDesignCompanyFilterItems(interiorDesignCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 選択した内装会社のマッチング設定情報を取得する。
     * @summary マッチング設定情報取得
     * @param {number} [interiorDesignCompanyId] 内装会社ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getInteriorDesignCompanyFilterItemsMe(interiorDesignCompanyId?: number, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getInteriorDesignCompanyFilterItemsMe(interiorDesignCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者が内装会社一覧情報を取得する。
     * @summary 内装会社情報取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public getInteriorDesignCompanyList(options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).getInteriorDesignCompanyList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社の事例を更新する。
     * @summary 事例更新
     * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public updateConstructionCases(constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).updateConstructionCases(constructionCasesRequestBodyInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社の事例を更新する。
     * @summary 事例更新
     * @param {Array<ConstructionCasesRequestBodyInner>} [constructionCasesRequestBodyInner] 成功
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public updateConstructionCasesMe(constructionCasesRequestBodyInner?: Array<ConstructionCasesRequestBodyInner>, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).updateConstructionCasesMe(constructionCasesRequestBodyInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社情報を更新する。
     * @summary 内装会社情報更新
     * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public updateInteriorDesignCompany(updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).updateInteriorDesignCompany(updateInteriorDesignCompanyRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マッチング設定情報を更新する。
     * @summary マッチング設定情報更新
     * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public updateInteriorDesignCompanyFilterItems(updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).updateInteriorDesignCompanyFilterItems(updateInteriorDesignCompanyFilterItemsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マッチング設定情報を更新する。
     * @summary マッチング設定情報更新
     * @param {UpdateInteriorDesignCompanyFilterItemsRequestBody} [updateInteriorDesignCompanyFilterItemsRequestBody] マッチング設定更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public updateInteriorDesignCompanyFilterItemsMe(updateInteriorDesignCompanyFilterItemsRequestBody?: UpdateInteriorDesignCompanyFilterItemsRequestBody, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).updateInteriorDesignCompanyFilterItemsMe(updateInteriorDesignCompanyFilterItemsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装会社情報を更新する。
     * @summary 内装会社情報更新
     * @param {UpdateInteriorDesignCompanyRequestBody} [updateInteriorDesignCompanyRequestBody] 内装会社更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignCompanyApi
     */
    public updateInteriorDesignCompanyMe(updateInteriorDesignCompanyRequestBody?: UpdateInteriorDesignCompanyRequestBody, options?: AxiosRequestConfig) {
        return InteriorDesignCompanyApiFp(this.configuration).updateInteriorDesignCompanyMe(updateInteriorDesignCompanyRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InteriorDesignOrderApi - axios parameter creator
 * @export
 */
export const InteriorDesignOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admin Get a interior design order.
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrder: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminGetInteriorDesignOrder', 'orderId', orderId)
            const localVarPath = `/ope/interior_design_order/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した内装案件に紐づく内装会社への送付（中間テーブル）の一覧を取得する
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrderSends: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminGetInteriorDesignOrderSends', 'orderId', orderId)
            const localVarPath = `/ope/interior_design_order/{order_id}/sending`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get interior design orders.
         * @param {number} page ページ番号
         * @param {AdminGetInteriorDesignOrdersSortEnum} [sort] 昇順／降順（asc または desc）
         * @param {Array<InteriorDesignOrderStatus>} [status] 内装ステータス（フィルタ。複数指定可）
         * @param {InteriorDesignOrderPropertyStatus} [propertyStatus] 物件ステータス（フィルタ）
         * @param {number} [id] 内部管理番号（id）
         * @param {string} [clientName] 氏名（部分一致。旧 title フィルタから移行）
         * @param {InteriorDesignOrderOperators} [operatorId] 伴走者オペレーターID
         * @param {string} [clientPhoneNumber] 電話番号（clientPhoneNumber 部分一致）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrders: async (page: number, sort?: AdminGetInteriorDesignOrdersSortEnum, status?: Array<InteriorDesignOrderStatus>, propertyStatus?: InteriorDesignOrderPropertyStatus, id?: number, clientName?: string, operatorId?: InteriorDesignOrderOperators, clientPhoneNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminGetInteriorDesignOrders', 'page', page)
            const localVarPath = `/ope/interior_design_order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (propertyStatus !== undefined) {
                localVarQueryParameter['propertyStatus'] = propertyStatus;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (clientName !== undefined) {
                localVarQueryParameter['clientName'] = clientName;
            }

            if (operatorId !== undefined) {
                localVarQueryParameter['operatorId'] = operatorId;
            }

            if (clientPhoneNumber !== undefined) {
                localVarQueryParameter['clientPhoneNumber'] = clientPhoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 全案件のステータスサマリーを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrdersStatusSummary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_orders/status_summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adminが内装案件を複数の内装会社に送付（バルク）
         * @param {number} orderId 案件Id
         * @param {AdminInteriorDesignOrderSendRequest} adminInteriorDesignOrderSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendInteriorDesignOrder: async (orderId: number, adminInteriorDesignOrderSendRequest: AdminInteriorDesignOrderSendRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminSendInteriorDesignOrder', 'orderId', orderId)
            // verify required parameter 'adminInteriorDesignOrderSendRequest' is not null or undefined
            assertParamExists('adminSendInteriorDesignOrder', 'adminInteriorDesignOrderSendRequest', adminInteriorDesignOrderSendRequest)
            const localVarPath = `/ope/interior_design_order/{order_id}/sending`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInteriorDesignOrderSendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adminで内装案件を更新。
         * @param {number} orderId 案件Id
         * @param {InteriorDesignOrder} interiorDesignOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateInteriorDesignOrder: async (orderId: number, interiorDesignOrder: InteriorDesignOrder, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminUpdateInteriorDesignOrder', 'orderId', orderId)
            // verify required parameter 'interiorDesignOrder' is not null or undefined
            assertParamExists('adminUpdateInteriorDesignOrder', 'interiorDesignOrder', interiorDesignOrder)
            const localVarPath = `/ope/interior_design_order/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interiorDesignOrder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装案件にエントリーする
         * @param {number} orderId 案件ID
         * @param {InteriorDesignOrderEntry} [interiorDesignOrderEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entryInteriorDesignOrder: async (orderId: number, interiorDesignOrderEntry?: InteriorDesignOrderEntry, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('entryInteriorDesignOrder', 'orderId', orderId)
            const localVarPath = `/design/interior_design_orders/{order_id}/entry`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interiorDesignOrderEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a interior design order.
         * @param {number} orderId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignInteriorDesignOrder: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getDesignInteriorDesignOrder', 'orderId', orderId)
            const localVarPath = `/design/interior_design_orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した `order_id` に紐づく内装会社と、その会社が当該案件に対して登録した応募情報（status, sentAt, message, enteredAt, matchedAt など）を返します。 
         * @summary 指定案件に紐づく内装会社一覧（応募情報付き）を取得します
         * @param {number} orderId 取得対象の案件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompaniesByOrder: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getInteriorDesignCompaniesByOrder', 'orderId', orderId)
            const localVarPath = `/ope/interior_design_orders/{order_id}/companies`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a interior design order.
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignOrder: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getInteriorDesignOrder', 'orderId', orderId)
            const localVarPath = `/interior_design_orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get interior design orders.
         * @param {number} [page] ページ番号
         * @param {Array<InteriorDesignCompanyInteriorDesignOrderStatus>} [status] 内装案件取得対象の案件ステータス
         * @param {boolean} [excludeDrop] true の場合、DROP ステータスの案件を結果から除外
         * @param {boolean} [includeDroppedOrdersWhenLinked] true の場合、内装会社との紐づきがある案件について「会社側ステータス条件」に加えて「案件側ステータスがDROP系」の案件もOR条件で結果に含める
         * @param {boolean} [excludePreEntry] true の場合、終了タブに返す案件から内装ステータス PRE_ENTRY を除外
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignOrders: async (page?: number, status?: Array<InteriorDesignCompanyInteriorDesignOrderStatus>, excludeDrop?: boolean, includeDroppedOrdersWhenLinked?: boolean, excludePreEntry?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/design/interior_design_orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (excludeDrop !== undefined) {
                localVarQueryParameter['excludeDrop'] = excludeDrop;
            }

            if (includeDroppedOrdersWhenLinked !== undefined) {
                localVarQueryParameter['includeDroppedOrdersWhenLinked'] = includeDroppedOrdersWhenLinked;
            }

            if (excludePreEntry !== undefined) {
                localVarQueryParameter['excludePreEntry'] = excludePreEntry;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装案件エントリーのステータスの部分更新
         * @param {number} orderId 案件ID
         * @param {PatchInteriorDesignOrderEntryStatusRequest} [patchInteriorDesignOrderEntryStatusRequest] 内装案件エントリーの部分更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInteriorDesignOrderEntryStatus: async (orderId: number, patchInteriorDesignOrderEntryStatusRequest?: PatchInteriorDesignOrderEntryStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('patchInteriorDesignOrderEntryStatus', 'orderId', orderId)
            const localVarPath = `/design/interior_design_orders/{order_id}/entry`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchInteriorDesignOrderEntryStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 内装案件の物件契約状況を部分更新する
         * @param {number} orderId 案件ID
         * @param {PatchInteriorDesignOrderPropertyStatusRequest} [patchInteriorDesignOrderPropertyStatusRequest] 内装案件の物件契約状況を部分更新するリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInteriorDesignOrderPropertyStatus: async (orderId: number, patchInteriorDesignOrderPropertyStatusRequest?: PatchInteriorDesignOrderPropertyStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('patchInteriorDesignOrderPropertyStatus', 'orderId', orderId)
            const localVarPath = `/design/interior_design_orders/{order_id}/property`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchInteriorDesignOrderPropertyStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した `order_id` に対し、リクエストボディで与えられた `company_ids` の一覧を処理します。 - 既存で紐づく `InteriorDesignCompanyInteriorDesignOrder` があり、かつ status が `ENTRY_IN_PROGRESS` の場合は `MATCHING_ESTABLISHED` に更新します。 - 紐づきが存在しない場合は新規に `InteriorDesignCompanyInteriorDesignOrder` を作成し、status を `MATCHING_ESTABLISHED` にして紐づけます。 処理後、該当案件に紐づく会社一覧（`InteriorDesignCompanyForOrderListResponse`）を返します。 
         * @summary 指定案件に対して会社をマッチングして紐づけを作成／更新します
         * @param {number} orderId 対象の案件 ID
         * @param {InteriorDesignCompanyMatchingRequest} interiorDesignCompanyMatchingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInteriorDesignCompanyMatching: async (orderId: number, interiorDesignCompanyMatchingRequest: InteriorDesignCompanyMatchingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('postInteriorDesignCompanyMatching', 'orderId', orderId)
            // verify required parameter 'interiorDesignCompanyMatchingRequest' is not null or undefined
            assertParamExists('postInteriorDesignCompanyMatching', 'interiorDesignCompanyMatchingRequest', interiorDesignCompanyMatchingRequest)
            const localVarPath = `/ope/interior_design_orders/{order_id}/companies/matching`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interiorDesignCompanyMatchingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運営への共有事項を追加する
         * @param {number} orderId 案件ID
         * @param {PostInteriorDesignOrderCompanySharedNoteRequest} [postInteriorDesignOrderCompanySharedNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInteriorDesignOrderCompanySharedNote: async (orderId: number, postInteriorDesignOrderCompanySharedNoteRequest?: PostInteriorDesignOrderCompanySharedNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('postInteriorDesignOrderCompanySharedNote', 'orderId', orderId)
            const localVarPath = `/design/interior_design_orders/{order_id}/company_shared_note`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postInteriorDesignOrderCompanySharedNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した `order_id` と `company_id` に紐づく中間テーブル `InteriorDesignCompanyInteriorDesignOrder` を更新します。 リクエストボディの内容でリソースを上書きします。存在しない場合は 404 を返します。 - バリデーションエラーは 400、存在しないリソースは 404 を返します。 
         * @summary 指定案件に紐づく会社の紐づけ情報（中間テーブル）を更新します
         * @param {number} orderId 更新対象の案件 ID
         * @param {number} companyId 更新対象の会社 ID
         * @param {InteriorDesignCompanyInteriorDesignOrder} interiorDesignCompanyInteriorDesignOrder 更新する &#x60;InteriorDesignCompanyInteriorDesignOrder&#x60; を指定します（完全更新）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putInteriorDesignCompanyInteriorDesignOrder: async (orderId: number, companyId: number, interiorDesignCompanyInteriorDesignOrder: InteriorDesignCompanyInteriorDesignOrder, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('putInteriorDesignCompanyInteriorDesignOrder', 'orderId', orderId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('putInteriorDesignCompanyInteriorDesignOrder', 'companyId', companyId)
            // verify required parameter 'interiorDesignCompanyInteriorDesignOrder' is not null or undefined
            assertParamExists('putInteriorDesignCompanyInteriorDesignOrder', 'interiorDesignCompanyInteriorDesignOrder', interiorDesignCompanyInteriorDesignOrder)
            const localVarPath = `/ope/interior_design_orders/{order_id}/companies/{company_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interiorDesignCompanyInteriorDesignOrder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * スプレッドシート取り込み
         * @summary 内装案件スプレッドシート同期（実行トリガー）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInteriorDesignOrderSpreadsheet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/interior_design_orders/spreadsheet/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InteriorDesignOrderApi - functional programming interface
 * @export
 */
export const InteriorDesignOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InteriorDesignOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * Admin Get a interior design order.
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetInteriorDesignOrder(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetInteriorDesignOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した内装案件に紐づく内装会社への送付（中間テーブル）の一覧を取得する
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetInteriorDesignOrderSends(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInteriorDesignOrderSendingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetInteriorDesignOrderSends(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get interior design orders.
         * @param {number} page ページ番号
         * @param {AdminGetInteriorDesignOrdersSortEnum} [sort] 昇順／降順（asc または desc）
         * @param {Array<InteriorDesignOrderStatus>} [status] 内装ステータス（フィルタ。複数指定可）
         * @param {InteriorDesignOrderPropertyStatus} [propertyStatus] 物件ステータス（フィルタ）
         * @param {number} [id] 内部管理番号（id）
         * @param {string} [clientName] 氏名（部分一致。旧 title フィルタから移行）
         * @param {InteriorDesignOrderOperators} [operatorId] 伴走者オペレーターID
         * @param {string} [clientPhoneNumber] 電話番号（clientPhoneNumber 部分一致）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetInteriorDesignOrders(page: number, sort?: AdminGetInteriorDesignOrdersSortEnum, status?: Array<InteriorDesignOrderStatus>, propertyStatus?: InteriorDesignOrderPropertyStatus, id?: number, clientName?: string, operatorId?: InteriorDesignOrderOperators, clientPhoneNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrderListGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetInteriorDesignOrders(page, sort, status, propertyStatus, id, clientName, operatorId, clientPhoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 全案件のステータスサマリーを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetInteriorDesignOrdersStatusSummary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InteriorDesignOrdersStatusSummaryItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetInteriorDesignOrdersStatusSummary(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adminが内装案件を複数の内装会社に送付（バルク）
         * @param {number} orderId 案件Id
         * @param {AdminInteriorDesignOrderSendRequest} adminInteriorDesignOrderSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSendInteriorDesignOrder(orderId: number, adminInteriorDesignOrderSendRequest: AdminInteriorDesignOrderSendRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInteriorDesignOrderSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSendInteriorDesignOrder(orderId, adminInteriorDesignOrderSendRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adminで内装案件を更新。
         * @param {number} orderId 案件Id
         * @param {InteriorDesignOrder} interiorDesignOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateInteriorDesignOrder(orderId: number, interiorDesignOrder: InteriorDesignOrder, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateInteriorDesignOrder(orderId, interiorDesignOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装案件にエントリーする
         * @param {number} orderId 案件ID
         * @param {InteriorDesignOrderEntry} [interiorDesignOrderEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entryInteriorDesignOrder(orderId: number, interiorDesignOrderEntry?: InteriorDesignOrderEntry, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrderEntryPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entryInteriorDesignOrder(orderId, interiorDesignOrderEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a interior design order.
         * @param {number} orderId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignInteriorDesignOrder(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDesignInteriorDesignOrder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignInteriorDesignOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した `order_id` に紐づく内装会社と、その会社が当該案件に対して登録した応募情報（status, sentAt, message, enteredAt, matchedAt など）を返します。 
         * @summary 指定案件に紐づく内装会社一覧（応募情報付き）を取得します
         * @param {number} orderId 取得対象の案件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignCompaniesByOrder(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignCompanyForOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignCompaniesByOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a interior design order.
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignOrder(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get interior design orders.
         * @param {number} [page] ページ番号
         * @param {Array<InteriorDesignCompanyInteriorDesignOrderStatus>} [status] 内装案件取得対象の案件ステータス
         * @param {boolean} [excludeDrop] true の場合、DROP ステータスの案件を結果から除外
         * @param {boolean} [includeDroppedOrdersWhenLinked] true の場合、内装会社との紐づきがある案件について「会社側ステータス条件」に加えて「案件側ステータスがDROP系」の案件もOR条件で結果に含める
         * @param {boolean} [excludePreEntry] true の場合、終了タブに返す案件から内装ステータス PRE_ENTRY を除外
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInteriorDesignOrders(page?: number, status?: Array<InteriorDesignCompanyInteriorDesignOrderStatus>, excludeDrop?: boolean, includeDroppedOrdersWhenLinked?: boolean, excludePreEntry?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInteriorDesignOrders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInteriorDesignOrders(page, status, excludeDrop, includeDroppedOrdersWhenLinked, excludePreEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装案件エントリーのステータスの部分更新
         * @param {number} orderId 案件ID
         * @param {PatchInteriorDesignOrderEntryStatusRequest} [patchInteriorDesignOrderEntryStatusRequest] 内装案件エントリーの部分更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchInteriorDesignOrderEntryStatus(orderId: number, patchInteriorDesignOrderEntryStatusRequest?: PatchInteriorDesignOrderEntryStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrderEntryPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchInteriorDesignOrderEntryStatus(orderId, patchInteriorDesignOrderEntryStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 内装案件の物件契約状況を部分更新する
         * @param {number} orderId 案件ID
         * @param {PatchInteriorDesignOrderPropertyStatusRequest} [patchInteriorDesignOrderPropertyStatusRequest] 内装案件の物件契約状況を部分更新するリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchInteriorDesignOrderPropertyStatus(orderId: number, patchInteriorDesignOrderPropertyStatusRequest?: PatchInteriorDesignOrderPropertyStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrderPropertyPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchInteriorDesignOrderPropertyStatus(orderId, patchInteriorDesignOrderPropertyStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した `order_id` に対し、リクエストボディで与えられた `company_ids` の一覧を処理します。 - 既存で紐づく `InteriorDesignCompanyInteriorDesignOrder` があり、かつ status が `ENTRY_IN_PROGRESS` の場合は `MATCHING_ESTABLISHED` に更新します。 - 紐づきが存在しない場合は新規に `InteriorDesignCompanyInteriorDesignOrder` を作成し、status を `MATCHING_ESTABLISHED` にして紐づけます。 処理後、該当案件に紐づく会社一覧（`InteriorDesignCompanyForOrderListResponse`）を返します。 
         * @summary 指定案件に対して会社をマッチングして紐づけを作成／更新します
         * @param {number} orderId 対象の案件 ID
         * @param {InteriorDesignCompanyMatchingRequest} interiorDesignCompanyMatchingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInteriorDesignCompanyMatching(orderId: number, interiorDesignCompanyMatchingRequest: InteriorDesignCompanyMatchingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignCompanyForOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInteriorDesignCompanyMatching(orderId, interiorDesignCompanyMatchingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運営への共有事項を追加する
         * @param {number} orderId 案件ID
         * @param {PostInteriorDesignOrderCompanySharedNoteRequest} [postInteriorDesignOrderCompanySharedNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInteriorDesignOrderCompanySharedNote(orderId: number, postInteriorDesignOrderCompanySharedNoteRequest?: PostInteriorDesignOrderCompanySharedNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignOrderPostCompanySharedNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInteriorDesignOrderCompanySharedNote(orderId, postInteriorDesignOrderCompanySharedNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した `order_id` と `company_id` に紐づく中間テーブル `InteriorDesignCompanyInteriorDesignOrder` を更新します。 リクエストボディの内容でリソースを上書きします。存在しない場合は 404 を返します。 - バリデーションエラーは 400、存在しないリソースは 404 を返します。 
         * @summary 指定案件に紐づく会社の紐づけ情報（中間テーブル）を更新します
         * @param {number} orderId 更新対象の案件 ID
         * @param {number} companyId 更新対象の会社 ID
         * @param {InteriorDesignCompanyInteriorDesignOrder} interiorDesignCompanyInteriorDesignOrder 更新する &#x60;InteriorDesignCompanyInteriorDesignOrder&#x60; を指定します（完全更新）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putInteriorDesignCompanyInteriorDesignOrder(orderId: number, companyId: number, interiorDesignCompanyInteriorDesignOrder: InteriorDesignCompanyInteriorDesignOrder, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteriorDesignCompanyInteriorDesignOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putInteriorDesignCompanyInteriorDesignOrder(orderId, companyId, interiorDesignCompanyInteriorDesignOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * スプレッドシート取り込み
         * @summary 内装案件スプレッドシート同期（実行トリガー）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncInteriorDesignOrderSpreadsheet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncInteriorDesignOrderSpreadsheet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InteriorDesignOrderApi - factory interface
 * @export
 */
export const InteriorDesignOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InteriorDesignOrderApiFp(configuration)
    return {
        /**
         * Admin Get a interior design order.
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrder(orderId: number, options?: any): AxiosPromise<InteriorDesignOrder> {
            return localVarFp.adminGetInteriorDesignOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した内装案件に紐づく内装会社への送付（中間テーブル）の一覧を取得する
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrderSends(orderId: number, options?: any): AxiosPromise<AdminInteriorDesignOrderSendingListResponse> {
            return localVarFp.adminGetInteriorDesignOrderSends(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get interior design orders.
         * @param {number} page ページ番号
         * @param {AdminGetInteriorDesignOrdersSortEnum} [sort] 昇順／降順（asc または desc）
         * @param {Array<InteriorDesignOrderStatus>} [status] 内装ステータス（フィルタ。複数指定可）
         * @param {InteriorDesignOrderPropertyStatus} [propertyStatus] 物件ステータス（フィルタ）
         * @param {number} [id] 内部管理番号（id）
         * @param {string} [clientName] 氏名（部分一致。旧 title フィルタから移行）
         * @param {InteriorDesignOrderOperators} [operatorId] 伴走者オペレーターID
         * @param {string} [clientPhoneNumber] 電話番号（clientPhoneNumber 部分一致）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrders(page: number, sort?: AdminGetInteriorDesignOrdersSortEnum, status?: Array<InteriorDesignOrderStatus>, propertyStatus?: InteriorDesignOrderPropertyStatus, id?: number, clientName?: string, operatorId?: InteriorDesignOrderOperators, clientPhoneNumber?: string, options?: any): AxiosPromise<InteriorDesignOrderListGetResponse> {
            return localVarFp.adminGetInteriorDesignOrders(page, sort, status, propertyStatus, id, clientName, operatorId, clientPhoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 全案件のステータスサマリーを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetInteriorDesignOrdersStatusSummary(options?: any): AxiosPromise<Array<InteriorDesignOrdersStatusSummaryItem>> {
            return localVarFp.adminGetInteriorDesignOrdersStatusSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Adminが内装案件を複数の内装会社に送付（バルク）
         * @param {number} orderId 案件Id
         * @param {AdminInteriorDesignOrderSendRequest} adminInteriorDesignOrderSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendInteriorDesignOrder(orderId: number, adminInteriorDesignOrderSendRequest: AdminInteriorDesignOrderSendRequest, options?: any): AxiosPromise<AdminInteriorDesignOrderSendResponse> {
            return localVarFp.adminSendInteriorDesignOrder(orderId, adminInteriorDesignOrderSendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adminで内装案件を更新。
         * @param {number} orderId 案件Id
         * @param {InteriorDesignOrder} interiorDesignOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateInteriorDesignOrder(orderId: number, interiorDesignOrder: InteriorDesignOrder, options?: any): AxiosPromise<InteriorDesignOrder> {
            return localVarFp.adminUpdateInteriorDesignOrder(orderId, interiorDesignOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装案件にエントリーする
         * @param {number} orderId 案件ID
         * @param {InteriorDesignOrderEntry} [interiorDesignOrderEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entryInteriorDesignOrder(orderId: number, interiorDesignOrderEntry?: InteriorDesignOrderEntry, options?: any): AxiosPromise<InteriorDesignOrderEntryPatchResponse> {
            return localVarFp.entryInteriorDesignOrder(orderId, interiorDesignOrderEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a interior design order.
         * @param {number} orderId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignInteriorDesignOrder(orderId: number, options?: any): AxiosPromise<GetDesignInteriorDesignOrder200Response> {
            return localVarFp.getDesignInteriorDesignOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した `order_id` に紐づく内装会社と、その会社が当該案件に対して登録した応募情報（status, sentAt, message, enteredAt, matchedAt など）を返します。 
         * @summary 指定案件に紐づく内装会社一覧（応募情報付き）を取得します
         * @param {number} orderId 取得対象の案件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignCompaniesByOrder(orderId: number, options?: any): AxiosPromise<InteriorDesignCompanyForOrderListResponse> {
            return localVarFp.getInteriorDesignCompaniesByOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a interior design order.
         * @param {number} orderId 案件Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignOrder(orderId: number, options?: any): AxiosPromise<InteriorDesignOrder> {
            return localVarFp.getInteriorDesignOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get interior design orders.
         * @param {number} [page] ページ番号
         * @param {Array<InteriorDesignCompanyInteriorDesignOrderStatus>} [status] 内装案件取得対象の案件ステータス
         * @param {boolean} [excludeDrop] true の場合、DROP ステータスの案件を結果から除外
         * @param {boolean} [includeDroppedOrdersWhenLinked] true の場合、内装会社との紐づきがある案件について「会社側ステータス条件」に加えて「案件側ステータスがDROP系」の案件もOR条件で結果に含める
         * @param {boolean} [excludePreEntry] true の場合、終了タブに返す案件から内装ステータス PRE_ENTRY を除外
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInteriorDesignOrders(page?: number, status?: Array<InteriorDesignCompanyInteriorDesignOrderStatus>, excludeDrop?: boolean, includeDroppedOrdersWhenLinked?: boolean, excludePreEntry?: boolean, options?: any): AxiosPromise<GetInteriorDesignOrders200Response> {
            return localVarFp.getInteriorDesignOrders(page, status, excludeDrop, includeDroppedOrdersWhenLinked, excludePreEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装案件エントリーのステータスの部分更新
         * @param {number} orderId 案件ID
         * @param {PatchInteriorDesignOrderEntryStatusRequest} [patchInteriorDesignOrderEntryStatusRequest] 内装案件エントリーの部分更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInteriorDesignOrderEntryStatus(orderId: number, patchInteriorDesignOrderEntryStatusRequest?: PatchInteriorDesignOrderEntryStatusRequest, options?: any): AxiosPromise<InteriorDesignOrderEntryPatchResponse> {
            return localVarFp.patchInteriorDesignOrderEntryStatus(orderId, patchInteriorDesignOrderEntryStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 内装案件の物件契約状況を部分更新する
         * @param {number} orderId 案件ID
         * @param {PatchInteriorDesignOrderPropertyStatusRequest} [patchInteriorDesignOrderPropertyStatusRequest] 内装案件の物件契約状況を部分更新するリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInteriorDesignOrderPropertyStatus(orderId: number, patchInteriorDesignOrderPropertyStatusRequest?: PatchInteriorDesignOrderPropertyStatusRequest, options?: any): AxiosPromise<InteriorDesignOrderPropertyPatchResponse> {
            return localVarFp.patchInteriorDesignOrderPropertyStatus(orderId, patchInteriorDesignOrderPropertyStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した `order_id` に対し、リクエストボディで与えられた `company_ids` の一覧を処理します。 - 既存で紐づく `InteriorDesignCompanyInteriorDesignOrder` があり、かつ status が `ENTRY_IN_PROGRESS` の場合は `MATCHING_ESTABLISHED` に更新します。 - 紐づきが存在しない場合は新規に `InteriorDesignCompanyInteriorDesignOrder` を作成し、status を `MATCHING_ESTABLISHED` にして紐づけます。 処理後、該当案件に紐づく会社一覧（`InteriorDesignCompanyForOrderListResponse`）を返します。 
         * @summary 指定案件に対して会社をマッチングして紐づけを作成／更新します
         * @param {number} orderId 対象の案件 ID
         * @param {InteriorDesignCompanyMatchingRequest} interiorDesignCompanyMatchingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInteriorDesignCompanyMatching(orderId: number, interiorDesignCompanyMatchingRequest: InteriorDesignCompanyMatchingRequest, options?: any): AxiosPromise<InteriorDesignCompanyForOrderListResponse> {
            return localVarFp.postInteriorDesignCompanyMatching(orderId, interiorDesignCompanyMatchingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 運営への共有事項を追加する
         * @param {number} orderId 案件ID
         * @param {PostInteriorDesignOrderCompanySharedNoteRequest} [postInteriorDesignOrderCompanySharedNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInteriorDesignOrderCompanySharedNote(orderId: number, postInteriorDesignOrderCompanySharedNoteRequest?: PostInteriorDesignOrderCompanySharedNoteRequest, options?: any): AxiosPromise<InteriorDesignOrderPostCompanySharedNoteResponse> {
            return localVarFp.postInteriorDesignOrderCompanySharedNote(orderId, postInteriorDesignOrderCompanySharedNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した `order_id` と `company_id` に紐づく中間テーブル `InteriorDesignCompanyInteriorDesignOrder` を更新します。 リクエストボディの内容でリソースを上書きします。存在しない場合は 404 を返します。 - バリデーションエラーは 400、存在しないリソースは 404 を返します。 
         * @summary 指定案件に紐づく会社の紐づけ情報（中間テーブル）を更新します
         * @param {number} orderId 更新対象の案件 ID
         * @param {number} companyId 更新対象の会社 ID
         * @param {InteriorDesignCompanyInteriorDesignOrder} interiorDesignCompanyInteriorDesignOrder 更新する &#x60;InteriorDesignCompanyInteriorDesignOrder&#x60; を指定します（完全更新）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putInteriorDesignCompanyInteriorDesignOrder(orderId: number, companyId: number, interiorDesignCompanyInteriorDesignOrder: InteriorDesignCompanyInteriorDesignOrder, options?: any): AxiosPromise<InteriorDesignCompanyInteriorDesignOrder> {
            return localVarFp.putInteriorDesignCompanyInteriorDesignOrder(orderId, companyId, interiorDesignCompanyInteriorDesignOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * スプレッドシート取り込み
         * @summary 内装案件スプレッドシート同期（実行トリガー）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInteriorDesignOrderSpreadsheet(options?: any): AxiosPromise<void> {
            return localVarFp.syncInteriorDesignOrderSpreadsheet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InteriorDesignOrderApi - object-oriented interface
 * @export
 * @class InteriorDesignOrderApi
 * @extends {BaseAPI}
 */
export class InteriorDesignOrderApi extends BaseAPI {
    /**
     * Admin Get a interior design order.
     * @param {number} orderId 案件Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public adminGetInteriorDesignOrder(orderId: number, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).adminGetInteriorDesignOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した内装案件に紐づく内装会社への送付（中間テーブル）の一覧を取得する
     * @param {number} orderId 案件Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public adminGetInteriorDesignOrderSends(orderId: number, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).adminGetInteriorDesignOrderSends(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get interior design orders.
     * @param {number} page ページ番号
     * @param {AdminGetInteriorDesignOrdersSortEnum} [sort] 昇順／降順（asc または desc）
     * @param {Array<InteriorDesignOrderStatus>} [status] 内装ステータス（フィルタ。複数指定可）
     * @param {InteriorDesignOrderPropertyStatus} [propertyStatus] 物件ステータス（フィルタ）
     * @param {number} [id] 内部管理番号（id）
     * @param {string} [clientName] 氏名（部分一致。旧 title フィルタから移行）
     * @param {InteriorDesignOrderOperators} [operatorId] 伴走者オペレーターID
     * @param {string} [clientPhoneNumber] 電話番号（clientPhoneNumber 部分一致）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public adminGetInteriorDesignOrders(page: number, sort?: AdminGetInteriorDesignOrdersSortEnum, status?: Array<InteriorDesignOrderStatus>, propertyStatus?: InteriorDesignOrderPropertyStatus, id?: number, clientName?: string, operatorId?: InteriorDesignOrderOperators, clientPhoneNumber?: string, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).adminGetInteriorDesignOrders(page, sort, status, propertyStatus, id, clientName, operatorId, clientPhoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 全案件のステータスサマリーを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public adminGetInteriorDesignOrdersStatusSummary(options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).adminGetInteriorDesignOrdersStatusSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adminが内装案件を複数の内装会社に送付（バルク）
     * @param {number} orderId 案件Id
     * @param {AdminInteriorDesignOrderSendRequest} adminInteriorDesignOrderSendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public adminSendInteriorDesignOrder(orderId: number, adminInteriorDesignOrderSendRequest: AdminInteriorDesignOrderSendRequest, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).adminSendInteriorDesignOrder(orderId, adminInteriorDesignOrderSendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adminで内装案件を更新。
     * @param {number} orderId 案件Id
     * @param {InteriorDesignOrder} interiorDesignOrder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public adminUpdateInteriorDesignOrder(orderId: number, interiorDesignOrder: InteriorDesignOrder, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).adminUpdateInteriorDesignOrder(orderId, interiorDesignOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装案件にエントリーする
     * @param {number} orderId 案件ID
     * @param {InteriorDesignOrderEntry} [interiorDesignOrderEntry] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public entryInteriorDesignOrder(orderId: number, interiorDesignOrderEntry?: InteriorDesignOrderEntry, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).entryInteriorDesignOrder(orderId, interiorDesignOrderEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a interior design order.
     * @param {number} orderId 案件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public getDesignInteriorDesignOrder(orderId: number, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).getDesignInteriorDesignOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した `order_id` に紐づく内装会社と、その会社が当該案件に対して登録した応募情報（status, sentAt, message, enteredAt, matchedAt など）を返します。 
     * @summary 指定案件に紐づく内装会社一覧（応募情報付き）を取得します
     * @param {number} orderId 取得対象の案件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public getInteriorDesignCompaniesByOrder(orderId: number, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).getInteriorDesignCompaniesByOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a interior design order.
     * @param {number} orderId 案件Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public getInteriorDesignOrder(orderId: number, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).getInteriorDesignOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get interior design orders.
     * @param {number} [page] ページ番号
     * @param {Array<InteriorDesignCompanyInteriorDesignOrderStatus>} [status] 内装案件取得対象の案件ステータス
     * @param {boolean} [excludeDrop] true の場合、DROP ステータスの案件を結果から除外
     * @param {boolean} [includeDroppedOrdersWhenLinked] true の場合、内装会社との紐づきがある案件について「会社側ステータス条件」に加えて「案件側ステータスがDROP系」の案件もOR条件で結果に含める
     * @param {boolean} [excludePreEntry] true の場合、終了タブに返す案件から内装ステータス PRE_ENTRY を除外
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public getInteriorDesignOrders(page?: number, status?: Array<InteriorDesignCompanyInteriorDesignOrderStatus>, excludeDrop?: boolean, includeDroppedOrdersWhenLinked?: boolean, excludePreEntry?: boolean, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).getInteriorDesignOrders(page, status, excludeDrop, includeDroppedOrdersWhenLinked, excludePreEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装案件エントリーのステータスの部分更新
     * @param {number} orderId 案件ID
     * @param {PatchInteriorDesignOrderEntryStatusRequest} [patchInteriorDesignOrderEntryStatusRequest] 内装案件エントリーの部分更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public patchInteriorDesignOrderEntryStatus(orderId: number, patchInteriorDesignOrderEntryStatusRequest?: PatchInteriorDesignOrderEntryStatusRequest, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).patchInteriorDesignOrderEntryStatus(orderId, patchInteriorDesignOrderEntryStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 内装案件の物件契約状況を部分更新する
     * @param {number} orderId 案件ID
     * @param {PatchInteriorDesignOrderPropertyStatusRequest} [patchInteriorDesignOrderPropertyStatusRequest] 内装案件の物件契約状況を部分更新するリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public patchInteriorDesignOrderPropertyStatus(orderId: number, patchInteriorDesignOrderPropertyStatusRequest?: PatchInteriorDesignOrderPropertyStatusRequest, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).patchInteriorDesignOrderPropertyStatus(orderId, patchInteriorDesignOrderPropertyStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した `order_id` に対し、リクエストボディで与えられた `company_ids` の一覧を処理します。 - 既存で紐づく `InteriorDesignCompanyInteriorDesignOrder` があり、かつ status が `ENTRY_IN_PROGRESS` の場合は `MATCHING_ESTABLISHED` に更新します。 - 紐づきが存在しない場合は新規に `InteriorDesignCompanyInteriorDesignOrder` を作成し、status を `MATCHING_ESTABLISHED` にして紐づけます。 処理後、該当案件に紐づく会社一覧（`InteriorDesignCompanyForOrderListResponse`）を返します。 
     * @summary 指定案件に対して会社をマッチングして紐づけを作成／更新します
     * @param {number} orderId 対象の案件 ID
     * @param {InteriorDesignCompanyMatchingRequest} interiorDesignCompanyMatchingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public postInteriorDesignCompanyMatching(orderId: number, interiorDesignCompanyMatchingRequest: InteriorDesignCompanyMatchingRequest, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).postInteriorDesignCompanyMatching(orderId, interiorDesignCompanyMatchingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運営への共有事項を追加する
     * @param {number} orderId 案件ID
     * @param {PostInteriorDesignOrderCompanySharedNoteRequest} [postInteriorDesignOrderCompanySharedNoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public postInteriorDesignOrderCompanySharedNote(orderId: number, postInteriorDesignOrderCompanySharedNoteRequest?: PostInteriorDesignOrderCompanySharedNoteRequest, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).postInteriorDesignOrderCompanySharedNote(orderId, postInteriorDesignOrderCompanySharedNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した `order_id` と `company_id` に紐づく中間テーブル `InteriorDesignCompanyInteriorDesignOrder` を更新します。 リクエストボディの内容でリソースを上書きします。存在しない場合は 404 を返します。 - バリデーションエラーは 400、存在しないリソースは 404 を返します。 
     * @summary 指定案件に紐づく会社の紐づけ情報（中間テーブル）を更新します
     * @param {number} orderId 更新対象の案件 ID
     * @param {number} companyId 更新対象の会社 ID
     * @param {InteriorDesignCompanyInteriorDesignOrder} interiorDesignCompanyInteriorDesignOrder 更新する &#x60;InteriorDesignCompanyInteriorDesignOrder&#x60; を指定します（完全更新）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public putInteriorDesignCompanyInteriorDesignOrder(orderId: number, companyId: number, interiorDesignCompanyInteriorDesignOrder: InteriorDesignCompanyInteriorDesignOrder, options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).putInteriorDesignCompanyInteriorDesignOrder(orderId, companyId, interiorDesignCompanyInteriorDesignOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * スプレッドシート取り込み
     * @summary 内装案件スプレッドシート同期（実行トリガー）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InteriorDesignOrderApi
     */
    public syncInteriorDesignOrderSpreadsheet(options?: AxiosRequestConfig) {
        return InteriorDesignOrderApiFp(this.configuration).syncInteriorDesignOrderSpreadsheet(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminGetInteriorDesignOrdersSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminGetInteriorDesignOrdersSortEnum = typeof AdminGetInteriorDesignOrdersSortEnum[keyof typeof AdminGetInteriorDesignOrdersSortEnum];


/**
 * LineMessagingApi - axios parameter creator
 * @export
 */
export const LineMessagingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 電話番号と一致する会員を取得する。
         * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
         * @param {string} [phoneNumber] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByPhoneNumber: async (phoneNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LINEのアカウントと会員情報を連携する。
         * @summary 未連携のLINE情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreLineMessagingUserList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line_messaging/user_list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LINEのアカウントと会員情報を連携する。
         * @summary LINE連携
         * @param {Line} [line] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLineInfo: async (line?: Line, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line_messaging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(line, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 該当のユーザーにLINE IDを登録する
         * @summary 会員情報にLINE IDを登録する
         * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLineMessagingId: async (registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerLineMessagingIdRequest' is not null or undefined
            assertParamExists('registerLineMessagingId', 'registerLineMessagingIdRequest', registerLineMessagingIdRequest)
            const localVarPath = `/user/line_messaging_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerLineMessagingIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LineMessagingApi - functional programming interface
 * @export
 */
export const LineMessagingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LineMessagingApiAxiosParamCreator(configuration)
    return {
        /**
         * 電話番号と一致する会員を取得する。
         * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
         * @param {string} [phoneNumber] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberByPhoneNumber(phoneNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberByPhoneNumber(phoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * LINEのアカウントと会員情報を連携する。
         * @summary 未連携のLINE情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreLineMessagingUserList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPreLineMessagingUserList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreLineMessagingUserList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * LINEのアカウントと会員情報を連携する。
         * @summary LINE連携
         * @param {Line} [line] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLineInfo(line?: Line, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRegistrationTemp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLineInfo(line, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 該当のユーザーにLINE IDを登録する
         * @summary 会員情報にLINE IDを登録する
         * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerLineMessagingId(registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerLineMessagingId(registerLineMessagingIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LineMessagingApi - factory interface
 * @export
 */
export const LineMessagingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LineMessagingApiFp(configuration)
    return {
        /**
         * 電話番号と一致する会員を取得する。
         * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
         * @param {string} [phoneNumber] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByPhoneNumber(phoneNumber?: string, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.getMemberByPhoneNumber(phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * LINEのアカウントと会員情報を連携する。
         * @summary 未連携のLINE情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreLineMessagingUserList(options?: any): AxiosPromise<GetPreLineMessagingUserList200Response> {
            return localVarFp.getPreLineMessagingUserList(options).then((request) => request(axios, basePath));
        },
        /**
         * LINEのアカウントと会員情報を連携する。
         * @summary LINE連携
         * @param {Line} [line] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLineInfo(line?: Line, options?: any): AxiosPromise<CreateRegistrationTemp200Response> {
            return localVarFp.postLineInfo(line, options).then((request) => request(axios, basePath));
        },
        /**
         * 該当のユーザーにLINE IDを登録する
         * @summary 会員情報にLINE IDを登録する
         * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLineMessagingId(registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.registerLineMessagingId(registerLineMessagingIdRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LineMessagingApi - object-oriented interface
 * @export
 * @class LineMessagingApi
 * @extends {BaseAPI}
 */
export class LineMessagingApi extends BaseAPI {
    /**
     * 電話番号と一致する会員を取得する。
     * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
     * @param {string} [phoneNumber] 電話番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineMessagingApi
     */
    public getMemberByPhoneNumber(phoneNumber?: string, options?: AxiosRequestConfig) {
        return LineMessagingApiFp(this.configuration).getMemberByPhoneNumber(phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LINEのアカウントと会員情報を連携する。
     * @summary 未連携のLINE情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineMessagingApi
     */
    public getPreLineMessagingUserList(options?: AxiosRequestConfig) {
        return LineMessagingApiFp(this.configuration).getPreLineMessagingUserList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LINEのアカウントと会員情報を連携する。
     * @summary LINE連携
     * @param {Line} [line] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineMessagingApi
     */
    public postLineInfo(line?: Line, options?: AxiosRequestConfig) {
        return LineMessagingApiFp(this.configuration).postLineInfo(line, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 該当のユーザーにLINE IDを登録する
     * @summary 会員情報にLINE IDを登録する
     * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineMessagingApi
     */
    public registerLineMessagingId(registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options?: AxiosRequestConfig) {
        return LineMessagingApiFp(this.configuration).registerLineMessagingId(registerLineMessagingIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MAreaApi - axios parameter creator
 * @export
 */
export const MAreaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 地域のマスターを取得する。
         * @summary 地域マスター取得
         * @param {number} [id] 地域ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMAreaList: async (id?: number, prefectureId?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/m/area`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (prefectureId !== undefined) {
                localVarQueryParameter['prefecture_id'] = prefectureId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MAreaApi - functional programming interface
 * @export
 */
export const MAreaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MAreaApiAxiosParamCreator(configuration)
    return {
        /**
         * 地域のマスターを取得する。
         * @summary 地域マスター取得
         * @param {number} [id] 地域ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMAreaList(id?: number, prefectureId?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMAreaList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMAreaList(id, prefectureId, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MAreaApi - factory interface
 * @export
 */
export const MAreaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MAreaApiFp(configuration)
    return {
        /**
         * 地域のマスターを取得する。
         * @summary 地域マスター取得
         * @param {number} [id] 地域ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMAreaList(id?: number, prefectureId?: number, page?: number, options?: any): AxiosPromise<GetMAreaList200Response> {
            return localVarFp.getMAreaList(id, prefectureId, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MAreaApi - object-oriented interface
 * @export
 * @class MAreaApi
 * @extends {BaseAPI}
 */
export class MAreaApi extends BaseAPI {
    /**
     * 地域のマスターを取得する。
     * @summary 地域マスター取得
     * @param {number} [id] 地域ID
     * @param {number} [prefectureId] 都道府県ID
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MAreaApi
     */
    public getMAreaList(id?: number, prefectureId?: number, page?: number, options?: AxiosRequestConfig) {
        return MAreaApiFp(this.configuration).getMAreaList(id, prefectureId, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MLineApi - axios parameter creator
 * @export
 */
export const MLineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 路線のマスターを取得する。
         * @summary 路線マスター取得
         * @param {number} [id] 路線ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMLineList: async (id?: number, prefectureId?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/m/line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (prefectureId !== undefined) {
                localVarQueryParameter['prefecture_id'] = prefectureId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MLineApi - functional programming interface
 * @export
 */
export const MLineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MLineApiAxiosParamCreator(configuration)
    return {
        /**
         * 路線のマスターを取得する。
         * @summary 路線マスター取得
         * @param {number} [id] 路線ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMLineList(id?: number, prefectureId?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMLineList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMLineList(id, prefectureId, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MLineApi - factory interface
 * @export
 */
export const MLineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MLineApiFp(configuration)
    return {
        /**
         * 路線のマスターを取得する。
         * @summary 路線マスター取得
         * @param {number} [id] 路線ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMLineList(id?: number, prefectureId?: number, page?: number, options?: any): AxiosPromise<GetMLineList200Response> {
            return localVarFp.getMLineList(id, prefectureId, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MLineApi - object-oriented interface
 * @export
 * @class MLineApi
 * @extends {BaseAPI}
 */
export class MLineApi extends BaseAPI {
    /**
     * 路線のマスターを取得する。
     * @summary 路線マスター取得
     * @param {number} [id] 路線ID
     * @param {number} [prefectureId] 都道府県ID
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MLineApi
     */
    public getMLineList(id?: number, prefectureId?: number, page?: number, options?: AxiosRequestConfig) {
        return MLineApiFp(this.configuration).getMLineList(id, prefectureId, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MOptionApi - axios parameter creator
 * @export
 */
export const MOptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 選択肢のマスターを取得する。
         * @summary 選択肢マスター取得
         * @param {number} [id] 選択肢ID
         * @param {number} [categoryId] 選択肢カテゴリID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMOptionList: async (id?: number, categoryId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/m/selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MOptionApi - functional programming interface
 * @export
 */
export const MOptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MOptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 選択肢のマスターを取得する。
         * @summary 選択肢マスター取得
         * @param {number} [id] 選択肢ID
         * @param {number} [categoryId] 選択肢カテゴリID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMOptionList(id?: number, categoryId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMOptionList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMOptionList(id, categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MOptionApi - factory interface
 * @export
 */
export const MOptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MOptionApiFp(configuration)
    return {
        /**
         * 選択肢のマスターを取得する。
         * @summary 選択肢マスター取得
         * @param {number} [id] 選択肢ID
         * @param {number} [categoryId] 選択肢カテゴリID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMOptionList(id?: number, categoryId?: number, options?: any): AxiosPromise<GetMOptionList200Response> {
            return localVarFp.getMOptionList(id, categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MOptionApi - object-oriented interface
 * @export
 * @class MOptionApi
 * @extends {BaseAPI}
 */
export class MOptionApi extends BaseAPI {
    /**
     * 選択肢のマスターを取得する。
     * @summary 選択肢マスター取得
     * @param {number} [id] 選択肢ID
     * @param {number} [categoryId] 選択肢カテゴリID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MOptionApi
     */
    public getMOptionList(id?: number, categoryId?: number, options?: AxiosRequestConfig) {
        return MOptionApiFp(this.configuration).getMOptionList(id, categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MOptionReferenceApi - axios parameter creator
 * @export
 */
export const MOptionReferenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 選択肢基準値マスターを取得する。
         * @summary 選択肢基準値マスター取得
         * @param {number} optionId 選択肢ID
         * @param {Array<string>} [sectionNames] 区分名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceList: async (optionId: number, sectionNames?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('getReferenceList', 'optionId', optionId)
            const localVarPath = `/m/option_reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sectionNames) {
                localVarQueryParameter['section_names'] = sectionNames.join(COLLECTION_FORMATS.csv);
            }

            if (optionId !== undefined) {
                localVarQueryParameter['option_id'] = optionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MOptionReferenceApi - functional programming interface
 * @export
 */
export const MOptionReferenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MOptionReferenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 選択肢基準値マスターを取得する。
         * @summary 選択肢基準値マスター取得
         * @param {number} optionId 選択肢ID
         * @param {Array<string>} [sectionNames] 区分名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferenceList(optionId: number, sectionNames?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferenceList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferenceList(optionId, sectionNames, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MOptionReferenceApi - factory interface
 * @export
 */
export const MOptionReferenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MOptionReferenceApiFp(configuration)
    return {
        /**
         * 選択肢基準値マスターを取得する。
         * @summary 選択肢基準値マスター取得
         * @param {number} optionId 選択肢ID
         * @param {Array<string>} [sectionNames] 区分名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceList(optionId: number, sectionNames?: Array<string>, options?: any): AxiosPromise<GetReferenceList200Response> {
            return localVarFp.getReferenceList(optionId, sectionNames, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MOptionReferenceApi - object-oriented interface
 * @export
 * @class MOptionReferenceApi
 * @extends {BaseAPI}
 */
export class MOptionReferenceApi extends BaseAPI {
    /**
     * 選択肢基準値マスターを取得する。
     * @summary 選択肢基準値マスター取得
     * @param {number} optionId 選択肢ID
     * @param {Array<string>} [sectionNames] 区分名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MOptionReferenceApi
     */
    public getReferenceList(optionId: number, sectionNames?: Array<string>, options?: AxiosRequestConfig) {
        return MOptionReferenceApiFp(this.configuration).getReferenceList(optionId, sectionNames, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MPrefectureApi - axios parameter creator
 * @export
 */
export const MPrefectureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 都道府県のマスターを取得する。
         * @summary 都道府県マスター取得
         * @param {number} [id] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMPrefectureList: async (id?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/m/prefecture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MPrefectureApi - functional programming interface
 * @export
 */
export const MPrefectureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MPrefectureApiAxiosParamCreator(configuration)
    return {
        /**
         * 都道府県のマスターを取得する。
         * @summary 都道府県マスター取得
         * @param {number} [id] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMPrefectureList(id?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMPrefectureList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMPrefectureList(id, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MPrefectureApi - factory interface
 * @export
 */
export const MPrefectureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MPrefectureApiFp(configuration)
    return {
        /**
         * 都道府県のマスターを取得する。
         * @summary 都道府県マスター取得
         * @param {number} [id] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMPrefectureList(id?: number, page?: number, options?: any): AxiosPromise<GetMPrefectureList200Response> {
            return localVarFp.getMPrefectureList(id, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MPrefectureApi - object-oriented interface
 * @export
 * @class MPrefectureApi
 * @extends {BaseAPI}
 */
export class MPrefectureApi extends BaseAPI {
    /**
     * 都道府県のマスターを取得する。
     * @summary 都道府県マスター取得
     * @param {number} [id] 都道府県ID
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPrefectureApi
     */
    public getMPrefectureList(id?: number, page?: number, options?: AxiosRequestConfig) {
        return MPrefectureApiFp(this.configuration).getMPrefectureList(id, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MStationApi - axios parameter creator
 * @export
 */
export const MStationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 駅のマスターを取得する。
         * @summary 駅マスター取得
         * @param {Array<number>} [ids] 駅ID
         * @param {Array<number>} [lineIds] 路線ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMStationList: async (ids?: Array<number>, lineIds?: Array<number>, prefectureId?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/m/station`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (lineIds) {
                localVarQueryParameter['line_ids'] = lineIds.join(COLLECTION_FORMATS.csv);
            }

            if (prefectureId !== undefined) {
                localVarQueryParameter['prefecture_id'] = prefectureId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MStationApi - functional programming interface
 * @export
 */
export const MStationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MStationApiAxiosParamCreator(configuration)
    return {
        /**
         * 駅のマスターを取得する。
         * @summary 駅マスター取得
         * @param {Array<number>} [ids] 駅ID
         * @param {Array<number>} [lineIds] 路線ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMStationList(ids?: Array<number>, lineIds?: Array<number>, prefectureId?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMStationList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMStationList(ids, lineIds, prefectureId, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MStationApi - factory interface
 * @export
 */
export const MStationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MStationApiFp(configuration)
    return {
        /**
         * 駅のマスターを取得する。
         * @summary 駅マスター取得
         * @param {Array<number>} [ids] 駅ID
         * @param {Array<number>} [lineIds] 路線ID
         * @param {number} [prefectureId] 都道府県ID
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMStationList(ids?: Array<number>, lineIds?: Array<number>, prefectureId?: number, page?: number, options?: any): AxiosPromise<GetMStationList200Response> {
            return localVarFp.getMStationList(ids, lineIds, prefectureId, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MStationApi - object-oriented interface
 * @export
 * @class MStationApi
 * @extends {BaseAPI}
 */
export class MStationApi extends BaseAPI {
    /**
     * 駅のマスターを取得する。
     * @summary 駅マスター取得
     * @param {Array<number>} [ids] 駅ID
     * @param {Array<number>} [lineIds] 路線ID
     * @param {number} [prefectureId] 都道府県ID
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MStationApi
     */
    public getMStationList(ids?: Array<number>, lineIds?: Array<number>, prefectureId?: number, page?: number, options?: AxiosRequestConfig) {
        return MStationApiFp(this.configuration).getMStationList(ids, lineIds, prefectureId, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MTaxRateApi - axios parameter creator
 * @export
 */
export const MTaxRateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 税率を取得する。
         * @summary 税率取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMTaxRate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/m/tax_rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MTaxRateApi - functional programming interface
 * @export
 */
export const MTaxRateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MTaxRateApiAxiosParamCreator(configuration)
    return {
        /**
         * 税率を取得する。
         * @summary 税率取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMTaxRate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMTaxRate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMTaxRate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MTaxRateApi - factory interface
 * @export
 */
export const MTaxRateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MTaxRateApiFp(configuration)
    return {
        /**
         * 税率を取得する。
         * @summary 税率取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMTaxRate(options?: any): AxiosPromise<GetMTaxRate200Response> {
            return localVarFp.getMTaxRate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MTaxRateApi - object-oriented interface
 * @export
 * @class MTaxRateApi
 * @extends {BaseAPI}
 */
export class MTaxRateApi extends BaseAPI {
    /**
     * 税率を取得する。
     * @summary 税率取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTaxRateApi
     */
    public getMTaxRate(options?: AxiosRequestConfig) {
        return MTaxRateApiFp(this.configuration).getMTaxRate(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MailLetterApi - axios parameter creator
 * @export
 */
export const MailLetterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザーのメール配信（新着物件）設定情報を取得します
         * @summary メール配信（新着物件）設定情報取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailLetterProperty: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/mail_letter/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーのメール配信同意設定を取得します
         * @summary メール配信同意設定の取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailLetterSetting: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/mail_letter/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を取得します
         * @summary （運用者）メール配信（新着物件）設定情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpeMailLetterProperty: async (memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/mail_letter/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者が対象会員のメール配信同意設定を取得します
         * @summary （運用者）メール配信同意設定取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpeMailLetterSetting: async (memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/mail_letter/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーのメール配信（新着物件）設定情報を登録します
         * @summary メール配信（新着物件）設定情報登録
         * @param {string} [uid] 会員ID
         * @param {PostMailLetterPropertyRequest} [postMailLetterPropertyRequest] メール配信（新着物件）設定情報登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMailLetterProperty: async (uid?: string, postMailLetterPropertyRequest?: PostMailLetterPropertyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/mail_letter/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postMailLetterPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を登録します
         * @summary （運用者）メール配信（新着物件）設定情報登録
         * @param {number} [memberId] 会員ID
         * @param {OpeMailLetterPropertyRequest} [opeMailLetterPropertyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOpeMailLetterProperty: async (memberId?: number, opeMailLetterPropertyRequest?: OpeMailLetterPropertyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/mail_letter/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opeMailLetterPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メール配信（新着物件）設定情報を解除します
         * @summary メール配信（新着物件）設定情報解除
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailLetterProperty: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/mail_letter/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーのメール配信同意設定を更新します
         * @summary メール配信同意設定の更新
         * @param {string} [uid] 会員ID
         * @param {UpdateMailLetterSettingRequest} [updateMailLetterSettingRequest] メール配信同意設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailLetterSetting: async (uid?: string, updateMailLetterSettingRequest?: UpdateMailLetterSettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/mail_letter/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMailLetterSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者が対象会員のメール配信同意設定を更新します
         * @summary （運用者）メール配信同意設定の更新
         * @param {OpeMailLetterAgreeRequest} opeMailLetterAgreeRequest 
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpeMailLetterAgree: async (opeMailLetterAgreeRequest: OpeMailLetterAgreeRequest, memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opeMailLetterAgreeRequest' is not null or undefined
            assertParamExists('updateOpeMailLetterAgree', 'opeMailLetterAgreeRequest', opeMailLetterAgreeRequest)
            const localVarPath = `/ope/user/mail_letter/agree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opeMailLetterAgreeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を解除します
         * @summary （運用者）メール配信（新着物件）設定情報解除
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpeMailLetterProperty: async (memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/mail_letter/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 運用者が対象会員のメール配信同意設定を更新します
         * @summary （運用者）メール配信同意設定更新
         * @param {number} [memberId] 会員ID
         * @param {OpeMailLetterRequest} [opeMailLetterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpeMailLetterSetting: async (memberId?: number, opeMailLetterRequest?: OpeMailLetterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/mail_letter/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opeMailLetterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailLetterApi - functional programming interface
 * @export
 */
export const MailLetterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailLetterApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザーのメール配信（新着物件）設定情報を取得します
         * @summary メール配信（新着物件）設定情報取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailLetterProperty(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMailLetterProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailLetterProperty(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーのメール配信同意設定を取得します
         * @summary メール配信同意設定の取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailLetterSetting(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMailLetterSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailLetterSetting(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を取得します
         * @summary （運用者）メール配信（新着物件）設定情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpeMailLetterProperty(memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeMailLetterPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpeMailLetterProperty(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者が対象会員のメール配信同意設定を取得します
         * @summary （運用者）メール配信同意設定取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpeMailLetterSetting(memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeMailLetterSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpeMailLetterSetting(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーのメール配信（新着物件）設定情報を登録します
         * @summary メール配信（新着物件）設定情報登録
         * @param {string} [uid] 会員ID
         * @param {PostMailLetterPropertyRequest} [postMailLetterPropertyRequest] メール配信（新着物件）設定情報登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMailLetterProperty(uid?: string, postMailLetterPropertyRequest?: PostMailLetterPropertyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMailLetterProperty(uid, postMailLetterPropertyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を登録します
         * @summary （運用者）メール配信（新着物件）設定情報登録
         * @param {number} [memberId] 会員ID
         * @param {OpeMailLetterPropertyRequest} [opeMailLetterPropertyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOpeMailLetterProperty(memberId?: number, opeMailLetterPropertyRequest?: OpeMailLetterPropertyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeMailLetterPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOpeMailLetterProperty(memberId, opeMailLetterPropertyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メール配信（新着物件）設定情報を解除します
         * @summary メール配信（新着物件）設定情報解除
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMailLetterProperty(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMailLetterProperty(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーのメール配信同意設定を更新します
         * @summary メール配信同意設定の更新
         * @param {string} [uid] 会員ID
         * @param {UpdateMailLetterSettingRequest} [updateMailLetterSettingRequest] メール配信同意設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMailLetterSetting(uid?: string, updateMailLetterSettingRequest?: UpdateMailLetterSettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMailLetterSetting(uid, updateMailLetterSettingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者が対象会員のメール配信同意設定を更新します
         * @summary （運用者）メール配信同意設定の更新
         * @param {OpeMailLetterAgreeRequest} opeMailLetterAgreeRequest 
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOpeMailLetterAgree(opeMailLetterAgreeRequest: OpeMailLetterAgreeRequest, memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOpeMailLetterAgree200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOpeMailLetterAgree(opeMailLetterAgreeRequest, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を解除します
         * @summary （運用者）メール配信（新着物件）設定情報解除
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOpeMailLetterProperty(memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeMailLetterPropertyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOpeMailLetterProperty(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 運用者が対象会員のメール配信同意設定を更新します
         * @summary （運用者）メール配信同意設定更新
         * @param {number} [memberId] 会員ID
         * @param {OpeMailLetterRequest} [opeMailLetterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOpeMailLetterSetting(memberId?: number, opeMailLetterRequest?: OpeMailLetterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeMailLetterSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOpeMailLetterSetting(memberId, opeMailLetterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MailLetterApi - factory interface
 * @export
 */
export const MailLetterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailLetterApiFp(configuration)
    return {
        /**
         * ユーザーのメール配信（新着物件）設定情報を取得します
         * @summary メール配信（新着物件）設定情報取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailLetterProperty(uid?: string, options?: any): AxiosPromise<GetMailLetterProperty200Response> {
            return localVarFp.getMailLetterProperty(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーのメール配信同意設定を取得します
         * @summary メール配信同意設定の取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailLetterSetting(uid?: string, options?: any): AxiosPromise<GetMailLetterSetting200Response> {
            return localVarFp.getMailLetterSetting(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を取得します
         * @summary （運用者）メール配信（新着物件）設定情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpeMailLetterProperty(memberId?: number, options?: any): AxiosPromise<OpeMailLetterPropertyResponse> {
            return localVarFp.getOpeMailLetterProperty(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者が対象会員のメール配信同意設定を取得します
         * @summary （運用者）メール配信同意設定取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpeMailLetterSetting(memberId?: number, options?: any): AxiosPromise<OpeMailLetterSettingResponse> {
            return localVarFp.getOpeMailLetterSetting(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーのメール配信（新着物件）設定情報を登録します
         * @summary メール配信（新着物件）設定情報登録
         * @param {string} [uid] 会員ID
         * @param {PostMailLetterPropertyRequest} [postMailLetterPropertyRequest] メール配信（新着物件）設定情報登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMailLetterProperty(uid?: string, postMailLetterPropertyRequest?: PostMailLetterPropertyRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.postMailLetterProperty(uid, postMailLetterPropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を登録します
         * @summary （運用者）メール配信（新着物件）設定情報登録
         * @param {number} [memberId] 会員ID
         * @param {OpeMailLetterPropertyRequest} [opeMailLetterPropertyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOpeMailLetterProperty(memberId?: number, opeMailLetterPropertyRequest?: OpeMailLetterPropertyRequest, options?: any): AxiosPromise<OpeMailLetterPropertyResponse> {
            return localVarFp.postOpeMailLetterProperty(memberId, opeMailLetterPropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * メール配信（新着物件）設定情報を解除します
         * @summary メール配信（新着物件）設定情報解除
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailLetterProperty(uid?: string, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.updateMailLetterProperty(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーのメール配信同意設定を更新します
         * @summary メール配信同意設定の更新
         * @param {string} [uid] 会員ID
         * @param {UpdateMailLetterSettingRequest} [updateMailLetterSettingRequest] メール配信同意設定更新リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailLetterSetting(uid?: string, updateMailLetterSettingRequest?: UpdateMailLetterSettingRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.updateMailLetterSetting(uid, updateMailLetterSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者が対象会員のメール配信同意設定を更新します
         * @summary （運用者）メール配信同意設定の更新
         * @param {OpeMailLetterAgreeRequest} opeMailLetterAgreeRequest 
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpeMailLetterAgree(opeMailLetterAgreeRequest: OpeMailLetterAgreeRequest, memberId?: number, options?: any): AxiosPromise<UpdateOpeMailLetterAgree200Response> {
            return localVarFp.updateOpeMailLetterAgree(opeMailLetterAgreeRequest, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者が対象会員のメール配信（新着物件）設定情報を解除します
         * @summary （運用者）メール配信（新着物件）設定情報解除
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpeMailLetterProperty(memberId?: number, options?: any): AxiosPromise<OpeMailLetterPropertyResponse> {
            return localVarFp.updateOpeMailLetterProperty(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 運用者が対象会員のメール配信同意設定を更新します
         * @summary （運用者）メール配信同意設定更新
         * @param {number} [memberId] 会員ID
         * @param {OpeMailLetterRequest} [opeMailLetterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOpeMailLetterSetting(memberId?: number, opeMailLetterRequest?: OpeMailLetterRequest, options?: any): AxiosPromise<OpeMailLetterSettingResponse> {
            return localVarFp.updateOpeMailLetterSetting(memberId, opeMailLetterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MailLetterApi - object-oriented interface
 * @export
 * @class MailLetterApi
 * @extends {BaseAPI}
 */
export class MailLetterApi extends BaseAPI {
    /**
     * ユーザーのメール配信（新着物件）設定情報を取得します
     * @summary メール配信（新着物件）設定情報取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public getMailLetterProperty(uid?: string, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).getMailLetterProperty(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーのメール配信同意設定を取得します
     * @summary メール配信同意設定の取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public getMailLetterSetting(uid?: string, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).getMailLetterSetting(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者が対象会員のメール配信（新着物件）設定情報を取得します
     * @summary （運用者）メール配信（新着物件）設定情報取得
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public getOpeMailLetterProperty(memberId?: number, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).getOpeMailLetterProperty(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者が対象会員のメール配信同意設定を取得します
     * @summary （運用者）メール配信同意設定取得
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public getOpeMailLetterSetting(memberId?: number, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).getOpeMailLetterSetting(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーのメール配信（新着物件）設定情報を登録します
     * @summary メール配信（新着物件）設定情報登録
     * @param {string} [uid] 会員ID
     * @param {PostMailLetterPropertyRequest} [postMailLetterPropertyRequest] メール配信（新着物件）設定情報登録リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public postMailLetterProperty(uid?: string, postMailLetterPropertyRequest?: PostMailLetterPropertyRequest, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).postMailLetterProperty(uid, postMailLetterPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者が対象会員のメール配信（新着物件）設定情報を登録します
     * @summary （運用者）メール配信（新着物件）設定情報登録
     * @param {number} [memberId] 会員ID
     * @param {OpeMailLetterPropertyRequest} [opeMailLetterPropertyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public postOpeMailLetterProperty(memberId?: number, opeMailLetterPropertyRequest?: OpeMailLetterPropertyRequest, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).postOpeMailLetterProperty(memberId, opeMailLetterPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メール配信（新着物件）設定情報を解除します
     * @summary メール配信（新着物件）設定情報解除
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public updateMailLetterProperty(uid?: string, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).updateMailLetterProperty(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーのメール配信同意設定を更新します
     * @summary メール配信同意設定の更新
     * @param {string} [uid] 会員ID
     * @param {UpdateMailLetterSettingRequest} [updateMailLetterSettingRequest] メール配信同意設定更新リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public updateMailLetterSetting(uid?: string, updateMailLetterSettingRequest?: UpdateMailLetterSettingRequest, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).updateMailLetterSetting(uid, updateMailLetterSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者が対象会員のメール配信同意設定を更新します
     * @summary （運用者）メール配信同意設定の更新
     * @param {OpeMailLetterAgreeRequest} opeMailLetterAgreeRequest 
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public updateOpeMailLetterAgree(opeMailLetterAgreeRequest: OpeMailLetterAgreeRequest, memberId?: number, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).updateOpeMailLetterAgree(opeMailLetterAgreeRequest, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者が対象会員のメール配信（新着物件）設定情報を解除します
     * @summary （運用者）メール配信（新着物件）設定情報解除
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public updateOpeMailLetterProperty(memberId?: number, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).updateOpeMailLetterProperty(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 運用者が対象会員のメール配信同意設定を更新します
     * @summary （運用者）メール配信同意設定更新
     * @param {number} [memberId] 会員ID
     * @param {OpeMailLetterRequest} [opeMailLetterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailLetterApi
     */
    public updateOpeMailLetterSetting(memberId?: number, opeMailLetterRequest?: OpeMailLetterRequest, options?: AxiosRequestConfig) {
        return MailLetterApiFp(this.configuration).updateOpeMailLetterSetting(memberId, opeMailLetterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PasswordApi - axios parameter creator
 * @export
 */
export const PasswordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザのパスワードを再設定を依頼する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * ../../examples/E_I001yml   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary パスワード変更忘れ
         * @param {CreatePasswordResetRequest} [createPasswordResetRequest] パスワード変更忘れリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswordReset: async (createPasswordResetRequest?: CreatePasswordResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのパスワードを再設定時の確認を行う
         * @summary パスワード変更確認
         * @param {string} [hashValue] ハッシュ値
         * @param {boolean} [isAdmin] 管理者かどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordConfirm: async (hashValue?: string, isAdmin?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hashValue !== undefined) {
                localVarQueryParameter['hashValue'] = hashValue;
            }

            if (isAdmin !== undefined) {
                localVarQueryParameter['isAdmin'] = isAdmin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * リセットしたユーザのパスワードを変更する (再設定)
         * @summary パスワード変更(再設定)
         * @param {string} [hashValue] ハッシュ値
         * @param {UpdatePasswordResetRequest} [updatePasswordResetRequest] パスワード変更(再設定)リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordReset: async (hashValue?: string, updatePasswordResetRequest?: UpdatePasswordResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hashValue !== undefined) {
                localVarQueryParameter['hashValue'] = hashValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordApi - functional programming interface
 * @export
 */
export const PasswordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザのパスワードを再設定を依頼する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * ../../examples/E_I001yml   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary パスワード変更忘れ
         * @param {CreatePasswordResetRequest} [createPasswordResetRequest] パスワード変更忘れリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPasswordReset(createPasswordResetRequest?: CreatePasswordResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePasswordReset200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPasswordReset(createPasswordResetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのパスワードを再設定時の確認を行う
         * @summary パスワード変更確認
         * @param {string} [hashValue] ハッシュ値
         * @param {boolean} [isAdmin] 管理者かどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordConfirm(hashValue?: string, isAdmin?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordConfirm200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordConfirm(hashValue, isAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * リセットしたユーザのパスワードを変更する (再設定)
         * @summary パスワード変更(再設定)
         * @param {string} [hashValue] ハッシュ値
         * @param {UpdatePasswordResetRequest} [updatePasswordResetRequest] パスワード変更(再設定)リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePasswordReset(hashValue?: string, updatePasswordResetRequest?: UpdatePasswordResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePasswordReset(hashValue, updatePasswordResetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordApi - factory interface
 * @export
 */
export const PasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordApiFp(configuration)
    return {
        /**
         * ユーザのパスワードを再設定を依頼する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * ../../examples/E_I001yml   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary パスワード変更忘れ
         * @param {CreatePasswordResetRequest} [createPasswordResetRequest] パスワード変更忘れリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPasswordReset(createPasswordResetRequest?: CreatePasswordResetRequest, options?: any): AxiosPromise<CreatePasswordReset200Response> {
            return localVarFp.createPasswordReset(createPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのパスワードを再設定時の確認を行う
         * @summary パスワード変更確認
         * @param {string} [hashValue] ハッシュ値
         * @param {boolean} [isAdmin] 管理者かどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordConfirm(hashValue?: string, isAdmin?: boolean, options?: any): AxiosPromise<ResetPasswordConfirm200Response> {
            return localVarFp.resetPasswordConfirm(hashValue, isAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         * リセットしたユーザのパスワードを変更する (再設定)
         * @summary パスワード変更(再設定)
         * @param {string} [hashValue] ハッシュ値
         * @param {UpdatePasswordResetRequest} [updatePasswordResetRequest] パスワード変更(再設定)リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePasswordReset(hashValue?: string, updatePasswordResetRequest?: UpdatePasswordResetRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.updatePasswordReset(hashValue, updatePasswordResetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
export class PasswordApi extends BaseAPI {
    /**
     * ユーザのパスワードを再設定を依頼する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * ../../examples/E_I001yml   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary パスワード変更忘れ
     * @param {CreatePasswordResetRequest} [createPasswordResetRequest] パスワード変更忘れリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    public createPasswordReset(createPasswordResetRequest?: CreatePasswordResetRequest, options?: AxiosRequestConfig) {
        return PasswordApiFp(this.configuration).createPasswordReset(createPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのパスワードを再設定時の確認を行う
     * @summary パスワード変更確認
     * @param {string} [hashValue] ハッシュ値
     * @param {boolean} [isAdmin] 管理者かどうか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    public resetPasswordConfirm(hashValue?: string, isAdmin?: boolean, options?: AxiosRequestConfig) {
        return PasswordApiFp(this.configuration).resetPasswordConfirm(hashValue, isAdmin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * リセットしたユーザのパスワードを変更する (再設定)
     * @summary パスワード変更(再設定)
     * @param {string} [hashValue] ハッシュ値
     * @param {UpdatePasswordResetRequest} [updatePasswordResetRequest] パスワード変更(再設定)リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    public updatePasswordReset(hashValue?: string, updatePasswordResetRequest?: UpdatePasswordResetRequest, options?: AxiosRequestConfig) {
        return PasswordApiFp(this.configuration).updatePasswordReset(hashValue, updatePasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PostNumberApi - axios parameter creator
 * @export
 */
export const PostNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 郵便番号検索を行う
         * @summary 郵便番号検索
         * @param {string} zip 郵便番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPostNumber: async (zip: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zip' is not null or undefined
            assertParamExists('searchPostNumber', 'zip', zip)
            const localVarPath = `/post_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (zip !== undefined) {
                localVarQueryParameter['zip'] = zip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostNumberApi - functional programming interface
 * @export
 */
export const PostNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 郵便番号検索を行う
         * @summary 郵便番号検索
         * @param {string} zip 郵便番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPostNumber(zip: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchPostNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPostNumber(zip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PostNumberApi - factory interface
 * @export
 */
export const PostNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostNumberApiFp(configuration)
    return {
        /**
         * 郵便番号検索を行う
         * @summary 郵便番号検索
         * @param {string} zip 郵便番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPostNumber(zip: string, options?: any): AxiosPromise<SearchPostNumber200Response> {
            return localVarFp.searchPostNumber(zip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostNumberApi - object-oriented interface
 * @export
 * @class PostNumberApi
 * @extends {BaseAPI}
 */
export class PostNumberApi extends BaseAPI {
    /**
     * 郵便番号検索を行う
     * @summary 郵便番号検索
     * @param {string} zip 郵便番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostNumberApi
     */
    public searchPostNumber(zip: string, options?: AxiosRequestConfig) {
        return PostNumberApiFp(this.configuration).searchPostNumber(zip, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PropertyApi - axios parameter creator
 * @export
 */
export const PropertyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 物件の削除を実施する
         * @summary 物件削除
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: async (propertyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deleteProperty', 'propertyId', propertyId)
            const localVarPath = `/property/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: async (propertyId: number, uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getProperty', 'propertyId', propertyId)
            const localVarPath = `/property/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件の検索または一覧取得を実施する
         * @summary 物件検索/一覧
         * @param {Array<number>} [stationIds] 駅IDリスト
         * @param {Array<number>} [areaIds] エリアIDリスト
         * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
         * @param {number} [rentMin] 賃料最小
         * @param {number} [rentMax] 賃料最大
         * @param {number} [condition] 状態
         * @param {number} [possibleUsage] 出店可能業態
         * @param {number} [floor] 階
         * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
         * @param {number} [tsuboMin] 面積(坪)最小
         * @param {number} [tsuboMax] 面積(坪)最大
         * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
         * @param {number} [prefectureId] 都道府県ID
         * @param {string} [freeWord] フリーワード検索
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyList: async (stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (stationIds) {
                localVarQueryParameter['station_ids'] = stationIds.join(COLLECTION_FORMATS.csv);
            }

            if (areaIds) {
                localVarQueryParameter['area_ids'] = areaIds.join(COLLECTION_FORMATS.csv);
            }

            if (accessMax !== undefined) {
                localVarQueryParameter['access_max'] = accessMax;
            }

            if (rentMin !== undefined) {
                localVarQueryParameter['rent_min'] = rentMin;
            }

            if (rentMax !== undefined) {
                localVarQueryParameter['rent_max'] = rentMax;
            }

            if (condition !== undefined) {
                localVarQueryParameter['condition'] = condition;
            }

            if (possibleUsage !== undefined) {
                localVarQueryParameter['possible_usage'] = possibleUsage;
            }

            if (floor !== undefined) {
                localVarQueryParameter['floor'] = floor;
            }

            if (ignorePublicStatus !== undefined) {
                localVarQueryParameter['ignore_public_status'] = ignorePublicStatus;
            }

            if (tsuboMin !== undefined) {
                localVarQueryParameter['tsubo_min'] = tsuboMin;
            }

            if (tsuboMax !== undefined) {
                localVarQueryParameter['tsubo_max'] = tsuboMax;
            }

            if (ignoreDeleteFlg !== undefined) {
                localVarQueryParameter['ignore_delete_flg'] = ignoreDeleteFlg;
            }

            if (prefectureId !== undefined) {
                localVarQueryParameter['prefecture_id'] = prefectureId;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['free_word'] = freeWord;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件についての問合せメールを送信する。 また、同時にお気に入りに登録を実施する。
         * @summary 物件問合せ
         * @param {number} propertyId 物件ID
         * @param {InquiryPropertyRequest} inquiryPropertyRequest 物件問合せリクエスト
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiryProperty: async (propertyId: number, inquiryPropertyRequest: InquiryPropertyRequest, uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('inquiryProperty', 'propertyId', propertyId)
            // verify required parameter 'inquiryPropertyRequest' is not null or undefined
            assertParamExists('inquiryProperty', 'inquiryPropertyRequest', inquiryPropertyRequest)
            const localVarPath = `/property/{property_id}/inquiry`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inquiryPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件の情報の部分更新を実施する
         * @summary 物件項目部分更新
         * @param {number} propertyId 物件ID
         * @param {PatchPropertyRequest} [patchPropertyRequest] 管理機能 物件登録/更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProperty: async (propertyId: number, patchPropertyRequest?: PatchPropertyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('patchProperty', 'propertyId', propertyId)
            const localVarPath = `/property/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件の情報更新を実施する
         * @summary 物件更新
         * @param {number} propertyId 物件ID
         * @param {PutPropertyRequest} [putPropertyRequest] 管理機能 物件登録/更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProperty: async (propertyId: number, putPropertyRequest?: PutPropertyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('putProperty', 'propertyId', propertyId)
            const localVarPath = `/property/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putPropertyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 不動産、コンサルタント、管理者が物件の画像を一時アップロードする
         * @summary 物件画像一時アップロード
         * @param {UploadPropertyImageRequest} uploadPropertyImageRequest 物件画像一時アップロードリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPropertyImage: async (uploadPropertyImageRequest: UploadPropertyImageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadPropertyImageRequest' is not null or undefined
            assertParamExists('uploadPropertyImage', 'uploadPropertyImageRequest', uploadPropertyImageRequest)
            const localVarPath = `/property/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadPropertyImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertyApi - functional programming interface
 * @export
 */
export const PropertyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertyApiAxiosParamCreator(configuration)
    return {
        /**
         * 物件の削除を実施する
         * @summary 物件削除
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProperty(propertyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProperty(propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProperty(propertyId: number, uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProperty(propertyId, uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件の検索または一覧取得を実施する
         * @summary 物件検索/一覧
         * @param {Array<number>} [stationIds] 駅IDリスト
         * @param {Array<number>} [areaIds] エリアIDリスト
         * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
         * @param {number} [rentMin] 賃料最小
         * @param {number} [rentMax] 賃料最大
         * @param {number} [condition] 状態
         * @param {number} [possibleUsage] 出店可能業態
         * @param {number} [floor] 階
         * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
         * @param {number} [tsuboMin] 面積(坪)最小
         * @param {number} [tsuboMax] 面積(坪)最大
         * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
         * @param {number} [prefectureId] 都道府県ID
         * @param {string} [freeWord] フリーワード検索
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyList(stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyList(stationIds, areaIds, accessMax, rentMin, rentMax, condition, possibleUsage, floor, ignorePublicStatus, tsuboMin, tsuboMax, ignoreDeleteFlg, prefectureId, freeWord, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件についての問合せメールを送信する。 また、同時にお気に入りに登録を実施する。
         * @summary 物件問合せ
         * @param {number} propertyId 物件ID
         * @param {InquiryPropertyRequest} inquiryPropertyRequest 物件問合せリクエスト
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inquiryProperty(propertyId: number, inquiryPropertyRequest: InquiryPropertyRequest, uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inquiryProperty(propertyId, inquiryPropertyRequest, uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件の情報の部分更新を実施する
         * @summary 物件項目部分更新
         * @param {number} propertyId 物件ID
         * @param {PatchPropertyRequest} [patchPropertyRequest] 管理機能 物件登録/更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchProperty(propertyId: number, patchPropertyRequest?: PatchPropertyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchProperty(propertyId, patchPropertyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件の情報更新を実施する
         * @summary 物件更新
         * @param {number} propertyId 物件ID
         * @param {PutPropertyRequest} [putPropertyRequest] 管理機能 物件登録/更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putProperty(propertyId: number, putPropertyRequest?: PutPropertyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putProperty(propertyId, putPropertyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 不動産、コンサルタント、管理者が物件の画像を一時アップロードする
         * @summary 物件画像一時アップロード
         * @param {UploadPropertyImageRequest} uploadPropertyImageRequest 物件画像一時アップロードリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPropertyImage(uploadPropertyImageRequest: UploadPropertyImageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadPropertyImage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPropertyImage(uploadPropertyImageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PropertyApi - factory interface
 * @export
 */
export const PropertyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertyApiFp(configuration)
    return {
        /**
         * 物件の削除を実施する
         * @summary 物件削除
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty(propertyId: number, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.deleteProperty(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty(propertyId: number, uid?: string, options?: any): AxiosPromise<GetProperty200Response> {
            return localVarFp.getProperty(propertyId, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 物件の検索または一覧取得を実施する
         * @summary 物件検索/一覧
         * @param {Array<number>} [stationIds] 駅IDリスト
         * @param {Array<number>} [areaIds] エリアIDリスト
         * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
         * @param {number} [rentMin] 賃料最小
         * @param {number} [rentMax] 賃料最大
         * @param {number} [condition] 状態
         * @param {number} [possibleUsage] 出店可能業態
         * @param {number} [floor] 階
         * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
         * @param {number} [tsuboMin] 面積(坪)最小
         * @param {number} [tsuboMax] 面積(坪)最大
         * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
         * @param {number} [prefectureId] 都道府県ID
         * @param {string} [freeWord] フリーワード検索
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyList(stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options?: any): AxiosPromise<GetPropertyList200Response> {
            return localVarFp.getPropertyList(stationIds, areaIds, accessMax, rentMin, rentMax, condition, possibleUsage, floor, ignorePublicStatus, tsuboMin, tsuboMax, ignoreDeleteFlg, prefectureId, freeWord, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 物件についての問合せメールを送信する。 また、同時にお気に入りに登録を実施する。
         * @summary 物件問合せ
         * @param {number} propertyId 物件ID
         * @param {InquiryPropertyRequest} inquiryPropertyRequest 物件問合せリクエスト
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inquiryProperty(propertyId: number, inquiryPropertyRequest: InquiryPropertyRequest, uid?: string, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.inquiryProperty(propertyId, inquiryPropertyRequest, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 物件の情報の部分更新を実施する
         * @summary 物件項目部分更新
         * @param {number} propertyId 物件ID
         * @param {PatchPropertyRequest} [patchPropertyRequest] 管理機能 物件登録/更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProperty(propertyId: number, patchPropertyRequest?: PatchPropertyRequest, options?: any): AxiosPromise<GetProperty200Response> {
            return localVarFp.patchProperty(propertyId, patchPropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 物件の情報更新を実施する
         * @summary 物件更新
         * @param {number} propertyId 物件ID
         * @param {PutPropertyRequest} [putPropertyRequest] 管理機能 物件登録/更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProperty(propertyId: number, putPropertyRequest?: PutPropertyRequest, options?: any): AxiosPromise<GetProperty200Response> {
            return localVarFp.putProperty(propertyId, putPropertyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 不動産、コンサルタント、管理者が物件の画像を一時アップロードする
         * @summary 物件画像一時アップロード
         * @param {UploadPropertyImageRequest} uploadPropertyImageRequest 物件画像一時アップロードリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPropertyImage(uploadPropertyImageRequest: UploadPropertyImageRequest, options?: any): AxiosPromise<UploadPropertyImage200Response> {
            return localVarFp.uploadPropertyImage(uploadPropertyImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertyApi - object-oriented interface
 * @export
 * @class PropertyApi
 * @extends {BaseAPI}
 */
export class PropertyApi extends BaseAPI {
    /**
     * 物件の削除を実施する
     * @summary 物件削除
     * @param {number} propertyId 物件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public deleteProperty(propertyId: number, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).deleteProperty(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件の詳細情報を取得する
     * @summary 物件取得(物件詳細取得)
     * @param {number} propertyId 物件ID
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public getProperty(propertyId: number, uid?: string, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).getProperty(propertyId, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件の検索または一覧取得を実施する
     * @summary 物件検索/一覧
     * @param {Array<number>} [stationIds] 駅IDリスト
     * @param {Array<number>} [areaIds] エリアIDリスト
     * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
     * @param {number} [rentMin] 賃料最小
     * @param {number} [rentMax] 賃料最大
     * @param {number} [condition] 状態
     * @param {number} [possibleUsage] 出店可能業態
     * @param {number} [floor] 階
     * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
     * @param {number} [tsuboMin] 面積(坪)最小
     * @param {number} [tsuboMax] 面積(坪)最大
     * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
     * @param {number} [prefectureId] 都道府県ID
     * @param {string} [freeWord] フリーワード検索
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public getPropertyList(stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).getPropertyList(stationIds, areaIds, accessMax, rentMin, rentMax, condition, possibleUsage, floor, ignorePublicStatus, tsuboMin, tsuboMax, ignoreDeleteFlg, prefectureId, freeWord, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件についての問合せメールを送信する。 また、同時にお気に入りに登録を実施する。
     * @summary 物件問合せ
     * @param {number} propertyId 物件ID
     * @param {InquiryPropertyRequest} inquiryPropertyRequest 物件問合せリクエスト
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public inquiryProperty(propertyId: number, inquiryPropertyRequest: InquiryPropertyRequest, uid?: string, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).inquiryProperty(propertyId, inquiryPropertyRequest, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件の情報の部分更新を実施する
     * @summary 物件項目部分更新
     * @param {number} propertyId 物件ID
     * @param {PatchPropertyRequest} [patchPropertyRequest] 管理機能 物件登録/更新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public patchProperty(propertyId: number, patchPropertyRequest?: PatchPropertyRequest, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).patchProperty(propertyId, patchPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件の情報更新を実施する
     * @summary 物件更新
     * @param {number} propertyId 物件ID
     * @param {PutPropertyRequest} [putPropertyRequest] 管理機能 物件登録/更新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public putProperty(propertyId: number, putPropertyRequest?: PutPropertyRequest, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).putProperty(propertyId, putPropertyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 不動産、コンサルタント、管理者が物件の画像を一時アップロードする
     * @summary 物件画像一時アップロード
     * @param {UploadPropertyImageRequest} uploadPropertyImageRequest 物件画像一時アップロードリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyApi
     */
    public uploadPropertyImage(uploadPropertyImageRequest: UploadPropertyImageRequest, options?: AxiosRequestConfig) {
        return PropertyApiFp(this.configuration).uploadPropertyImage(uploadPropertyImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PropertyNoAuthApi - axios parameter creator
 * @export
 */
export const PropertyNoAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearestProperties: async (propertyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getNearestProperties', 'propertyId', propertyId)
            const localVarPath = `/property/{property_id}/nearest`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 新着物件を取得する
         * @summary 新着物件取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewPropertyList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/property/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件の検索または一覧取得を実施する
         * @summary 物件検索/一覧
         * @param {Array<number>} [stationIds] 駅IDリスト
         * @param {Array<number>} [areaIds] エリアIDリスト
         * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
         * @param {number} [rentMin] 賃料最小
         * @param {number} [rentMax] 賃料最大
         * @param {number} [condition] 状態
         * @param {number} [possibleUsage] 出店可能業態
         * @param {number} [floor] 階
         * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
         * @param {number} [tsuboMin] 面積(坪)最小
         * @param {number} [tsuboMax] 面積(坪)最大
         * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
         * @param {number} [prefectureId] 都道府県ID
         * @param {string} [freeWord] フリーワード検索
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyListNoAuth: async (stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/propertyNoAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationIds) {
                localVarQueryParameter['station_ids'] = stationIds.join(COLLECTION_FORMATS.csv);
            }

            if (areaIds) {
                localVarQueryParameter['area_ids'] = areaIds.join(COLLECTION_FORMATS.csv);
            }

            if (accessMax !== undefined) {
                localVarQueryParameter['access_max'] = accessMax;
            }

            if (rentMin !== undefined) {
                localVarQueryParameter['rent_min'] = rentMin;
            }

            if (rentMax !== undefined) {
                localVarQueryParameter['rent_max'] = rentMax;
            }

            if (condition !== undefined) {
                localVarQueryParameter['condition'] = condition;
            }

            if (possibleUsage !== undefined) {
                localVarQueryParameter['possible_usage'] = possibleUsage;
            }

            if (floor !== undefined) {
                localVarQueryParameter['floor'] = floor;
            }

            if (ignorePublicStatus !== undefined) {
                localVarQueryParameter['ignore_public_status'] = ignorePublicStatus;
            }

            if (tsuboMin !== undefined) {
                localVarQueryParameter['tsubo_min'] = tsuboMin;
            }

            if (tsuboMax !== undefined) {
                localVarQueryParameter['tsubo_max'] = tsuboMax;
            }

            if (ignoreDeleteFlg !== undefined) {
                localVarQueryParameter['ignore_delete_flg'] = ignoreDeleteFlg;
            }

            if (prefectureId !== undefined) {
                localVarQueryParameter['prefecture_id'] = prefectureId;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['free_word'] = freeWord;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyNoAuth: async (propertyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('getPropertyNoAuth', 'propertyId', propertyId)
            const localVarPath = `/propertyNoAuth/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertyNoAuthApi - functional programming interface
 * @export
 */
export const PropertyNoAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertyNoAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNearestProperties(propertyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNearestProperties200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNearestProperties(propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 新着物件を取得する
         * @summary 新着物件取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewPropertyList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewPropertyList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件の検索または一覧取得を実施する
         * @summary 物件検索/一覧
         * @param {Array<number>} [stationIds] 駅IDリスト
         * @param {Array<number>} [areaIds] エリアIDリスト
         * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
         * @param {number} [rentMin] 賃料最小
         * @param {number} [rentMax] 賃料最大
         * @param {number} [condition] 状態
         * @param {number} [possibleUsage] 出店可能業態
         * @param {number} [floor] 階
         * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
         * @param {number} [tsuboMin] 面積(坪)最小
         * @param {number} [tsuboMax] 面積(坪)最大
         * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
         * @param {number} [prefectureId] 都道府県ID
         * @param {string} [freeWord] フリーワード検索
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyListNoAuth(stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertyList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyListNoAuth(stationIds, areaIds, accessMax, rentMin, rentMax, condition, possibleUsage, floor, ignorePublicStatus, tsuboMin, tsuboMax, ignoreDeleteFlg, prefectureId, freeWord, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyNoAuth(propertyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProperty200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyNoAuth(propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PropertyNoAuthApi - factory interface
 * @export
 */
export const PropertyNoAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertyNoAuthApiFp(configuration)
    return {
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearestProperties(propertyId: number, options?: any): AxiosPromise<Array<GetNearestProperties200ResponseInner>> {
            return localVarFp.getNearestProperties(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 新着物件を取得する
         * @summary 新着物件取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewPropertyList(options?: any): AxiosPromise<GetPropertyList200Response> {
            return localVarFp.getNewPropertyList(options).then((request) => request(axios, basePath));
        },
        /**
         * 物件の検索または一覧取得を実施する
         * @summary 物件検索/一覧
         * @param {Array<number>} [stationIds] 駅IDリスト
         * @param {Array<number>} [areaIds] エリアIDリスト
         * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
         * @param {number} [rentMin] 賃料最小
         * @param {number} [rentMax] 賃料最大
         * @param {number} [condition] 状態
         * @param {number} [possibleUsage] 出店可能業態
         * @param {number} [floor] 階
         * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
         * @param {number} [tsuboMin] 面積(坪)最小
         * @param {number} [tsuboMax] 面積(坪)最大
         * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
         * @param {number} [prefectureId] 都道府県ID
         * @param {string} [freeWord] フリーワード検索
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyListNoAuth(stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options?: any): AxiosPromise<GetPropertyList200Response> {
            return localVarFp.getPropertyListNoAuth(stationIds, areaIds, accessMax, rentMin, rentMax, condition, possibleUsage, floor, ignorePublicStatus, tsuboMin, tsuboMax, ignoreDeleteFlg, prefectureId, freeWord, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 物件の詳細情報を取得する
         * @summary 物件取得(物件詳細取得)
         * @param {number} propertyId 物件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyNoAuth(propertyId: number, options?: any): AxiosPromise<GetProperty200Response> {
            return localVarFp.getPropertyNoAuth(propertyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertyNoAuthApi - object-oriented interface
 * @export
 * @class PropertyNoAuthApi
 * @extends {BaseAPI}
 */
export class PropertyNoAuthApi extends BaseAPI {
    /**
     * 物件の詳細情報を取得する
     * @summary 物件取得(物件詳細取得)
     * @param {number} propertyId 物件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyNoAuthApi
     */
    public getNearestProperties(propertyId: number, options?: AxiosRequestConfig) {
        return PropertyNoAuthApiFp(this.configuration).getNearestProperties(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 新着物件を取得する
     * @summary 新着物件取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyNoAuthApi
     */
    public getNewPropertyList(options?: AxiosRequestConfig) {
        return PropertyNoAuthApiFp(this.configuration).getNewPropertyList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件の検索または一覧取得を実施する
     * @summary 物件検索/一覧
     * @param {Array<number>} [stationIds] 駅IDリスト
     * @param {Array<number>} [areaIds] エリアIDリスト
     * @param {number} [accessMax] 最寄り駅徒歩時間 (分) 最大
     * @param {number} [rentMin] 賃料最小
     * @param {number} [rentMax] 賃料最大
     * @param {number} [condition] 状態
     * @param {number} [possibleUsage] 出店可能業態
     * @param {number} [floor] 階
     * @param {boolean} [ignorePublicStatus] 非公開含む (管理者のみ有効)
     * @param {number} [tsuboMin] 面積(坪)最小
     * @param {number} [tsuboMax] 面積(坪)最大
     * @param {boolean} [ignoreDeleteFlg] 削除含む (管理者のみ有効)
     * @param {number} [prefectureId] 都道府県ID
     * @param {string} [freeWord] フリーワード検索
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyNoAuthApi
     */
    public getPropertyListNoAuth(stationIds?: Array<number>, areaIds?: Array<number>, accessMax?: number, rentMin?: number, rentMax?: number, condition?: number, possibleUsage?: number, floor?: number, ignorePublicStatus?: boolean, tsuboMin?: number, tsuboMax?: number, ignoreDeleteFlg?: boolean, prefectureId?: number, freeWord?: string, page?: number, options?: AxiosRequestConfig) {
        return PropertyNoAuthApiFp(this.configuration).getPropertyListNoAuth(stationIds, areaIds, accessMax, rentMin, rentMax, condition, possibleUsage, floor, ignorePublicStatus, tsuboMin, tsuboMax, ignoreDeleteFlg, prefectureId, freeWord, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件の詳細情報を取得する
     * @summary 物件取得(物件詳細取得)
     * @param {number} propertyId 物件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyNoAuthApi
     */
    public getPropertyNoAuth(propertyId: number, options?: AxiosRequestConfig) {
        return PropertyNoAuthApiFp(this.configuration).getPropertyNoAuth(propertyId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PropertySelectionInquiryApi - axios parameter creator
 * @export
 */
export const PropertySelectionInquiryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会員の物件選定サポートの最新の申し込み情報を取得する
         * @summary 物件選定サポート最新申し込み情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertySelectionSupportLatestInquiry: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/property_selection/inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 物件選定サポートの申し込みをする 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
         * @summary 物件選定サポート申し込み
         * @param {PropertySelectionSupportInquiryRequest} propertySelectionSupportInquiryRequest 物件選定サポート申し込み
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        propertySelectionSupportInquiry: async (propertySelectionSupportInquiryRequest: PropertySelectionSupportInquiryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertySelectionSupportInquiryRequest' is not null or undefined
            assertParamExists('propertySelectionSupportInquiry', 'propertySelectionSupportInquiryRequest', propertySelectionSupportInquiryRequest)
            const localVarPath = `/property_selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(propertySelectionSupportInquiryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertySelectionInquiryApi - functional programming interface
 * @export
 */
export const PropertySelectionInquiryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertySelectionInquiryApiAxiosParamCreator(configuration)
    return {
        /**
         * 会員の物件選定サポートの最新の申し込み情報を取得する
         * @summary 物件選定サポート最新申し込み情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertySelectionSupportLatestInquiry(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPropertySelectionSupportLatestInquiry200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertySelectionSupportLatestInquiry(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 物件選定サポートの申し込みをする 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
         * @summary 物件選定サポート申し込み
         * @param {PropertySelectionSupportInquiryRequest} propertySelectionSupportInquiryRequest 物件選定サポート申し込み
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async propertySelectionSupportInquiry(propertySelectionSupportInquiryRequest: PropertySelectionSupportInquiryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertySelectionSupportInquiry200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.propertySelectionSupportInquiry(propertySelectionSupportInquiryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PropertySelectionInquiryApi - factory interface
 * @export
 */
export const PropertySelectionInquiryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertySelectionInquiryApiFp(configuration)
    return {
        /**
         * 会員の物件選定サポートの最新の申し込み情報を取得する
         * @summary 物件選定サポート最新申し込み情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertySelectionSupportLatestInquiry(options?: any): AxiosPromise<GetPropertySelectionSupportLatestInquiry200Response> {
            return localVarFp.getPropertySelectionSupportLatestInquiry(options).then((request) => request(axios, basePath));
        },
        /**
         * 物件選定サポートの申し込みをする 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
         * @summary 物件選定サポート申し込み
         * @param {PropertySelectionSupportInquiryRequest} propertySelectionSupportInquiryRequest 物件選定サポート申し込み
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        propertySelectionSupportInquiry(propertySelectionSupportInquiryRequest: PropertySelectionSupportInquiryRequest, options?: any): AxiosPromise<PropertySelectionSupportInquiry200Response> {
            return localVarFp.propertySelectionSupportInquiry(propertySelectionSupportInquiryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertySelectionInquiryApi - object-oriented interface
 * @export
 * @class PropertySelectionInquiryApi
 * @extends {BaseAPI}
 */
export class PropertySelectionInquiryApi extends BaseAPI {
    /**
     * 会員の物件選定サポートの最新の申し込み情報を取得する
     * @summary 物件選定サポート最新申し込み情報取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionInquiryApi
     */
    public getPropertySelectionSupportLatestInquiry(options?: AxiosRequestConfig) {
        return PropertySelectionInquiryApiFp(this.configuration).getPropertySelectionSupportLatestInquiry(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 物件選定サポートの申し込みをする 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/parameters/QueryPage   * APIリソース別共通定義シート * #/components/schemas/ListResponse   * 一覧レスポンスシート
     * @summary 物件選定サポート申し込み
     * @param {PropertySelectionSupportInquiryRequest} propertySelectionSupportInquiryRequest 物件選定サポート申し込み
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionInquiryApi
     */
    public propertySelectionSupportInquiry(propertySelectionSupportInquiryRequest: PropertySelectionSupportInquiryRequest, options?: AxiosRequestConfig) {
        return PropertySelectionInquiryApiFp(this.configuration).propertySelectionSupportInquiry(propertySelectionSupportInquiryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegistrationApi - axios parameter creator
 * @export
 */
export const RegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録
         * @param {Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistrationTemp: async (registration: Registration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registration' is not null or undefined
            assertParamExists('createRegistrationTemp', 'registration', registration)
            const localVarPath = `/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (tempId: number, createUserRequest?: CreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempId' is not null or undefined
            assertParamExists('createUser', 'tempId', tempId)
            const localVarPath = `/registration/{temp_id}`
                .replace(`{${"temp_id"}}`, encodeURIComponent(String(tempId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録確認
         * @param {number} tempId 会員仮登録ID
         * @param {string} hashValue 認証コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationTemp: async (tempId: number, hashValue: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempId' is not null or undefined
            assertParamExists('getRegistrationTemp', 'tempId', tempId)
            // verify required parameter 'hashValue' is not null or undefined
            assertParamExists('getRegistrationTemp', 'hashValue', hashValue)
            const localVarPath = `/registration/{temp_id}`
                .replace(`{${"temp_id"}}`, encodeURIComponent(String(tempId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hashValue !== undefined) {
                localVarQueryParameter['hashValue'] = hashValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary メール認証
         * @param {string} code 認証コード
         * @param {string} [emailAddress] メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (code: string, emailAddress?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyEmail', 'code', code)
            const localVarPath = `/registration/verify_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailAddress !== undefined) {
                localVarQueryParameter['email_address'] = emailAddress;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationApi - functional programming interface
 * @export
 */
export const RegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録
         * @param {Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistrationTemp(registration: Registration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRegistrationTemp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistrationTemp(registration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(tempId, createUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録確認
         * @param {number} tempId 会員仮登録ID
         * @param {string} hashValue 認証コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrationTemp(tempId: number, hashValue: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegistrationTemp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrationTemp(tempId, hashValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary メール認証
         * @param {string} code 認証コード
         * @param {string} [emailAddress] メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(code: string, emailAddress?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(code, emailAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationApi - factory interface
 * @export
 */
export const RegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationApiFp(configuration)
    return {
        /**
         * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録
         * @param {Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistrationTemp(registration: Registration, options?: any): AxiosPromise<CreateRegistrationTemp200Response> {
            return localVarFp.createRegistrationTemp(registration, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createUser(tempId, createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録確認
         * @param {number} tempId 会員仮登録ID
         * @param {string} hashValue 認証コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationTemp(tempId: number, hashValue: string, options?: any): AxiosPromise<GetRegistrationTemp200Response> {
            return localVarFp.getRegistrationTemp(tempId, hashValue, options).then((request) => request(axios, basePath));
        },
        /**
         * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary メール認証
         * @param {string} code 認証コード
         * @param {string} [emailAddress] メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(code: string, emailAddress?: string, options?: any): AxiosPromise<VerifyEmail200Response> {
            return localVarFp.verifyEmail(code, emailAddress, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
export class RegistrationApi extends BaseAPI {
    /**
     * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員仮登録
     * @param {Registration} registration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public createRegistrationTemp(registration: Registration, options?: AxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).createRegistrationTemp(registration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員本登録
     * @param {number} tempId 会員仮登録ID
     * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).createUser(tempId, createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員仮登録確認
     * @param {number} tempId 会員仮登録ID
     * @param {string} hashValue 認証コード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public getRegistrationTemp(tempId: number, hashValue: string, options?: AxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).getRegistrationTemp(tempId, hashValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary メール認証
     * @param {string} code 認証コード
     * @param {string} [emailAddress] メールアドレス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public verifyEmail(code: string, emailAddress?: string, options?: AxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).verifyEmail(code, emailAddress, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegistrationTempConfirmApi - axios parameter creator
 * @export
 */
export const RegistrationTempConfirmApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録確認
         * @param {number} tempId 会員仮登録ID
         * @param {string} hashValue 認証コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationTemp: async (tempId: number, hashValue: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempId' is not null or undefined
            assertParamExists('getRegistrationTemp', 'tempId', tempId)
            // verify required parameter 'hashValue' is not null or undefined
            assertParamExists('getRegistrationTemp', 'hashValue', hashValue)
            const localVarPath = `/registration/{temp_id}`
                .replace(`{${"temp_id"}}`, encodeURIComponent(String(tempId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hashValue !== undefined) {
                localVarQueryParameter['hashValue'] = hashValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationTempConfirmApi - functional programming interface
 * @export
 */
export const RegistrationTempConfirmApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationTempConfirmApiAxiosParamCreator(configuration)
    return {
        /**
         * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録確認
         * @param {number} tempId 会員仮登録ID
         * @param {string} hashValue 認証コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrationTemp(tempId: number, hashValue: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegistrationTemp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrationTemp(tempId, hashValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationTempConfirmApi - factory interface
 * @export
 */
export const RegistrationTempConfirmApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationTempConfirmApiFp(configuration)
    return {
        /**
         * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録確認
         * @param {number} tempId 会員仮登録ID
         * @param {string} hashValue 認証コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationTemp(tempId: number, hashValue: string, options?: any): AxiosPromise<GetRegistrationTemp200Response> {
            return localVarFp.getRegistrationTemp(tempId, hashValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationTempConfirmApi - object-oriented interface
 * @export
 * @class RegistrationTempConfirmApi
 * @extends {BaseAPI}
 */
export class RegistrationTempConfirmApi extends BaseAPI {
    /**
     * 会員仮登録情報を確認する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員仮登録確認
     * @param {number} tempId 会員仮登録ID
     * @param {string} hashValue 認証コード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationTempConfirmApi
     */
    public getRegistrationTemp(tempId: number, hashValue: string, options?: AxiosRequestConfig) {
        return RegistrationTempConfirmApiFp(this.configuration).getRegistrationTemp(tempId, hashValue, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegistrationTempCreateApi - axios parameter creator
 * @export
 */
export const RegistrationTempCreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録
         * @param {Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistrationTemp: async (registration: Registration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registration' is not null or undefined
            assertParamExists('createRegistrationTemp', 'registration', registration)
            const localVarPath = `/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationTempCreateApi - functional programming interface
 * @export
 */
export const RegistrationTempCreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationTempCreateApiAxiosParamCreator(configuration)
    return {
        /**
         * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録
         * @param {Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistrationTemp(registration: Registration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRegistrationTemp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistrationTemp(registration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationTempCreateApi - factory interface
 * @export
 */
export const RegistrationTempCreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationTempCreateApiFp(configuration)
    return {
        /**
         * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員仮登録
         * @param {Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistrationTemp(registration: Registration, options?: any): AxiosPromise<CreateRegistrationTemp200Response> {
            return localVarFp.createRegistrationTemp(registration, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationTempCreateApi - object-oriented interface
 * @export
 * @class RegistrationTempCreateApi
 * @extends {BaseAPI}
 */
export class RegistrationTempCreateApi extends BaseAPI {
    /**
     * 会員登録前に確認用メールアドレスを登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員仮登録
     * @param {Registration} registration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationTempCreateApi
     */
    public createRegistrationTemp(registration: Registration, options?: AxiosRequestConfig) {
        return RegistrationTempCreateApiFp(this.configuration).createRegistrationTemp(registration, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegistrationUserCreateApi - axios parameter creator
 * @export
 */
export const RegistrationUserCreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (tempId: number, createUserRequest?: CreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempId' is not null or undefined
            assertParamExists('createUser', 'tempId', tempId)
            const localVarPath = `/registration/{temp_id}`
                .replace(`{${"temp_id"}}`, encodeURIComponent(String(tempId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationUserCreateApi - functional programming interface
 * @export
 */
export const RegistrationUserCreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationUserCreateApiAxiosParamCreator(configuration)
    return {
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(tempId, createUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistrationUserCreateApi - factory interface
 * @export
 */
export const RegistrationUserCreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationUserCreateApiFp(configuration)
    return {
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createUser(tempId, createUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistrationUserCreateApi - object-oriented interface
 * @export
 * @class RegistrationUserCreateApi
 * @extends {BaseAPI}
 */
export class RegistrationUserCreateApi extends BaseAPI {
    /**
     * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員本登録
     * @param {number} tempId 会員仮登録ID
     * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationUserCreateApi
     */
    public createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig) {
        return RegistrationUserCreateApiFp(this.configuration).createUser(tempId, createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoresApi - axios parameter creator
 * @export
 */
export const StoresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザの店舗情報を取得する。
         * @summary 運営店舗情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStores: async (memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザの店舗情報を更新する。
         * @summary 運営店舗情報更新
         * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStores: async (memberStoreRequest: MemberStoreRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberStoreRequest' is not null or undefined
            assertParamExists('updateStores', 'memberStoreRequest', memberStoreRequest)
            const localVarPath = `/user/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberStoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoresApi - functional programming interface
 * @export
 */
export const StoresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoresApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザの店舗情報を取得する。
         * @summary 運営店舗情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStores(memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStores(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザの店舗情報を更新する。
         * @summary 運営店舗情報更新
         * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStores(memberStoreRequest: MemberStoreRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStores(memberStoreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoresApi - factory interface
 * @export
 */
export const StoresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoresApiFp(configuration)
    return {
        /**
         * ユーザの店舗情報を取得する。
         * @summary 運営店舗情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStores(memberId?: number, options?: any): AxiosPromise<MemberStoreResponse> {
            return localVarFp.getStores(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザの店舗情報を更新する。
         * @summary 運営店舗情報更新
         * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStores(memberStoreRequest: MemberStoreRequest, options?: any): AxiosPromise<MemberStoreResponse> {
            return localVarFp.updateStores(memberStoreRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoresApi - object-oriented interface
 * @export
 * @class StoresApi
 * @extends {BaseAPI}
 */
export class StoresApi extends BaseAPI {
    /**
     * ユーザの店舗情報を取得する。
     * @summary 運営店舗情報取得
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    public getStores(memberId?: number, options?: AxiosRequestConfig) {
        return StoresApiFp(this.configuration).getStores(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザの店舗情報を更新する。
     * @summary 運営店舗情報更新
     * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoresApi
     */
    public updateStores(memberStoreRequest: MemberStoreRequest, options?: AxiosRequestConfig) {
        return StoresApiFp(this.configuration).updateStores(memberStoreRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TodoApi - axios parameter creator
 * @export
 */
export const TodoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザのタスクを登録・更新する。
         * @summary 開業TODO登録・更新
         * @param {number} mTaskId タスクマスタID
         * @param {CreateOrUpdateTodoRequest} createOrUpdateTodoRequest 開業TODO登録・更新リクエスト
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTodo: async (mTaskId: number, createOrUpdateTodoRequest: CreateOrUpdateTodoRequest, uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mTaskId' is not null or undefined
            assertParamExists('createOrUpdateTodo', 'mTaskId', mTaskId)
            // verify required parameter 'createOrUpdateTodoRequest' is not null or undefined
            assertParamExists('createOrUpdateTodo', 'createOrUpdateTodoRequest', createOrUpdateTodoRequest)
            const localVarPath = `/user/todo/{m_task_id}`
                .replace(`{${"m_task_id"}}`, encodeURIComponent(String(mTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateTodoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのタスクリストを取得する。
         * @summary 開業TODO一覧取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoList: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/todo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TodoApi - functional programming interface
 * @export
 */
export const TodoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TodoApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザのタスクを登録・更新する。
         * @summary 開業TODO登録・更新
         * @param {number} mTaskId タスクマスタID
         * @param {CreateOrUpdateTodoRequest} createOrUpdateTodoRequest 開業TODO登録・更新リクエスト
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateTodo(mTaskId: number, createOrUpdateTodoRequest: CreateOrUpdateTodoRequest, uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOrUpdateTodo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateTodo(mTaskId, createOrUpdateTodoRequest, uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのタスクリストを取得する。
         * @summary 開業TODO一覧取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodoList(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTodoList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodoList(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TodoApi - factory interface
 * @export
 */
export const TodoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TodoApiFp(configuration)
    return {
        /**
         * ユーザのタスクを登録・更新する。
         * @summary 開業TODO登録・更新
         * @param {number} mTaskId タスクマスタID
         * @param {CreateOrUpdateTodoRequest} createOrUpdateTodoRequest 開業TODO登録・更新リクエスト
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTodo(mTaskId: number, createOrUpdateTodoRequest: CreateOrUpdateTodoRequest, uid?: string, options?: any): AxiosPromise<CreateOrUpdateTodo200Response> {
            return localVarFp.createOrUpdateTodo(mTaskId, createOrUpdateTodoRequest, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのタスクリストを取得する。
         * @summary 開業TODO一覧取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoList(uid?: string, options?: any): AxiosPromise<GetTodoList200Response> {
            return localVarFp.getTodoList(uid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TodoApi - object-oriented interface
 * @export
 * @class TodoApi
 * @extends {BaseAPI}
 */
export class TodoApi extends BaseAPI {
    /**
     * ユーザのタスクを登録・更新する。
     * @summary 開業TODO登録・更新
     * @param {number} mTaskId タスクマスタID
     * @param {CreateOrUpdateTodoRequest} createOrUpdateTodoRequest 開業TODO登録・更新リクエスト
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public createOrUpdateTodo(mTaskId: number, createOrUpdateTodoRequest: CreateOrUpdateTodoRequest, uid?: string, options?: AxiosRequestConfig) {
        return TodoApiFp(this.configuration).createOrUpdateTodo(mTaskId, createOrUpdateTodoRequest, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのタスクリストを取得する。
     * @summary 開業TODO一覧取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public getTodoList(uid?: string, options?: AxiosRequestConfig) {
        return TodoApiFp(this.configuration).getTodoList(uid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admin Get a Member
         * @param {number} userId 会員Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMember: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminGetMember', 'userId', userId)
            const localVarPath = `/ope/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのメールアドレスを変更確認と反映を行う
         * @summary メールアドレス変更確認
         * @param {string} passphrase パスフレーズ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail: async (passphrase: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passphrase' is not null or undefined
            assertParamExists('confirmEmail', 'passphrase', passphrase)
            const localVarPath = `/user/email/{passphrase}`
                .replace(`{${"passphrase"}}`, encodeURIComponent(String(passphrase)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (tempId: number, createUserRequest?: CreateUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tempId' is not null or undefined
            assertParamExists('createUser', 'tempId', tempId)
            const localVarPath = `/registration/{temp_id}`
                .replace(`{${"temp_id"}}`, encodeURIComponent(String(tempId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員の退会処理を行う
         * @summary 退会
         * @param {string} [uid] 会員ID
         * @param {DeleteUserRequest} [deleteUserRequest] 退会リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (uid?: string, deleteUserRequest?: DeleteUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/withdrawal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザの情報を取得する。
         * @summary 会員情報取得
         * @param {string} [uid] 会員ID
         * @param {boolean} [checkFeatureNotiVersion] 機能通知バージョン確認
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMember: async (uid?: string, checkFeatureNotiVersion?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (checkFeatureNotiVersion !== undefined) {
                localVarQueryParameter['check_feature_noti_version'] = checkFeatureNotiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 電話番号と一致する会員を取得する。
         * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
         * @param {string} [phoneNumber] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByPhoneNumber: async (phoneNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員情報CSVを取得する。
         * @summary 会員一覧CSV取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberListCsvForAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件に一致する会員情報を取得する。 name には、ニックネーム、姓名（連結）、姓名カナ（連結）を指定できる。
         * @summary 会員一覧取得
         * @param {number} [memberId] 会員ID
         * @param {number} [repConsultantId] 担当コンサルタントID
         * @param {string} [emailAddress] メールアドレス
         * @param {string} [name] ニックネーム、姓名（連結）、姓名カナ（連結）
         * @param {number} [qualifiedRank] Qualifiedランク
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberListForAdmin: async (memberId?: number, repConsultantId?: number, emailAddress?: string, name?: string, qualifiedRank?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }

            if (repConsultantId !== undefined) {
                localVarQueryParameter['rep_consultant_id'] = repConsultantId;
            }

            if (emailAddress !== undefined) {
                localVarQueryParameter['email_address'] = emailAddress;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (qualifiedRank !== undefined) {
                localVarQueryParameter['qualifiedRank'] = qualifiedRank;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件 (cognito_user_pool_id) に一致するユーザのロールを取得する。
         * @summary ロール取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (uid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザの店舗情報を取得する。
         * @summary 運営店舗情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStores: async (memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メールアドレスが登録済みか確認する
         * @summary メールアドレス登録済みチェック
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isRegisteredEmail: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('isRegisteredEmail', 'email', email)
            const localVarPath = `/user/email/is_registered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メルマガの登録を解除する。
         * @summary メルマガ登録解除
         * @param {string} token メルマガ登録解除用トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUnsubscribe: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('postUserUnsubscribe', 'token', token)
            const localVarPath = `/user/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 該当のユーザーにLINE IDを登録する
         * @summary 会員情報にLINE IDを登録する
         * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLineMessagingId: async (registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerLineMessagingIdRequest' is not null or undefined
            assertParamExists('registerLineMessagingId', 'registerLineMessagingIdRequest', registerLineMessagingIdRequest)
            const localVarPath = `/user/line_messaging_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerLineMessagingIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのメールアドレスを変更する
         * @summary メールアドレス変更
         * @param {string} [uid] 会員ID
         * @param {UpdateEmailRequest} [updateEmailRequest] メールアドレス変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail: async (uid?: string, updateEmailRequest?: UpdateEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザーのメール配信同意設定を更新します
         * @summary メール配信同意設定の更新
         * @param {boolean} isAgreed メール配信に同意するかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailLetter: async (isAgreed: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isAgreed' is not null or undefined
            assertParamExists('updateMailLetter', 'isAgreed', isAgreed)
            const localVarPath = `/user/mail_letter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isAgreed !== undefined) {
                localVarQueryParameter['isAgreed'] = isAgreed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 会員情報の更新を行う。
         * @summary 会員情報変更
         * @param {string} [uid] 会員ID
         * @param {UpdateMemberRequest} [updateMemberRequest] 会員情報変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember: async (uid?: string, updateMemberRequest?: UpdateMemberRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザのパスワードを変更する
         * @summary パスワード変更
         * @param {string} [uid] 会員ID
         * @param {UpdatePasswordRequest} [updatePasswordRequest] パスワード変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (uid?: string, updatePasswordRequest?: UpdatePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * オペレーターによるQualifiedランク強制変更
         * @summary Qualifiedランク強制変更
         * @param {string} [uid] 会員ID
         * @param {number} [qualifiedRank] Qualifiedランク
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQualifiedRankForce: async (uid?: string, qualifiedRank?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ope/user/qualified/rank/force`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (qualifiedRank !== undefined) {
                localVarQueryParameter['qualifiedRank'] = qualifiedRank;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザの店舗情報を更新する。
         * @summary 運営店舗情報更新
         * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStores: async (memberStoreRequest: MemberStoreRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberStoreRequest' is not null or undefined
            assertParamExists('updateStores', 'memberStoreRequest', memberStoreRequest)
            const localVarPath = `/user/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberStoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Admin Get a Member
         * @param {number} userId 会員Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetMember(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetMember(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのメールアドレスを変更確認と反映を行う
         * @summary メールアドレス変更確認
         * @param {string} passphrase パスフレーズ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmEmail(passphrase: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmEmail(passphrase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(tempId, createUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員の退会処理を行う
         * @summary 退会
         * @param {string} [uid] 会員ID
         * @param {DeleteUserRequest} [deleteUserRequest] 退会リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(uid?: string, deleteUserRequest?: DeleteUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(uid, deleteUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザの情報を取得する。
         * @summary 会員情報取得
         * @param {string} [uid] 会員ID
         * @param {boolean} [checkFeatureNotiVersion] 機能通知バージョン確認
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMember(uid?: string, checkFeatureNotiVersion?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMember(uid, checkFeatureNotiVersion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 電話番号と一致する会員を取得する。
         * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
         * @param {string} [phoneNumber] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberByPhoneNumber(phoneNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberByPhoneNumber(phoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員情報CSVを取得する。
         * @summary 会員一覧CSV取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberListCsvForAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberListCsvForAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件に一致する会員情報を取得する。 name には、ニックネーム、姓名（連結）、姓名カナ（連結）を指定できる。
         * @summary 会員一覧取得
         * @param {number} [memberId] 会員ID
         * @param {number} [repConsultantId] 担当コンサルタントID
         * @param {string} [emailAddress] メールアドレス
         * @param {string} [name] ニックネーム、姓名（連結）、姓名カナ（連結）
         * @param {number} [qualifiedRank] Qualifiedランク
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberListForAdmin(memberId?: number, repConsultantId?: number, emailAddress?: string, name?: string, qualifiedRank?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMemberListForAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberListForAdmin(memberId, repConsultantId, emailAddress, name, qualifiedRank, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件 (cognito_user_pool_id) に一致するユーザのロールを取得する。
         * @summary ロール取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(uid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRole200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(uid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザの店舗情報を取得する。
         * @summary 運営店舗情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStores(memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStores(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メールアドレスが登録済みか確認する
         * @summary メールアドレス登録済みチェック
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isRegisteredEmail(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isRegisteredEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メルマガの登録を解除する。
         * @summary メルマガ登録解除
         * @param {string} token メルマガ登録解除用トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserUnsubscribe(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserUnsubscribe(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 該当のユーザーにLINE IDを登録する
         * @summary 会員情報にLINE IDを登録する
         * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerLineMessagingId(registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerLineMessagingId(registerLineMessagingIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのメールアドレスを変更する
         * @summary メールアドレス変更
         * @param {string} [uid] 会員ID
         * @param {UpdateEmailRequest} [updateEmailRequest] メールアドレス変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmail(uid?: string, updateEmailRequest?: UpdateEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmail(uid, updateEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザーのメール配信同意設定を更新します
         * @summary メール配信同意設定の更新
         * @param {boolean} isAgreed メール配信に同意するかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMailLetter(isAgreed: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMailLetter(isAgreed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 会員情報の更新を行う。
         * @summary 会員情報変更
         * @param {string} [uid] 会員ID
         * @param {UpdateMemberRequest} [updateMemberRequest] 会員情報変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMember(uid?: string, updateMemberRequest?: UpdateMemberRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMember(uid, updateMemberRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザのパスワードを変更する
         * @summary パスワード変更
         * @param {string} [uid] 会員ID
         * @param {UpdatePasswordRequest} [updatePasswordRequest] パスワード変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(uid?: string, updatePasswordRequest?: UpdatePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(uid, updatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * オペレーターによるQualifiedランク強制変更
         * @summary Qualifiedランク強制変更
         * @param {string} [uid] 会員ID
         * @param {number} [qualifiedRank] Qualifiedランク
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQualifiedRankForce(uid?: string, qualifiedRank?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateQualifiedRankForce200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQualifiedRankForce(uid, qualifiedRank, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザの店舗情報を更新する。
         * @summary 運営店舗情報更新
         * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStores(memberStoreRequest: MemberStoreRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStores(memberStoreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Admin Get a Member
         * @param {number} userId 会員Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetMember(userId: number, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.adminGetMember(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのメールアドレスを変更確認と反映を行う
         * @summary メールアドレス変更確認
         * @param {string} passphrase パスフレーズ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(passphrase: string, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.confirmEmail(passphrase, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary 会員本登録
         * @param {number} tempId 会員仮登録ID
         * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: any): AxiosPromise<CreateUser200Response> {
            return localVarFp.createUser(tempId, createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員の退会処理を行う
         * @summary 退会
         * @param {string} [uid] 会員ID
         * @param {DeleteUserRequest} [deleteUserRequest] 退会リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(uid?: string, deleteUserRequest?: DeleteUserRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.deleteUser(uid, deleteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザの情報を取得する。
         * @summary 会員情報取得
         * @param {string} [uid] 会員ID
         * @param {boolean} [checkFeatureNotiVersion] 機能通知バージョン確認
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMember(uid?: string, checkFeatureNotiVersion?: boolean, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.getMember(uid, checkFeatureNotiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 電話番号と一致する会員を取得する。
         * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
         * @param {string} [phoneNumber] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByPhoneNumber(phoneNumber?: string, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.getMemberByPhoneNumber(phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員情報CSVを取得する。
         * @summary 会員一覧CSV取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberListCsvForAdmin(options?: any): AxiosPromise<File> {
            return localVarFp.getMemberListCsvForAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件に一致する会員情報を取得する。 name には、ニックネーム、姓名（連結）、姓名カナ（連結）を指定できる。
         * @summary 会員一覧取得
         * @param {number} [memberId] 会員ID
         * @param {number} [repConsultantId] 担当コンサルタントID
         * @param {string} [emailAddress] メールアドレス
         * @param {string} [name] ニックネーム、姓名（連結）、姓名カナ（連結）
         * @param {number} [qualifiedRank] Qualifiedランク
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberListForAdmin(memberId?: number, repConsultantId?: number, emailAddress?: string, name?: string, qualifiedRank?: number, page?: number, options?: any): AxiosPromise<GetMemberListForAdmin200Response> {
            return localVarFp.getMemberListForAdmin(memberId, repConsultantId, emailAddress, name, qualifiedRank, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件 (cognito_user_pool_id) に一致するユーザのロールを取得する。
         * @summary ロール取得
         * @param {string} [uid] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(uid?: string, options?: any): AxiosPromise<GetRole200Response> {
            return localVarFp.getRole(uid, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザの店舗情報を取得する。
         * @summary 運営店舗情報取得
         * @param {number} [memberId] 会員ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStores(memberId?: number, options?: any): AxiosPromise<MemberStoreResponse> {
            return localVarFp.getStores(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * メールアドレスが登録済みか確認する
         * @summary メールアドレス登録済みチェック
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isRegisteredEmail(email: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.isRegisteredEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * メルマガの登録を解除する。
         * @summary メルマガ登録解除
         * @param {string} token メルマガ登録解除用トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserUnsubscribe(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.postUserUnsubscribe(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 該当のユーザーにLINE IDを登録する
         * @summary 会員情報にLINE IDを登録する
         * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerLineMessagingId(registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.registerLineMessagingId(registerLineMessagingIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのメールアドレスを変更する
         * @summary メールアドレス変更
         * @param {string} [uid] 会員ID
         * @param {UpdateEmailRequest} [updateEmailRequest] メールアドレス変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmail(uid?: string, updateEmailRequest?: UpdateEmailRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.updateEmail(uid, updateEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザーのメール配信同意設定を更新します
         * @summary メール配信同意設定の更新
         * @param {boolean} isAgreed メール配信に同意するかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailLetter(isAgreed: boolean, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.updateMailLetter(isAgreed, options).then((request) => request(axios, basePath));
        },
        /**
         * 会員情報の更新を行う。
         * @summary 会員情報変更
         * @param {string} [uid] 会員ID
         * @param {UpdateMemberRequest} [updateMemberRequest] 会員情報変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember(uid?: string, updateMemberRequest?: UpdateMemberRequest, options?: any): AxiosPromise<GetMember200Response> {
            return localVarFp.updateMember(uid, updateMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザのパスワードを変更する
         * @summary パスワード変更
         * @param {string} [uid] 会員ID
         * @param {UpdatePasswordRequest} [updatePasswordRequest] パスワード変更リクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(uid?: string, updatePasswordRequest?: UpdatePasswordRequest, options?: any): AxiosPromise<AuthLogin200Response> {
            return localVarFp.updatePassword(uid, updatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * オペレーターによるQualifiedランク強制変更
         * @summary Qualifiedランク強制変更
         * @param {string} [uid] 会員ID
         * @param {number} [qualifiedRank] Qualifiedランク
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQualifiedRankForce(uid?: string, qualifiedRank?: number, options?: any): AxiosPromise<UpdateQualifiedRankForce200Response> {
            return localVarFp.updateQualifiedRankForce(uid, qualifiedRank, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザの店舗情報を更新する。
         * @summary 運営店舗情報更新
         * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStores(memberStoreRequest: MemberStoreRequest, options?: any): AxiosPromise<MemberStoreResponse> {
            return localVarFp.updateStores(memberStoreRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Admin Get a Member
     * @param {number} userId 会員Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public adminGetMember(userId: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).adminGetMember(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのメールアドレスを変更確認と反映を行う
     * @summary メールアドレス変更確認
     * @param {string} passphrase パスフレーズ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public confirmEmail(passphrase: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).confirmEmail(passphrase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員情報を登録する。 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_I001Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I002Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_I005Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary 会員本登録
     * @param {number} tempId 会員仮登録ID
     * @param {CreateUserRequest} [createUserRequest] 本登録リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createUser(tempId: number, createUserRequest?: CreateUserRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).createUser(tempId, createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員の退会処理を行う
     * @summary 退会
     * @param {string} [uid] 会員ID
     * @param {DeleteUserRequest} [deleteUserRequest] 退会リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(uid?: string, deleteUserRequest?: DeleteUserRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUser(uid, deleteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザの情報を取得する。
     * @summary 会員情報取得
     * @param {string} [uid] 会員ID
     * @param {boolean} [checkFeatureNotiVersion] 機能通知バージョン確認
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getMember(uid?: string, checkFeatureNotiVersion?: boolean, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getMember(uid, checkFeatureNotiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 電話番号と一致する会員を取得する。
     * @summary LINE IDを紐付けるために、入力された電話番号と一致する会員を取得する。
     * @param {string} [phoneNumber] 電話番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getMemberByPhoneNumber(phoneNumber?: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getMemberByPhoneNumber(phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員情報CSVを取得する。
     * @summary 会員一覧CSV取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getMemberListCsvForAdmin(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getMemberListCsvForAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件に一致する会員情報を取得する。 name には、ニックネーム、姓名（連結）、姓名カナ（連結）を指定できる。
     * @summary 会員一覧取得
     * @param {number} [memberId] 会員ID
     * @param {number} [repConsultantId] 担当コンサルタントID
     * @param {string} [emailAddress] メールアドレス
     * @param {string} [name] ニックネーム、姓名（連結）、姓名カナ（連結）
     * @param {number} [qualifiedRank] Qualifiedランク
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getMemberListForAdmin(memberId?: number, repConsultantId?: number, emailAddress?: string, name?: string, qualifiedRank?: number, page?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getMemberListForAdmin(memberId, repConsultantId, emailAddress, name, qualifiedRank, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件 (cognito_user_pool_id) に一致するユーザのロールを取得する。
     * @summary ロール取得
     * @param {string} [uid] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getRole(uid?: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getRole(uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザの店舗情報を取得する。
     * @summary 運営店舗情報取得
     * @param {number} [memberId] 会員ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getStores(memberId?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getStores(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メールアドレスが登録済みか確認する
     * @summary メールアドレス登録済みチェック
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public isRegisteredEmail(email: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).isRegisteredEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メルマガの登録を解除する。
     * @summary メルマガ登録解除
     * @param {string} token メルマガ登録解除用トークン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserUnsubscribe(token: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserUnsubscribe(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 該当のユーザーにLINE IDを登録する
     * @summary 会員情報にLINE IDを登録する
     * @param {RegisterLineMessagingIdRequest} registerLineMessagingIdRequest LINE連携リクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public registerLineMessagingId(registerLineMessagingIdRequest: RegisterLineMessagingIdRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).registerLineMessagingId(registerLineMessagingIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのメールアドレスを変更する
     * @summary メールアドレス変更
     * @param {string} [uid] 会員ID
     * @param {UpdateEmailRequest} [updateEmailRequest] メールアドレス変更リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateEmail(uid?: string, updateEmailRequest?: UpdateEmailRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateEmail(uid, updateEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザーのメール配信同意設定を更新します
     * @summary メール配信同意設定の更新
     * @param {boolean} isAgreed メール配信に同意するかどうか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateMailLetter(isAgreed: boolean, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateMailLetter(isAgreed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 会員情報の更新を行う。
     * @summary 会員情報変更
     * @param {string} [uid] 会員ID
     * @param {UpdateMemberRequest} [updateMemberRequest] 会員情報変更リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateMember(uid?: string, updateMemberRequest?: UpdateMemberRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateMember(uid, updateMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザのパスワードを変更する
     * @summary パスワード変更
     * @param {string} [uid] 会員ID
     * @param {UpdatePasswordRequest} [updatePasswordRequest] パスワード変更リクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updatePassword(uid?: string, updatePasswordRequest?: UpdatePasswordRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updatePassword(uid, updatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * オペレーターによるQualifiedランク強制変更
     * @summary Qualifiedランク強制変更
     * @param {string} [uid] 会員ID
     * @param {number} [qualifiedRank] Qualifiedランク
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateQualifiedRankForce(uid?: string, qualifiedRank?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateQualifiedRankForce(uid, qualifiedRank, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザの店舗情報を更新する。
     * @summary 運営店舗情報更新
     * @param {MemberStoreRequest} memberStoreRequest 更新リクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateStores(memberStoreRequest: MemberStoreRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateStores(memberStoreRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VerifyApi - axios parameter creator
 * @export
 */
export const VerifyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary メール認証
         * @param {string} code 認証コード
         * @param {string} [emailAddress] メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (code: string, emailAddress?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyEmail', 'code', code)
            const localVarPath = `/registration/verify_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailAddress !== undefined) {
                localVarQueryParameter['email_address'] = emailAddress;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerifyApi - functional programming interface
 * @export
 */
export const VerifyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerifyApiAxiosParamCreator(configuration)
    return {
        /**
         * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary メール認証
         * @param {string} code 認証コード
         * @param {string} [emailAddress] メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(code: string, emailAddress?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(code, emailAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VerifyApi - factory interface
 * @export
 */
export const VerifyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerifyApiFp(configuration)
    return {
        /**
         * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
         * @summary メール認証
         * @param {string} code 認証コード
         * @param {string} [emailAddress] メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(code: string, emailAddress?: string, options?: any): AxiosPromise<VerifyEmail200Response> {
            return localVarFp.verifyEmail(code, emailAddress, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerifyApi - object-oriented interface
 * @export
 * @class VerifyApi
 * @extends {BaseAPI}
 */
export class VerifyApi extends BaseAPI {
    /**
     * メール認証を実行する 下記コンポーネント定義についてはAPI設計書_共通.xlsxも参照してください。 * #/components/schemas/E_C003Response   * エラーレスポンスシート   * メッセージ一覧シート * #/components/schemas/E_C005Response   * エラーレスポンスシート   * メッセージ一覧シート
     * @summary メール認証
     * @param {string} code 認証コード
     * @param {string} [emailAddress] メールアドレス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyApi
     */
    public verifyEmail(code: string, emailAddress?: string, options?: AxiosRequestConfig) {
        return VerifyApiFp(this.configuration).verifyEmail(code, emailAddress, options).then((request) => request(this.axios, this.basePath));
    }
}



